import { compressImage, analyzeImageSafety } from './utils/mediaUtils';
import { Camera as CapacitorCamera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { App as CapApp } from '@capacitor/app';
import { Geolocation } from '@capacitor/geolocation';
import React, { useEffect, useState, useCallback, createContext, useContext,useRef,useMemo } from 'react'; 
import { 
    BrowserRouter,
    Routes,
    useParams, 
    useSearchParams,
    Route, 
    Link, 
    useNavigate, 
    useLocation,
    Navigate 
} from 'react-router-dom';
import MarkerClusterGroup from 'react-leaflet-cluster';


import { motion, useMotionValue, useTransform , animate} from 'framer-motion';
import { 
    onAuthStateChanged, 
    signOut, 
    updateProfile, 
    updateEmail,
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword,
    EmailAuthProvider,
    linkWithCredential
} from 'firebase/auth';


import { 
    collection, 
    onSnapshot, 
    query, 
    orderBy, 
    addDoc, 
    serverTimestamp,
    where,
    updateDoc, 
    deleteDoc,
    getDoc,
    getDocs, 
    writeBatch,
    limit, 
    collectionGroup,
    startAfter,  
    doc,
    arrayUnion,    // ⭐ Add this
    arrayRemove,
    Timestamp,
    setDoc,
    increment,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import {Heart,Download,Pin, Check, CheckCheck, Zap, Reply, CheckCircle, XCircle,Image as ImageIcon, Mic, Square, Loader, TrendingUp, Star, ChevronRight} from 'lucide-react';

// ===============================================================
// CRITICAL FIX: i18n IMPORTS MUST BE PRESENT AT THE TOP OF THE FILE
// ===============================================================
import i18n from 'i18next'; // Fix for 'i18n is not defined'
import { initReactI18next, useTranslation } from 'react-i18next'; // Fix for 'initReactI18next' and 'useTranslation'
import LanguageDetector from 'i18next-browser-languagedetector'; // Fix for 'LanguageDetector'
// ICON IMPORTS (using lucide-react)
import { 
    Plus, MessageSquare,
    Loader2, ChevronLeft, Send, 
    ListOrdered, LogOut, Settings, 
    Home,Volume2,Camera ,ThumbsUp, Tag, Info,Navigation, Trash2,Store, MessageCircle,Image, User,Share,MoreVertical,Eye ,ArrowLeft,Bell, Bookmark, X, Search, Clock, ArrowUpLeft
} from 'lucide-react';

import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap,useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { getStorage,uploadString, ref as storageRef,ref,uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { initializeApp } from "firebase/app";
import { getAuth,sendPasswordResetEmail } from "firebase/auth"; 
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken } from "firebase/messaging";


// --- FIREBASE CONFIGURATION ---
const firebaseConfig = {
    apiKey: "AIzaSyA95ygmME1kz5WjSAGzYQtM3pNWbVOowkY", 
    authDomain: "buja-market-app-d1ca9.firebaseapp.com",
    projectId: "buja-market-app-d1ca9",
    storageBucket: "buja-market-app-d1ca9.firebasestorage.app",
    messagingSenderId: "981149490628",
    appId: "1:981149490628:web:c2b8bb91fd2aca6c4c5891",
    measurementId: "G-GJ3FTBKPVX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
const storage = getStorage(app);

// --- CRITICAL GLOBAL VARIABLE DEFINITIONS ---
const appId = (typeof window !== 'undefined' && typeof window.__app_id !== 'undefined') 
    ? window.__app_id 
    : 'default-app-id';

const initialAuthToken = (typeof window !== 'undefined' && typeof window.__initial_auth_token !== 'undefined') 
    ? window.__initial_auth_token 
    : null;

const appInitialized = true;



const registerPushNotification = async (userId, app, db) => {
    try {
        // 1. Get the messaging instance
        const messaging = getMessaging(app);
        
        // 2. Wait for the Service Worker in /public/firebase-messaging-sw.js
        const registration = await navigator.serviceWorker.ready;

        // 3. Use the EXACT key from your "Certificats Web push" screenshot
        const token = await getToken(messaging, { 
            vapidKey: "BO7lTm9ZIfmUQUUkHxj1nPB6NlT9icH8e4A6LrOI9XuNu25aw-7mC7rU8D8kOI263Em5COqetv27reR_rjrLZ_s",
            serviceWorkerRegistration: registration
        });

        if (token) {
            // 4. Save to the top-level 'users' collection seen in your screenshot
            const userDocRef = doc(db, 'users', userId);
            
            await setDoc(userDocRef, { 
                pushToken: token,
                lastTokenUpdate: serverTimestamp() 
            }, { merge: true });
            
            console.log("🚀 SUCCESS: Token saved to Firestore!");
        }
    } catch (err) {
        console.error("❌ Token Fetch Error:", err);
    }
};
const VAPID_KEY = "BO7lTm9ZIfmUQUUkHxj1nPB6NlT9icH8e4A6LrOI9XuNu25aw-7mC7rU8D8kOI263Em5COqetv27reR_rjrLZ_s";

const NotificationService = {
  /**
   * Sets up FCM, requests permission, and syncs the push token to Firestore.
   * Returns true if successful, allowing the UI to show the ✅ checkmark.
   */
  async setup(user, db, app, appId) {
    try {
      if (!user || !db || !appId) {
        console.error("❌ Notification setup failed: Missing user, db, or appId");
        return false;
      }

      // 1. Request Native Smartphone Permission
      let permStatus = await PushNotifications.checkPermissions();
      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        console.warn("⚠️ Native Push permission denied by user.");
        return false;
      }

      // Clear old listeners so they don't duplicate on page reloads
      await PushNotifications.removeAllListeners();

      // 2. Listen for the Native Token and Save to Firestore
      PushNotifications.addListener('registration', async (token) => {
        console.log('🚀 Native Push Token Received: ', token.value);
        
        const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
        await setDoc(userRef, {
          pushToken: token.value,
          lastTokenUpdate: serverTimestamp()
        }, { merge: true });

        console.log("🚀 ✅ Native Push Token Synced to Firestore!");
      });

      // 3. Handle Notification Clicks (When app is in background)
      PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        const data = notification.notification.data;
        if (data && data.link) {
          window.location.href = data.link; // Redirect to the chat/product
        }
      });

      // 4. Trigger the actual registration with Google FCM
      await PushNotifications.register();

      return true; // Triggers the ✅ checkmark in your UI
    } catch (err) {
      console.error("❌ Native FCM Setup error:", err);
      return false;
    }
  },

  
   
  async sendMessage(db, appId, chatId, pushText, senderName, recipientId) {
    return this.saveNotification(
      db,
      appId,
      recipientId,
      null, // senderId
      'message',
      { title: senderName, msg: pushText },
      `/messages/${chatId}`
    );
  },

  /**
   * Manually saves a notification document to Firestore.
   * Note: With the new Cloud Function, simply sending a message 
   * in a chat will now trigger a notification automatically.
   */
  async saveNotification(db, appId, recipientId, senderId, type, content, link) {
    try {
      const notifPath = `artifacts/${appId}/notifications`;

      await addDoc(collection(db, notifPath), {
        recipientId,
        senderId,
        type,
        title: content.title || 'Madili Market',
        message: content.msg || content.text || '',
        link: link || '',
        seen: false,
        createdAt: serverTimestamp()
      });
      
      console.log(`📡 Notification record created at ${notifPath}`);
    } catch (e) {
      console.error("❌ Error saving notification:", e);
    }
  }
};

const AuthPage = ({ t, i18n, auth, db }) => { 
    // State from your original code
    const [email, setEmail] = useState('');
    const navigate = useNavigate(); // Add this line
    const [password, setPassword] = useState('');
    const [nickname, setNickname] = useState(''); 
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [isLoginView, setIsLoginView] = useState(true); 
    const [authMode, setAuthMode] = useState('login'); 

    

// 🔔 NOTIFICATION ENGINE: Triggered on Login/Signup
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user && db && app) {
                // Pass 'app' so getMessaging(app) works inside the service
                NotificationService.setup(user, db, app);
            }
        });
        return () => unsubscribe();
    }, [auth, db, app]);

// 🟢 NEW: Bulletproof Invisible IP Geolocation Tracker
    const captureBackgroundLocation = async (userUid) => {
        // 1. 🟢 GUARANTEED UNLOCK: Ensures the slider unlocks instantly
        localStorage.setItem('is_visitor_mode', 'false');

        try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            
            const detectedCountry = data.country_name || "Burundi";
            const approxLat = data.latitude;
            const approxLon = data.longitude;

            // Save to LocalStorage so the Feed immediately filters correctly
            localStorage.setItem('user_country', detectedCountry);
            localStorage.setItem('device_lat', approxLat);
            localStorage.setItem('device_lon', approxLon);

            // 2. Silently update their Firebase profile (Leaves their custom radius exactly as they left it!)
            if (userUid && db) {
                const userPath = typeof appId !== 'undefined' ? `artifacts/${appId}/users` : 'users';
                await setDoc(doc(db, userPath, userUid), { 
                    country: detectedCountry,
                    backgroundLocation: { lat: approxLat, lon: approxLon },
                    lastLogin: serverTimestamp()
                }, { merge: true });
            }
        } catch (error) {
            console.log("Background location skipped (AdBlocker or Privacy Shield active)", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
           if (isLoginView) {
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                
                // 🟢 1. Secretly capture location on Login
                await captureBackgroundLocation(userCredential.user.uid);

                // 🟢 FIXED: Ask for notification permissions exactly when they click Sign In!
                if ('Notification' in window) Notification.requestPermission();
                navigate('/'); // Redirect to Homepage/Listings after login
            } else {
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                await updateProfile(user, {
                    displayName: nickname.trim()
                });

             if (db) {
                    // Ensure it saves to the correct unified path
                    const userPath = typeof appId !== 'undefined' ? `artifacts/${appId}/users` : 'users';
                    await setDoc(doc(db, userPath, user.uid), {
                        nickname: nickname.trim(),
                        email: email,
                        photoURL: "",
                        createdAt: serverTimestamp()
                    });
                }

                // 🟢 2. Secretly capture location on Sign Up
                await captureBackgroundLocation(user.uid);

                // 🟢 FIXED: Ask for notification permissions exactly when they click Sign Up!
                if ('Notification' in window) Notification.requestPermission();
                navigate('/');

            }
        } catch (err) {
            console.error("Auth error:", err);
            setError(t('auth.error_login') || `Authentication Failed: ${err.message}`); 
            setLoading(false); 
        }
    };


    const toggleView = () => {
        setIsLoginView(!isLoginView);
        setAuthMode(!isLoginView ? 'login' : 'signup');
        setError('');
    };
    
    const setResetMode = () => setAuthMode('reset');

    const renderAuthForm = () => {
        if (authMode === 'reset') {
            return (
                <PasswordResetComponent 
                    t={t} 
                    auth={auth} 
                    onBackToLogin={() => setAuthMode(isLoginView ? 'login' : 'signup')} 
                />
            );
        }

        return (
            <div className="max-w-md mx-auto p-6 bg-white shadow-lg rounded-xl">
                <h2 className="text-2xl font-bold mb-6 text-center text-orange-600">
                    {isLoginView ? (t('auth.signin_title') || 'Sign In') : (t('auth.signup_title') || 'Create Account')}
                </h2>

                {error && <p className="text-red-500 text-center mb-4 p-2 border border-red-200 bg-red-50 rounded text-sm">{error}</p>}

                <form onSubmit={handleSubmit}>
                    {!isLoginView && (
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                {t('auth.nickname_label') || 'Surnom (Nickname)'}
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 focus:ring-2 focus:ring-orange-300 outline-none"
                                type="text"
                                value={nickname}
                                onChange={(e) => setNickname(e.target.value)}
                                placeholder="Ex: Joseph14"
                                required={!isLoginView}
                                disabled={loading}
                            />
                        </div>
                    )}

                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                            {t('auth.email_label') || 'Email'}
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700"
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={t('auth.email_placeholder') || "Email Address"}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            {t('auth.password_label') || 'Password'}
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 mb-3"
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('auth.password_placeholder') || "******"}
                            required
                            disabled={loading}
                        />
                        
                        {isLoginView && (
                            <div className="flex justify-end text-sm">
                                <button 
                                    type="button" 
                                    onClick={setResetMode}
                                    className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
                                    disabled={loading}
                                >
                                    {t('auth.forgot_password') || 'Forgot Password?'}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="flex items-center justify-between">
                        <button
                            className="w-full bg-orange-500 hover:bg-orange-700 text-white font-bold py-3 px-4 rounded transition duration-150 disabled:bg-gray-400"
                            type="submit"
                            disabled={loading}
                        >
                            {loading 
                                ? (t('common.loading') || 'Processing...') 
                                : (isLoginView ? (t('auth.signin_button') || 'Sign In') : (t('auth.signup_button') || 'Sign Up'))}
                        </button>
                    </div>
                </form>

                <div className="text-center mt-4">
                    <button 
                        onClick={toggleView}
                        className="text-sm text-blue-500 hover:text-blue-800"
                        disabled={loading}
                    >
                        {isLoginView 
                            ? (t('auth.need_account') || "Don't have an account? Sign Up") 
                            : (t('auth.have_account') || "Already have an account? Login")}
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            {renderAuthForm()}
        </div>
    );
};

// RESTORED: Your exact PasswordResetComponent
const PasswordResetComponent = ({ t, auth, onBackToLogin }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        if (!email) {
            setError(t('reset.email_required') || 'Please enter your email address.');
            setLoading(false);
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);

            setMessage(
                t('reset.success_message') || 
                'If an account exists for that email, a password reset link has been sent to your inbox. Check your email to proceed.'
            );
            setEmail('');

        } catch (err) {
            console.error("Password reset error:", err);
            
            let displayError = t('reset.generic_error') || 'Failed to send password reset email.';

            if (err.code === 'auth/user-not-found') {
                setMessage(t('reset.user_not_found_safe') || 'If that email is registered, you will receive a reset link shortly.');
                setError('');
                setEmail('');
            } else if (err.code === 'auth/invalid-email') {
                displayError = t('reset.invalid_email') || 'The email address is not valid.';
                setError(displayError);
            } else {
                setError(displayError);
            }
        } finally {
            setLoading(false);
        }
    };

    if (message) {
        return (
            <div className="max-w-md mx-auto p-6 bg-white shadow-lg rounded-xl text-center">
                <h2 className="text-2xl font-bold mb-6 text-green-600">
                    {t('reset.check_email') || 'Success!'}
                </h2>
                <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6" role="alert">
                    <p className='text-sm'>{message}</p>
                </div>
                <button
                    onClick={onBackToLogin}
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded transition duration-150"
                >
                    {t('auth.signin_button') || 'Back to Login'}
                </button>
            </div>
        );
    }
    
    return (
        <div className="max-w-md mx-auto p-6 bg-white shadow-lg rounded-xl">
            <h2 className="text-2xl font-bold mb-6 text-center text-orange-600">
                {t('reset.title') || 'Account Recovery'}
            </h2>

            {error && (
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                    <p className="font-bold">{t('reset.error_title') || 'Error'}</p>
                    <p className='text-sm'>{error}</p>
                </div>
            )}

            <form onSubmit={handlePasswordReset}>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                        {t('reset.email_label') || 'Enter your registered email address:'}
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-orange-500"
                        id="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={t('reset.email_placeholder') || "Email Address"}
                        disabled={loading} 
                    />
                </div>

                <div className="flex items-center justify-between">
                    <button
                        className="w-full bg-orange-500 hover:bg-orange-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150 disabled:bg-gray-400"
                        type="submit"
                        disabled={loading || !email}
                    >
                        {loading 
                            ? (t('reset.loading') || 'Sending...') 
                            : (t('reset.button') || 'Send Reset Link')}
                    </button>
                </div>
            </form>

            <p className="text-center text-gray-500 text-xs mt-4">
                {t('reset.instruction') || 'You will receive an email with a link to set a new password.'}
            </p>
            
            <div className="text-center mt-4">
                <button 
                    onClick={onBackToLogin}
                    className="text-sm text-blue-500 hover:text-blue-800"
                    disabled={loading}
                >
                    {t('auth.have_account') || "Already have an account? Login"}
                </button>
            </div>
        </div>
    );
};
// ** CORE APPLICATION COMPONENTS (Mostly unchanged, but reliant on a real 'user') **
// -----------------------------------------------------------------------------------

const BottomNavBar = ({ user, db, appId }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [totalUnread, setTotalUnread] = useState(0);

    // ⭐ EFFECT: Track Unread Messages
    useEffect(() => {
        if (!user || !db || !appId) return;

        const q = query(
            collection(db, `artifacts/${appId}/chats`),
            where('participants', 'array-contains', user.uid)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            let count = 0;
            snapshot.docs.forEach(doc => {
                const data = doc.data();
                // Only count if the last message wasn't from us and there are unread items
                if (data.lastSenderId !== user.uid && data.unreadCount > 0) {
                    count += data.unreadCount;
                }
            });
            setTotalUnread(count);
        }, (error) => {
            console.error("Error fetching global unread count:", error);
        });

        return () => unsubscribe();
    }, [user, db, appId]);

    // ⭐ HIDE LOGIC
    const isChatWindow = location.pathname.includes('/messages/') && location.pathname !== '/messages';
    const shouldHide = location.pathname.startsWith('/product/') || isChatWindow;

    if (shouldHide) return null; 

    const navItems = [
        { path: '/', name: 'Home', icon: Home },          
        { path: '/messages', name: 'Messages', icon: MessageCircle, hasBadge: true }, 
        { path: '/add-listing', name: 'Add', isCenter: true },             
        { path: '/my-shop', name: 'My Shop', icon: Store, isMyShop: true },     
        { path: '/profile', name: 'Profile', icon: User },        
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 h-16 bg-white border-t border-gray-200 shadow-xl z-50">
            <div className="flex justify-around h-full">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path || (item.isMyShop && location.pathname.startsWith('/my-shop'));
                    
                    if (item.isCenter) {
                        return (
                            <div key="center-add" className="flex justify-center items-center -mt-6">
                                <button
                                    onClick={() => navigate(item.path)}
                                    className="w-14 h-14 bg-orange-500 text-white rounded-full flex items-center justify-center text-3xl font-bold shadow-2xl transition-transform active:scale-90"
                                >
                                    +
                                </button>
                            </div>
                        );
                    }

                    const Icon = item.icon;
                    return (
                        <Link 
                            key={item.path} 
                            to={item.path} 
                            className={`flex flex-col items-center justify-center p-2 text-[11px] font-bold transition-colors relative min-w-[64px] ${
                                isActive ? 'text-orange-500' : 'text-gray-400'
                            }`}
                        >
                            <div className="relative">
                                <Icon size={24} className="mb-0.5" />
                                
                                {/* ⭐ UNREAD BADGE WITH 9+ LOGIC */}
                                {item.hasBadge && totalUnread > 0 && (
                                    <span className="absolute -top-1.5 -right-2 bg-red-600 text-white text-[10px] min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full border-2 border-white font-black shadow-sm">
                                        {totalUnread > 9 ? '9+' : totalUnread}
                                    </span>
                                )}
                            </div>
                            {item.name}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};


const NotificationPage = ({ user, db, appId, t }) => {
    const [notifications, setNotifications] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user || !db) return;

        const q = query(
            collection(db, `artifacts/${appId}/notifications`),
            where('recipientId', '==', user.uid),
            orderBy('createdAt', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snap) => {
            setNotifications(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        }, (err) => console.error("Notif Feed Error:", err));

        return () => unsubscribe();
    }, [user, db, appId]);

    const markAllAsRead = async () => {
        if (notifications.length === 0) return;
        const batch = writeBatch(db);
        notifications.filter(n => !n.seen).forEach(n => {
            const ref = doc(db, `artifacts/${appId}/notifications`, n.id);
            batch.update(ref, { seen: true });
        });
        try {
            await batch.commit();
        } catch (e) { console.error("Batch update failed", e); }
    };

  const handleNotifClick = async (notif) => {
        if (!notif.seen) {
            try {
                await updateDoc(doc(db, `artifacts/${appId}/notifications`, notif.id), { seen: true });
            } catch (e) { console.error(e); }
        }

        // 1. Chat notifications
        if (notif.type === 'chat_start' || notif.type === 'chat_interest' || notif.type === 'message') {
            navigate(notif.link.startsWith('/') ? notif.link : `/${notif.link}`);
            return;
        }

        // 2. THE GHOST BUSTER: If the link contains 'my-shop', force it to the shop, ignoring the bad ID
        if (notif.link && notif.link.includes('my-shop')) {
            navigate('/my-shop');
            return;
        }

        // 3. Extract ID safely
        let finalId = notif.productId;
        if (!finalId && notif.link) {
            if (notif.link.includes('id=')) {
                finalId = notif.link.split('id=')[1].split('&')[0];
            } else {
                finalId = notif.link.split('?')[0].split('/').filter(Boolean).pop();
            }
        }

        // 4. Navigate securely
        if (finalId && finalId !== 'product' && finalId !== 'my-shop') {
            navigate(`/product/${finalId}`);
        } else {
            navigate('/');
        }
    };


    // Updated to use ThumbsUp
    const getIcon = (type) => {
        switch (type) {
            case 'like': 
                return <ThumbsUp className="text-blue-500 fill-blue-500" size={20} />;
            case 'price_drop': 
                return <Tag className="text-green-500" size={20} />;
            case 'chat_start': 
                return <MessageCircle className="text-orange-500" size={20} />;
            default: 
                return <Info className="text-blue-500" size={20} />;
        }
    };

    return (
        <div className="max-w-md mx-auto bg-white min-h-screen pb-20 shadow-lg">
            <div className="flex items-center justify-between p-4 border-b bg-white sticky top-0 z-50">
                <div className="flex items-center gap-3">
                    <button onClick={() => navigate(-1)} className="p-1 active:scale-90 transition-transform">
                        <ChevronLeft size={24} />
                    </button>
                    <h1 className="text-xl font-bold text-gray-900">
                        {t('notifications.title')}
                    </h1>
                </div>
                {notifications.some(n => !n.seen) && (
                    <button onClick={markAllAsRead} className="text-orange-500 text-xs font-bold flex items-center gap-1 active:opacity-70">
                        <CheckCheck size={16} /> 
                        {t('notifications.mark_all_read')}
                    </button>
                )}
            </div>

            {notifications.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-32 text-gray-400">
                    <div className="bg-gray-50 p-6 rounded-full mb-4">
                        <Bell size={48} className="opacity-20" />
                    </div>
                    <p className="font-medium">{t('notifications.no_activity')}</p>
                    <p className="text-xs">{t('notifications.no_activity_sub')}</p>
                </div>
            ) : (
                <div className="flex flex-col">
                    {notifications.map(n => (
                        <div 
                            key={n.id} 
                            onClick={() => handleNotifClick(n)}
                            className={`p-4 border-b flex gap-4 cursor-pointer transition-all active:bg-gray-100 ${n.seen ? 'bg-white' : 'bg-orange-50/60'}`}
                        >
                            <div className="mt-1 flex-shrink-0">{getIcon(n.type)}</div>
                            
   <div className="flex-1 min-w-0 flex flex-col justify-center">
                                <div className="flex flex-row flex-wrap items-baseline gap-1 text-[14px] leading-tight">
                                    <span className={`font-bold mr-1 ${n.seen ? 'text-gray-600' : 'text-gray-900'}`}>{n.senderName || 'User'}</span>
                                    <span className={`${n.seen ? 'text-gray-600' : 'text-gray-900'}`}>
                                        {n.type === 'chat_start' || n.type === 'message' ? ':' : ''} 
                                        <span className="ml-1">
                                            {n.message === 'notifications.chat_interest_msg' 
                                                ? 'is interested in your product!' 
                                                : t(n.message, { defaultValue: n.message, item: n.productName || "" })}
                                        </span>
                                    </span>
                                </div>
    <p className="text-[10px] text-gray-400 mt-1 font-medium">
        {n.createdAt?.toDate 
            ? n.createdAt.toDate().toLocaleDateString() + ' ' + n.createdAt.toDate().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
            : t('notifications.just_now')}
    </p>
</div>

                            {n.image && (
                                <div className="w-12 h-12 rounded-lg bg-gray-100 overflow-hidden flex-shrink-0 border">
                                    <img src={n.image} className="w-full h-full object-cover" alt="" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
// ====================================================================
// i18n CONFIGURATION (MOVED FROM i18n.js)
// ====================================================================


// --- i18N SETUP (TRANSLATION RESOURCES) ---
const resources = {
    en: {
        translation: {
            app_title: 'Madili Market',
            home: 'Home',
            shop: 'My Shop',
            messages: 'Messages',
            add_listing: 'New Listing',
            search: 'Search',
            all: 'All',
            smartphones: 'Smartphones',
            used_cars: 'Used Cars',
            electronics: 'Electronics',
            fashion: 'Fashion',
            properties: 'Properties',
            jobs: 'Jobs',
            food: 'Food',
            others: 'Others',
            Authenticating: 'Authenticating...',
            Loading: 'Loading...',
            Authenticating_and_Loading_Listings: 'Authenticating and Loading Listings...',
            Operation_Failed: 'Operation Failed',
            Close: 'Close',
            Listing_Detail_Missing: 'Listing Detail Missing',
            Unknown_Item: 'Unknown Item',
            No_listings_found_for_the_selected_category: 'No listings found for the selected category.',
            Please_sign_in_to_view_all_available_products: 'Please sign in to view all available products.',
            You_must_be_logged_in_and_the_database_must_be_available_to_start_a_chat: 'You must be logged in and the database must be available to start a chat.',
            This_is_your_listing_You_cannot_start_a_chat_with_yourself_Manage_it_in_My_Shop: "This is your listing. You cannot start a chat with yourself. Manage it in 'My Shop'!",
        },
    },
    sw: {
        translation: {
            app_title: 'Soko la Madili',
            home: 'Nyumbani',
            shop: 'Duka Langu',
            messages: 'Ujumbe',
            add_listing: 'Tangazo Jipya',
            search: 'Tafuta',
            all: 'Zote',
            smartphones: 'Simu',
            used_cars: 'Magari Yaliyotumika',
            electronics: 'Vifaa vya Kielektroniki',
            fashion: 'Mitindo',
            properties: 'Mali',
            jobs: 'Kazi',
            food: 'Chakula',
            others: 'Mengineyo',
            Authenticating: 'Inathibitisha...',
            Loading: 'Inapakia...',
            Authenticating_and_Loading_Listings: 'Inathibitisha na Kupakia Matangazo...',
            Operation_Failed: 'Operesheni Imeshindikana',
            Close: 'Funga',
            Listing_Detail_Missing: 'Maelezo ya Tangazo Yanapotea',
            Unknown_Item: 'Bidhaa Isiyojulikana',
            No_listings_found_for_the_selected_category: 'Hakuna matangazo yaliyopatikana kwa kategoria iliyochaguliwa.',
            Please_sign_in_to_view_all_available_products: 'Tafadhali ingia ili kuona bidhaa zote zinazopatikana.',
            You_must_be_logged_in_and_the_database_must_be_available_to_start_a_chat: 'Lazima uingie na hifadhidata ipatikane ili kuanzisha soga.',
            This_is_your_listing_You_cannot_start_a_chat_with_yourself_Manage_it_in_My_Shop: "Hili ni tangazo lako. Huwezi kuanzisha soga na wewe mwenyewe. Simamia katika 'Duka Langu'!",
        },
    },
    fr: {
        translation: {
            app_title: 'Marché de Madili',
            home: 'Accueil',
            shop: 'Ma Boutique',
            messages: 'Messages',
            add_listing: 'Nouvelle Annonce',
            search: 'Rechercher',
            all: 'Tout',
            smartphones: 'Téléphones',
            used_cars: 'Voitures d’occasion',
            electronics: 'Électronique',
            fashion: 'Mode',
            properties: 'Immobilier',
            jobs: 'Emplois',
            food: 'Aliments',
            others: 'Autres',
            Authenticating: 'Authentification en cours...',
            Loading: 'Chargement en cours...',
            Authenticating_and_Loading_Listings: 'Authentification et chargement des annonces...',
            Operation_Failed: 'Opération Échouée',
            Close: 'Fermer',
            Listing_Detail_Missing: 'Détail de l\'annonce Manquant',
            Unknown_Item: 'Article Inconnu',
            No_listings_found_for_the_selected_category: 'Aucune annonce trouvée pour la catégorie sélectionnée.',
            Please_sign_in_to_view_all_available_products: 'Veuillez vous connecter pour voir tous les produits disponibles.',
            You_must_be_logged_in_and_the_database_must_be_available_to_start_a_chat: 'Vous devez être connecté et la base de données doit être disponible pour démarrer un chat.',
            This_is_your_listing_You_cannot_start_a_chat_with_yourself_Manage_it_in_My_Shop: "Ceci est votre annonce. Vous ne pouvez pas démarrer de chat avec vous-même. Gérez-le dans 'Ma Boutique'!",
        },
    },
    run: { // Kirundi/Rundi
        translation: {
            app_title: 'Isoko rya Madili',
            home: 'Aho Kwishira',
            shop: 'Iduka Ryawe',
            messages: 'Ubutumwa',
            add_listing: 'Itangazo Rishasha',
            search: 'Ronda',
            all: 'Vyose',
            smartphones: 'Telefoni',
            used_cars: 'Imodoka Zikoreshejwe',
            electronics: 'Ibintu vy’Ubwenge',
            fashion: 'Imideri',
            properties: 'Amazu',
            jobs: 'Akazi',
            food: 'Ibiribwa',
            others: 'Ibindi',
            Authenticating: 'Gushira Imeza...',
            Loading: 'Gupakira...',
            Authenticating_and_Loading_Listings: 'Gushira Imeza no Gupakira Amazu...',
            Operation_Failed: 'Ikintu Carahagaze',
            Close: 'Funga',
            Listing_Detail_Missing: 'Amakuru Y’Itangazo Yabuze',
            Unknown_Item: 'Ikintu Kitazwi',
            No_listings_found_for_the_selected_category: 'Nta matangazo yabonetse muri ico gice catoranijwe.',
            Please_sign_in_to_view_all_available_products: 'Niwishe Imeza kugira ubone ibicuruzwa vyose bihari.',
            You_must_be_logged_in_and_the_database_must_be_available_to_start_a_chat: 'Utegerezwa kuba waciye mu bwishingizi kandi urutonde rukwiye kuboneka kugira utangure ibiganiro.',
            This_is_your_listing_You_cannot_start_a_chat_with_yourself_Manage_it_in_My_Shop: "Iri ni itangazo ryawe. Ntushobora kwitanguriza ibiganiro. Rigerereze muri 'Iduka Ryawe'!",
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });



// Add these imports to your component file (if not already there)
// import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore'; 
// import { db } from './firebase'; // <-- Your Firestore instance

// --- Component: Three-Dot Action Menu ---
// This is a small, reusable component for the action menu logic
const ListingActionsMenu = ({ listing, onAction, open, setOpen }) => {
    // Define the options based on the current listing status
    const isReserved = listing.status === 'reserved';
    const isSold = listing.status === 'sold';
    
    // Determine the primary actions (Mark as Reserved/Sold, or Unmark)
    const primaryActions = [];
    
    if (isReserved) {
        primaryActions.push({ label: 'Unmark as Reserved', status: 'active' });
        primaryActions.push({ label: 'Mark as Sold', status: 'sold' });
    } else if (isSold) {
        primaryActions.push({ label: 'Unmark as Sold', status: 'active' });
    } else { // status is 'active' or 'all' default
        primaryActions.push({ label: 'Mark as Reserved', status: 'reserved' });
        primaryActions.push({ label: 'Mark as Sold', status: 'sold' });
    }

    const handleMenuClick = (action, status) => {
        setOpen(null); // Close the menu
        if (action === 'edit') {
            onAction('edit', listing.id);
        } else if (action === 'delete') {
            onAction('delete', listing.id);
        } else if (status) {
            onAction('updateStatus', listing.id, status);
        }
    };
    
    // A simple ellipsis icon (you can replace this with a better SVG icon if available)
    const EllipsisIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4z" />
        </svg>
    );

    return (
        <div className="relative z-10">
            <button 
                className="p-1 rounded-full hover:bg-gray-100" 
                onClick={(e) => { 
                    e.stopPropagation(); // Prevents clicks on the menu from affecting the listing card
                    setOpen(open ? null : listing.id); 
                }}
            >
                <EllipsisIcon />
            </button>
            
            {/* Dropdown Menu Modal */}
            {open && (
                <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
                    {/* Status Update Options */}
                    {primaryActions.map(action => (
                        <button
                            key={action.status}
                            onClick={() => handleMenuClick('status', action.status)}
                            className="w-full text-left px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                            {action.label}
                        </button>
                    ))}

                    {/* Separator */}
                    <div className="border-t border-gray-100 my-0"></div>

                    {/* Edit Option (Navigates to Edit Page) */}
                    <button
                        onClick={() => handleMenuClick('edit')}
                        className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        Edit
                    </button>
                    
                    {/* Delete Option (Red for danger) */}
                    <button
                        onClick={() => handleMenuClick('delete')}
                        className="w-full text-left px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors"
                    >
                        Delete
                    </button>
                </div>
            )}
        </div>
    );
};

// Assume these globals are initialized in index.js or App.
const functions = window.functions;
const user = window.user; // Mock user or passed as prop
const APP_ID = 'default-app-id'; 
const LISTINGS_COLLECTION_PATH = `artifacts/${APP_ID}/listings`;

const PromoteListingPage = ({ user }) => {
    const { listingId } = useParams();
    const navigate = useNavigate();
    
    // State for payment process
    const [listing, setListing] = useState(null);
    const [mobileNumber, setMobileNumber] = useState('');
    const [status, setStatus] = useState('idle'); // idle | loading | prompt_sent | success | error
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);

    // 1. Fetch Listing Details
    const fetchListing = useCallback(async () => {
        if (!db || !listingId) return;
        try {
            const docRef = doc(db, LISTINGS_COLLECTION_PATH, listingId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists() && docSnap.data().sellerId === user?.uid) {
                setListing({ id: docSnap.id, ...docSnap.data() });
            } else {
                setError("Listing not found or you don't have permission to promote it.");
            }
        } catch (err) {
            console.error("Error fetching listing:", err);
            setError("Failed to load listing details.");
        }
    }, [listingId, user?.uid]);

    useEffect(() => {
        if (user) {
            fetchListing();
        }
    }, [user, fetchListing]);


    // 2. Poll Firestore for Promotion Status Update
    useEffect(() => {
        if (!db || !listingId || status !== 'prompt_sent') return;

        // Start polling the listing document
        const interval = setInterval(async () => {
            const docRef = doc(db, LISTINGS_COLLECTION_PATH, listingId);
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
                const data = docSnap.data();
                const isPromoted = data.isPromoted;
                const promotionEndTime = data.promotionEndTime;
                
                if (isPromoted && promotionEndTime) {
                    clearInterval(interval);
                    setStatus('success');
                    setMessage(`Success! Your listing is now promoted until ${new Date(promotionEndTime.seconds * 1000).toLocaleString()}.`);
                }
                // We don't handle failure here, as the webhook is server-to-server.
                // The user must check their phone for failure prompt.
            }
        }, 5000); // Check every 5 seconds

        return () => clearInterval(interval);
    }, [status, listingId]);


    // 3. Initiate Payment Function
    const handleInitiatePayment = async (e) => {
        e.preventDefault();
        
        if (!mobileNumber || !user || !functions) {
            setError("Missing data: mobile number or user session is required.");
            return;
        }

        setStatus('loading');
        setError(null);
        setMessage('');

        try {
            // Get the callable function reference
            const initiatePromotionPayment = httpsCallable(functions, 'initiatePromotionPayment');
            
            const response = await initiatePromotionPayment({
                listingId: listingId,
                amount: PROMOTE_COST_BIF,
                userId: user.uid,
                userMobileNumber: mobileNumber,
            });

            if (response.data.success) {
                setStatus('prompt_sent');
                setMessage(response.data.message);
            } else {
                setError(response.data.message || 'Payment initiation failed.');
                setStatus('error');
            }

        } catch (err) {
            console.error('Callable Function Error:', err);
            setError(`Payment processing failed. Please check the network or try again. Error Code: ${err.code}`);
            setStatus('error');
        }
    };

    const StatusIcon = ({ currentStatus }) => {
        switch (currentStatus) {
            case 'loading':
                return <Loader className="w-8 h-8 text-blue-500 animate-spin" />;
            case 'prompt_sent':
                return <Clock className="w-8 h-8 text-yellow-500" />;
            case 'success':
                return <CheckCircle className="w-8 h-8 text-green-500" />;
            case 'error':
                return <XCircle className="w-8 h-8 text-red-500" />;
            default:
                return <Zap className="w-8 h-8 text-orange-500" />;
        }
    };

    if (error) {
        return <div className="p-6 max-w-xl mx-auto text-center text-red-600 font-semibold">{error}</div>;
    }

    if (!listing) {
        return (
            <div className="p-6 max-w-xl mx-auto">
                <div className="flex items-center space-x-2 text-gray-500">
                    <Loader className="w-5 h-5 animate-spin"/>
                    <span>Loading listing...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 mb-20 max-w-xl mx-auto">
            <button 
                onClick={() => navigate('/myshop')} 
                className="flex items-center text-orange-600 hover:text-orange-700 transition-colors mb-6"
            >
                <ChevronLeft className="w-5 h-5 mr-1" />
                Back to My Listings
            </button>

            <h2 className="text-3xl font-extrabold mb-4 text-gray-900 flex items-center">
                <Zap className="w-7 h-7 mr-2 text-orange-600" />
                Promote Listing
            </h2>
            <p className="text-gray-500 mb-6">Boost your visibility and reach more buyers for a small fee.</p>

            {/* Listing Summary */}
            <div className="bg-white p-4 rounded-xl shadow-lg mb-6 border border-orange-200">
                <h3 className="font-bold text-xl text-gray-800 truncate">{listing.title}</h3>
                <p className="text-orange-600 font-semibold mt-1">
                    Price: ₹{listing.price ? listing.price.toLocaleString() : 'N/A'}
                </p>
                <p className="text-sm text-gray-600 mt-2">
                    Promotion Cost: <span className="font-bold text-red-600">{PROMOTE_COST_BIF.toLocaleString()} BIF</span> (24 Hours)
                </p>
                {listing.isPromoted && (
                    <p className="text-sm text-green-600 font-medium mt-2">
                        Currently Promoted: Ends {listing.promotionEndTime ? new Date(listing.promotionEndTime.seconds * 1000).toLocaleString() : 'N/A'}
                    </p>
                )}
            </div>

            {/* Status & Message */}
            {(message || status !== 'idle') && (
                <div className="flex items-start p-4 rounded-xl bg-gray-50 mb-6 border border-gray-200">
                    <StatusIcon currentStatus={status} />
                    <div className="ml-4 flex-1">
                        <p className="font-bold text-gray-800 capitalize">{status.replace('_', ' ')}</p>
                        <p className={`text-sm mt-1 ${status === 'error' ? 'text-red-600' : 'text-gray-600'}`}>
                            {message || (status === 'prompt_sent' 
                                ? 'Waiting for confirmation from your mobile money account. DO NOT close this page.'
                                : 'Please wait while we process your request...')
                            }
                        </p>
                    </div>
                </div>
            )}


            {/* Payment Form */}
            {status !== 'success' && status !== 'loading' && (
                <form onSubmit={handleInitiatePayment} className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
                    <div className="mb-4">
                        <label htmlFor="mobileNumber" className="block text-sm font-medium text-gray-700 mb-2">
                            Mobile Money Number (e.g., 7x xxx xxx)
                        </label>
                        <input
                            id="mobileNumber"
                            type="tel"
                            value={mobileNumber}
                            onChange={(e) => setMobileNumber(e.target.value)}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                            placeholder="Enter your mobile number"
                            required
                            disabled={status === 'prompt_sent'}
                        />
                    </div>
                    
                    <button
                        type="submit"
                        disabled={status === 'loading' || status === 'prompt_sent'}
                        className={`w-full py-3 text-white font-bold rounded-xl shadow-md transition-colors ${
                            status === 'loading'
                                ? 'bg-orange-400 cursor-not-allowed flex items-center justify-center'
                                : status === 'prompt_sent'
                                    ? 'bg-yellow-500 cursor-not-allowed'
                                    : 'bg-orange-600 hover:bg-orange-700'
                        }`}
                    >
                        {status === 'loading' && <Loader className="w-5 h-5 mr-2 animate-spin" />}
                        {status === 'loading' && 'Initiating Payment...'}
                        {status === 'prompt_sent' && 'Prompt Sent - Awaiting Confirmation...'}
                        {status === 'idle' && `Pay ${PROMOTE_COST_BIF.toLocaleString()} BIF to Promote`}
                        {status === 'error' && 'Retry Payment'}
                    </button>
                </form>
            )}
        </div>
    );
};

const PROMOTE_COST_BIF = 1000; // Cost for 24-hour promotion

// --- Mock Payment Function (Simulates the success of the payment webhook) ---
// This is where you would integrate your call to Leapa/serverless function
const mockInitiatePayment = async (listingId, db, LISTINGS_COLLECTION_PATH, userId) => {
    console.log(`[MOCK PAYMENT] Initiating ${PROMOTE_COST_BIF} BIF payment for Listing ID: ${listingId}...`);
    
    // Simulate network delay and payment processing
    await new Promise(resolve => setTimeout(resolve, 1500)); 

    // Update Firestore (This simulates the secure update done by your server/webhook)
    const listingRef = doc(db, LISTINGS_COLLECTION_PATH, listingId);
    
    const promotionEndTime = new Date(Date.now() + 24 * 60 * 60 * 1000); // 24 hours from now

    try {
        await updateDoc(listingRef, {
            isPromoted: true,
            promotionEndTime: promotionEndTime,
            lastPromotedAt: serverTimestamp(),
        });
        console.log(`[MOCK PAYMENT] SUCCESS: Listing ${listingId} promoted.`);
        return { success: true, message: "Listing successfully promoted for 24 hours!" };
    } catch (error) {
        console.error("Error updating promotion status:", error);
        return { success: false, message: "Error: Failed to activate promotion status." };
    }
};


// ⚠️ IMPORTANT: Ensure you pass 'db', 't', and 'i18n' in the props!
// --- Main MyShopPage Component ---
const MyShopPage = ({ user, db, t, i18n,countryName }) => {
    // NOTE: This MUST match the path shown in your Firebase console data tab.
    const appId = 'default-app-id'; 
    const LISTINGS_COLLECTION_PATH = `artifacts/${appId}/listings`; 

    const [activeTab, setActiveTab] = useState('all');
    const navigate = useNavigate();
    const [userListings, setUserListings] = useState([]); 
    const [loading, setLoading] = useState(true);
    // Use t() for initial message state
    const [message, setMessage] = useState(''); 
    const [openMenuId, setOpenMenuId] = useState(null); 
    const location = useLocation(); // ⭐ 1. ADD THIS LINE

  // ⭐ THE FIXED SCROLL LOGIC
    useEffect(() => {
        // 1. If we don't have a target product, jump to top immediately
        if (!location.state?.scrollToProduct) {
            window.scrollTo(0, 0);
            return;
        }

        // 2. FIXED: Use userListings here instead so it doesn't crash!
        if (!loading && userListings.length > 0) {
            setTimeout(() => {
                const targetId = `shop-item-${location.state.scrollToProduct}`;
                const el = document.getElementById(targetId);
                
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    
                    el.classList.add('ring-4', 'ring-orange-400', 'transition-all', 'duration-500');
                    setTimeout(() => el.classList.remove('ring-4', 'ring-orange-400'), 2500);

                    window.history.replaceState({}, document.title);
                }
            }, 500); 
        }
    }, [loading, userListings.length, location.state]); // ⭐ FIXED DEPENDENCY HERE TOO

    // --- 1. DATA FETCHING (useEffect) ---
    useEffect(() => {
        if (!user || !db) return; 

        // Close menu logic setup
        const closeMenu = (e) => {
            // Check if the click occurred outside any listing card or menu
            if (openMenuId && !e.target.closest('.listing-card') && !e.target.closest('.menu-toggle')) {
                setOpenMenuId(null);
            }
        };
        document.addEventListener('click', closeMenu);
        
        // CRITICAL FIX: Query uses 'sellerId' to match existing data
        const q = query(
            collection(db, LISTINGS_COLLECTION_PATH), 
            where('sellerId', '==', user.uid), 
            orderBy('createdAt', 'desc')
        );
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const listingsData = snapshot.docs.map(d => ({ 
                id: d.id, 
                status: d.data().status || 'active', 
                ...d.data() 
            }));
            setUserListings(listingsData);
            setLoading(false);
            if (message.includes('Error')) setMessage('');
        }, (error) => {
            console.error("Error fetching user listings:", error);
            setMessage(t("shop.error_loading")); 
            setLoading(false);
        });

        return () => {
            document.removeEventListener('click', closeMenu);
            unsubscribe();
        }
    }, [user, db, message, openMenuId, LISTINGS_COLLECTION_PATH, t]); 

    // --- 2. ACTION HANDLERS (useCallback) ---

    const handleUpdateStatus = useCallback(async (listingId, newStatus) => {
        if (!user) return;
        setLoading(true);
        setMessage('');

        try {
            const listingRef = doc(db, LISTINGS_COLLECTION_PATH, listingId);
            await updateDoc(listingRef, { 
                status: newStatus,
                lastUpdated: serverTimestamp()
            });
            
            // Use translation with interpolation
            setMessage(t("shop.status_updated", { status: newStatus }));
            setOpenMenuId(null);
        } catch (error) {
            console.error("Error updating status:", error);
            // Use translation with interpolation
            setMessage(t("shop.error_status_update", { status: newStatus }));
        } finally {
            setLoading(false);
            // Clear message after 3 seconds
            setTimeout(() => setMessage(''), 3000); 
        }
    }, [user, db, LISTINGS_COLLECTION_PATH, t]);

    const handleDeleteListing = useCallback(async (listingId) => {
        if (!user) return;
        
        // NOTE: Use translated confirmation text
        if (!window.confirm(t("shop.delete_confirm"))) {
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const listingRef = doc(db, LISTINGS_COLLECTION_PATH, listingId);
            await deleteDoc(listingRef);

            setMessage(t("shop.deleted_success"));
            setOpenMenuId(null);
        } catch (error) {
            console.error("Error deleting listing:", error);
            setMessage(t("shop.error_deleting"));
        } finally {
            setLoading(false);
            setTimeout(() => setMessage(''), 3000);
        }
    }, [user, db, LISTINGS_COLLECTION_PATH, t]);
    
    // Unified Action Handler for the Menu 
    const handleMenuAction = useCallback((action, listingId, newStatus = null) => {
        switch (action) {
            case 'reserve':
            case 'activate': 
            case 'sold':
                handleUpdateStatus(listingId, newStatus);
                break;
            case 'delete':
                handleDeleteListing(listingId);
                break;
            case 'edit':
                navigate(`/edit-listing/${listingId}`); 
                break;
            default:
                break;
        }
    }, [handleUpdateStatus, handleDeleteListing, navigate]);


    // --- 3. DISPLAY LOGIC ---
    const listingsToDisplay = userListings.filter(listing => activeTab === 'all' || listing.status === activeTab);
    
    const getTabClasses = (tab) => (
        `px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
            activeTab === tab 
                ? 'bg-orange-600 text-white shadow-md' 
                : 'text-gray-600 hover:bg-gray-100'
        }`
    );

    const countByStatus = (status) => userListings.filter(l => l.status === status).length;

    if (loading) {
        // Use translated loading text
        return <div className="text-center mt-20 text-lg font-semibold text-gray-600">{t("shop.loading")}</div>;
    }

   // Listing Card Component (Inlined)
    const ListingCard = ({ listing }) => (
        <div 
            key={listing.id} 
            id={`shop-item-${listing.id}`} // ⭐ THIS MUST BE HERE
            className="listing-card flex p-3 bg-white border border-gray-200 rounded-xl shadow-sm mb-4 transition-all duration-500 hover:shadow-lg"
        >
            <img 
    // ⭐ CRITICAL FIX: Robust image source selection
    src={
        (listing.imageUrls && listing.imageUrls.length > 0) 
            ? listing.imageUrls[0]  // 1. Use the FIRST URL from the new imageUrls array
            : listing.imageUrl      // 2. Fallback to the old single imageUrl field
                ? listing.imageUrl
                : "https://placehold.co/100x100/f3f4f6/374151?text=No+Image" // 3. Use placeholder
    } 
    alt={listing.title} 
    className="w-24 h-24 object-cover rounded-lg mr-4"
    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/100x100/f3f4f6/374151?text=No+Image" }}
/>
            <div className="flex-1 min-w-0">
                <h3 className="font-bold text-lg truncate text-gray-800">{listing.title}</h3>
{/* 2. FIXED: Dynamic Currency Logic - Replaced ₹ with formatPrice */}
                <p className="text-orange-600 font-semibold mt-1">
                    {formatPrice(listing.price, countryName)}
                </p>
                {/* Use translated status label */}
                <p className="text-xs text-gray-500 capitalize mt-1">{t("shop.status_label")} <span className={`font-medium ${listing.status === 'active' ? 'text-green-600' : 'text-yellow-600'}`}>{t(`status.${listing.status}`, { defaultValue: listing.status })}</span></p>
                {/* Use translated posted label */}
                <p className="text-xs text-gray-400 mt-0.5">{t("shop.posted_label")} {listing.createdAt ? new Date(listing.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}</p>
            </div>
            
            <div className="relative">
                <button 
                    className="menu-toggle p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors"
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent the main div click handler from closing the menu immediately
                        setOpenMenuId(openMenuId === listing.id ? null : listing.id);
                    }}
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                </button>
                
                {openMenuId === listing.id && (
                    <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-10">
                        
                        {/* OPTIONS FOR ACTIVE STATUS */}
                        {listing.status === 'active' && (
                            <>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('reserve', listing.id, 'reserved')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_reserve")}
                                </button>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('sold', listing.id, 'sold')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_sold")}
                                </button>
                            </>
                        )}
                        
                        {/* OPTIONS FOR RESERVED STATUS */}
                        {listing.status === 'reserved' && (
                            <>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('activate', listing.id, 'active')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_activate")}
                                </button>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('sold', listing.id, 'sold')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_sold")}
                                </button>
                            </>
                        )}

                        {/* OPTIONS FOR SOLD STATUS */}
                        {listing.status === 'sold' && (
                             <>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('activate', listing.id, 'active')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_activate")}
                                </button>
                                {/* Use translated action text */}
                                <button onClick={() => handleMenuAction('reserve', listing.id, 'reserved')} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                    {t("shop.action_reserve")}
                                </button>
                             </>
                        )}

                        {/* EDIT OPTION (Always available) */}
                        <button onClick={() => handleMenuAction('edit', listing.id)} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t border-gray-100">
                             {t("shop.action_edit")}
                        </button>
                        
                        {/* DELETE OPTION (Always available) */}
                        {/* Use translated action text */}
                        <button onClick={() => handleMenuAction('delete', listing.id)} className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-b-lg border-t border-gray-100 mt-1">
                            {t("shop.action_delete")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
    // End Listing Card

    return (
        <div className="p-4 mb-20 max-w-xl mx-auto">
            {/* Use translated title */}
            <h2 className="text-3xl font-extrabold text-center mt-4 mb-6 text-gray-900">{t("shop.title")}</h2>
            
            {/* Message Display Block - No translation needed here, as the message variable is already translated */}
            {message && (
                <div className={`p-3 rounded-xl text-white text-center mb-4 text-sm font-semibold ${message.includes('Error') ? 'bg-red-500' : 'bg-green-500'}`}>
                    {message}
                </div>
            )}
            
            {/* Action Buttons */}
            <div className="flex justify-between space-x-2 mb-6">
                <button 
                    onClick={() => navigate('/add-listing')}
                    className="flex-1 py-3 bg-orange-600 text-white font-bold rounded-xl shadow-lg hover:bg-orange-700 transition-colors"
                >
                    {/* Use translated button text */}
                    {t("shop.button_create")}
                </button>
                <button 
                    onClick={() => { alert(t("shop.value_not_implemented"))}}
                    className="flex-1 py-3 bg-gray-200 text-gray-800 font-bold rounded-xl shadow-lg hover:bg-gray-300 transition-colors"
                >
                    {/* Use translated button text */}
                    {t("shop.button_value")}
                </button>
            </div>
            
            {/* Tab Navigation */}
            <div className="flex justify-around bg-gray-50 p-1 rounded-full mb-6 shadow-inner">
                <button onClick={() => setActiveTab('all')} className={getTabClasses('all')}>
                    {/* Use translated tab text with interpolation */}
                    {t("shop.tab_all", { count: userListings.length })}
                </button>
                <button onClick={() => setActiveTab('active')} className={getTabClasses('active')}>
                    {t("shop.tab_active", { count: countByStatus('active') })}
                </button>
                <button onClick={() => setActiveTab('reserved')} className={getTabClasses('reserved')}>
                    {t("shop.tab_reserved", { count: countByStatus('reserved') })}
                </button>
                <button onClick={() => setActiveTab('sold')} className={getTabClasses('sold')}>
                    {t("shop.tab_sold", { count: countByStatus('sold') })}
                </button>
            </div>

            {/* Listings List */}
            {listingsToDisplay.length > 0 ? (
                <div>
                    {listingsToDisplay.map(listing => <ListingCard key={listing.id} listing={listing} />)}
                </div>
            ) : (
                <div className="text-center p-8 text-gray-500 bg-white rounded-xl shadow-sm mt-8">
                    {/* Use translated text with interpolation */}
                    <p className="text-lg font-semibold">{t("shop.no_listings_title", { tab: activeTab.toUpperCase() })}</p>
                    <p className="text-sm mt-2">{t("shop.no_listings_text")}</p>
                </div>
            )}
        </div>
    );
};


// --- 1. IMAGE SWIPER COMPONENT ---
// 🟢 FIXED: Added 'isFullScreen' prop to stop smartphone zooming
const ImageSwiper = ({ imageUrls, title, placeholderImageUrl, isFullScreen }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const validImageUrls = imageUrls?.filter(url => typeof url === 'string') || [];
    const images = validImageUrls.length > 0 ? validImageUrls : [placeholderImageUrl];
    const displayUrl = images[currentImageIndex];
    const isMultiImage = images.length > 1 && images[0] !== placeholderImageUrl;

    const handleNext = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    useEffect(() => {
        setCurrentImageIndex(0);
    }, [imageUrls]);

    return (
        <div className="relative w-full h-full">
            <img
                src={displayUrl}
                alt={title || "Product image"} 
                // 🟢 THE FIX: If full screen, use 'contain' so nothing gets cropped. Otherwise 'cover'.
                className={`w-full h-full ${isFullScreen ? 'object-contain' : 'object-cover'}`}
                onError={(e) => { e.target.onerror = null; e.target.src = placeholderImageUrl; }}
            />
            {isMultiImage && (
                <>
                    <button onClick={handlePrev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-black/20 text-white p-1 rounded-r z-10 text-xs">
                        &lt;
                    </button>
                    <button onClick={handleNext} className="absolute right-0 top-1/2 -translate-y-1/2 bg-black/20 text-white p-1 rounded-l z-10 text-xs">
                        &gt;
                    </button>
                    <div className="absolute bottom-1 left-1/2 -translate-x-1/2 flex space-x-1 z-10">
                        {images.map((_, index) => (
                            <div key={index} className={`w-1 h-1 rounded-full ${index === currentImageIndex ? 'bg-orange-500' : 'bg-white/50'}`} />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

// --- 2. TIME FORMATTING HELPER ---
const formatTimeAgo = (createdAt, t) => {
    if (!createdAt) return t('time.just_now', 'Just Now');
    let date;
    if (createdAt.toDate) date = createdAt.toDate();
    else if (createdAt.seconds) date = new Date(createdAt.seconds * 1000);
    else date = new Date(createdAt);
    
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return t('time.just_now', 'Just Now');
    
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return t('time.minutes_ago', '{{count}}m', { count: minutes });
    
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t('time.hours_ago', '{{count}}h', { count: hours });
    
    const days = Math.floor(hours / 24);
    if (days < 30) return t('time.days_ago', '{{count}}d', { count: days });
    
    const months = Math.floor(days / 30);
    return t('time.months_ago', '{{count}}mo', { count: months });
};

const SearchScreen = ({ t, user }) => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [history, setHistory] = useState([]);

    // ⭐ Unique key per user prevents shared history
    const HISTORY_KEY = user ? `Madili_history_${user.uid}` : 'Madili_history_guest';

    useEffect(() => {
        const savedHistory = localStorage.getItem(HISTORY_KEY);
        if (savedHistory) {
            setHistory(JSON.parse(savedHistory));
        }
    }, [HISTORY_KEY]); // Reloads if user logs in/out

    const handleClearInput = () => setSearchTerm('');

    const handleSearch = (query) => {
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return;

        // Update history for this specific user
        const updatedHistory = [
            trimmedQuery,
            ...history.filter(item => item !== trimmedQuery)
        ].slice(0, 5);

        setHistory(updatedHistory);
        localStorage.setItem(HISTORY_KEY, JSON.stringify(updatedHistory));

        navigate(`/search/results?q=${encodeURIComponent(trimmedQuery)}`);
    };

    const handleHistoryClick = (term) => {
        setSearchTerm(term);
        handleSearch(term);
    };

    const clearAllHistory = () => {
        setHistory([]);
        localStorage.removeItem(HISTORY_KEY);
    };

    return (
        <div className="min-h-screen bg-white">
            <header className="sticky top-0 p-3 flex items-center border-b border-gray-200 bg-white shadow-sm z-10">
                <button onClick={() => navigate(-1)} className="p-1 text-gray-700 mr-2">
                    <ArrowLeft size={24} />
                </button>
                
                <form 
                    onSubmit={(e) => { e.preventDefault(); handleSearch(searchTerm); }}
                    className="flex-grow flex items-center bg-gray-100 rounded-lg h-10 px-2"
                >
                    <input
                        type="search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder={t('search.placeholder', 'Search Madili Market')}
                        className="w-full bg-transparent text-gray-800 focus:outline-none text-base"
                        autoFocus
                    />
                    {searchTerm && (
                        <button type="button" onClick={handleClearInput} className="p-1 text-gray-500">
                            <X size={20} />
                        </button>
                    )}
                </form>
                
                <button onClick={() => navigate(-1)} className="ml-3 text-sm text-gray-700 font-semibold">
                    {t('common.close', 'Close')}
                </button>
            </header>
            
            <div className="p-0">
                <div className="flex justify-between items-center px-4 pt-4 pb-2">
                    <h2 className="text-lg font-bold text-gray-900">
                        {t('search.recent', 'Recent Searches')}
                    </h2>
                    {history.length > 0 && (
                        <button onClick={clearAllHistory} className="text-xs text-orange-600 font-bold">
                            {t('search.clear_all', 'Clear All')}
                        </button>
                    )}
                </div> 

                {history.length > 0 ? (
                    history.map((term, index) => (
                        <div 
                            key={index} 
                            onClick={() => handleHistoryClick(term)}
                            className="flex items-center justify-between py-3 px-4 border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
                        >
                            <div className="flex items-center space-x-3">
                                <Clock size={18} className="text-gray-400" />
                                <span className="text-gray-800 font-medium">{term}</span>
                            </div>
                            <ArrowUpLeft size={18} className="rotate-45 text-gray-300" />
                        </div>
                    ))
                ) : (
                    <div className="px-4 py-10 text-center">
                        <p className="text-gray-400 text-sm">
                            {t('search.no_recent', 'No recent searches yet.')}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

const SearchResultsPage = ({ db, appId, formatTimeAgo, user, countryName}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('q') || "";

    useEffect(() => {
        const fetchSearchResults = async () => {
            if (!db || !appId || !searchQuery) return;
            setLoading(true);
            try {
                const listingsCollectionPath = `/artifacts/${appId}/listings`;
                const q = query(collection(db, listingsCollectionPath));
                const snap = await getDocs(q);
                
                const term = searchQuery.toLowerCase();
                const nowInSeconds = Date.now() / 1000;

                const processedResults = snap.docs
                    .map(d => ({ id: d.id, ...d.data() }))
                    .filter(item => {
                        // 1. MATCH SEARCH TERM
                        const titleMatch = item.title?.toLowerCase().includes(term);
                        
                        // 2. ⭐ HIDE MY PRODUCTS FIX
                        // If user.uid matches either sellerId or userId, we hide it
                        const isMine = user?.uid && (item.sellerId === user.uid || item.userId === user.uid);
                        
                        return titleMatch && !isMine;
                    })
                    .map(item => {
                        // 3. ⭐ ADVANCED RANKING SYSTEM
                        let score = 0;
                        const createdAt = item.createdAt?.seconds || 0;
                        
                        // Recency: Newer items get a higher base score
                        score += (createdAt / 1000); 

                        // Popularity Boost: Chats are high value, Favorites are medium
                        score += (item.chats || 0) * 5000;
                        score += (item.favorites || 0) * 1000;

                        // Exact match bonus (if title is exactly the search query)
                        if (item.title?.toLowerCase() === term) score += 100000;

                        return { ...item, finalScore: score };
                    })
                    .sort((a, b) => b.finalScore - a.finalScore);

                setResults(processedResults);
            } catch (error) {
                console.error("Search Logic Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSearchResults();
    }, [db, appId, searchQuery, user?.uid]); // ⭐ Updates instantly if user identity changes

    return (
        <div className="min-h-screen bg-white">
            <header className="p-4 bg-white sticky top-0 z-50 border-b border-gray-100 shadow-sm">
                <div className="flex items-center max-w-lg mx-auto">
                    <button onClick={() => navigate(-1)} className="mr-3 text-gray-800 p-2 hover:bg-gray-50 rounded-full">
                        <ArrowLeft size={22} />
                    </button>
                    <div className="flex-grow bg-gray-100 rounded-2xl px-4 py-2.5 flex items-center border border-gray-200">
                        <Search size={18} className="text-gray-400 mr-2" />
                        <input 
                            readOnly 
                            value={searchQuery}
                            className="bg-transparent text-[15px] font-semibold w-full outline-none text-gray-800"
                        />
                    </div>
                </div>
            </header>

            <main className="pt-2">
                <div className="w-full max-w-lg mx-auto">
                    <div className="px-4 py-3 border-b border-gray-50 flex justify-between items-center">
                        <p className="text-[13px] text-gray-500 font-bold uppercase tracking-tight">
                            {results.length} {t('search.results')}
                        </p>
                        {user && (
                            <span className="text-[11px] text-orange-500 font-bold bg-orange-50 px-2 py-0.5 rounded">
                                {t('search.excluding_mine', 'Excluding your items')}
                            </span>
                        )}
                    </div>

                    {loading ? (
                        <div className="flex flex-col items-center justify-center py-32">
                            <div className="w-8 h-8 border-[3px] border-orange-500 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    ) : results.length > 0 ? (
                        <div className="divide-y divide-gray-50">
                            {results.map((listing) => (
                                <div 
                                    key={listing.id} 
                                    onClick={() => navigate(`/product/${listing.id}`)}
                                    className="p-4 flex items-start active:bg-gray-50 transition-colors cursor-pointer"
                                >
                                    <div className="w-28 h-28 flex-shrink-0 rounded-xl overflow-hidden bg-gray-100 border border-gray-100 relative">
                                        <img 
                                            src={listing.imageUrls?.[0] || listing.imageUrl || "https://placehold.co/150"} 
                                            alt={listing.title} 
                                            className="w-full h-full object-cover" 
                                        />
                                        {listing.status === 'sold' && (
                                            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                                                <span className="text-white text-[10px] font-black px-2 py-1 border border-white rounded uppercase">Sold</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex flex-col ml-4 flex-grow min-w-0 h-28 justify-between py-0.5">
                                        <div>
                                            <h2 className="text-[15px] font-medium text-gray-900 line-clamp-2 leading-snug">
                                                {listing.title}
                                            </h2>
                                            <div className="flex items-center gap-1 text-gray-400 mt-1">
                                                <span className="text-[11px] font-medium">{listing.location}</span>
                                                <span className="text-[11px]">·</span>
                                                <span className="text-[11px] font-medium">
                                                    {formatTimeAgo ? formatTimeAgo(listing.createdAt, t) : 'Recently'}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="flex items-end justify-between">
                                            {/* 🟢 FIXED: Using formatPrice instead of hardcoded FBu */}
                                            <p className="text-[16px] font-black text-gray-900">
                                                {formatPrice ? formatPrice(listing.price, countryName) : `${listing.price?.toLocaleString()} FBu`}
                                            </p>
                                            
                                            <div className="flex items-center gap-3">
                                                {listing.chats > 0 && (
                                                    <div className="flex items-center gap-1 text-gray-500">
                                                        <MessageCircle size={14} />
                                                        <span className="text-[11px] font-bold">{listing.chats}</span>
                                                    </div>
                                                )}
                                                {listing.favorites > 0 && (
                                                    <div className="flex items-center gap-1 text-gray-500">
                                                        <Heart size={14} />
                                                        <span className="text-[11px] font-bold">{listing.favorites}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-24 px-10">
                            <p className="text-gray-500 font-bold text-sm">No results found for "{searchQuery}"</p>
                            <p className="text-gray-400 text-xs mt-1">Try a different keyword or check your spelling.</p>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

// Add this inside your App component
const changeLanguageHandler = async (e) => {
    const newLang = e.target.value;
    
    // 1. Update the UI immediately
    i18n.changeLanguage(newLang);

    // 2. Save to the specific user's Firestore document
    if (auth.currentUser) {
        try {
            const userRef = doc(db, `artifacts/${appId}/users`, auth.currentUser.uid);
            await setDoc(userRef, { 
                language: newLang 
            }, { merge: true });
            console.log("Language saved for user:", auth.currentUser.uid);
        } catch (err) {
            console.error("Error saving language preference:", err);
        }
    }
};
     
// --- 1. PLACE THESE AT THE VERY TOP OF YOUR FILE ---

const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; 
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)));
};



const MapInteractionHandler = ({ userLocation, radius, countryName }) => {
    const map = useMap();

    useEffect(() => {
        if (userLocation && userLocation.lat && userLocation.lon) {
            let zoomLevel = 15;
            let targetCoords = [userLocation.lat, userLocation.lon];

            if (radius > 10) {
                // Check if the user is in "Manual Burundi Mode" or "Automatic GPS Mode"
                if (countryName === "Burundi") {
                    // Manual selection: Always show the full map of Burundi
                    targetCoords = [-3.3731, 29.9189]; 
                    zoomLevel = 8;
                } else {
                    // Automatic/GPS selection: Zoom out to show the country where the user is (e.g., Korea)
                    targetCoords = [userLocation.lat, userLocation.lon];
                    zoomLevel = 6; // Zoom level 6 is perfect for viewing a whole country like Korea
                }
            } else if (radius > 5) {
                zoomLevel = 13;
            } else if (radius > 2) {
                zoomLevel = 14;
            } else {
                zoomLevel = 15;
            }

            map.flyTo(targetCoords, zoomLevel, { 
                animate: true, 
                duration: 1.5,
                padding: [20, 20] // Adds a nice buffer around the edges
            });
        }
    }, [userLocation.lat, userLocation.lon, userLocation._forceMove, radius, map, countryName]); 

    return null;
};

// --- BURUNDI NATIONAL DATA ---
const burundiLocations = {
    "Bujumbura Mairie": { center: [-3.3822, 29.3644], communes: ["Rohero", "Nyakabiga", "Bwiza", "Buyenzi", "Kamenge", "Kinama", "Ngagara", "Muha", "Kanyosha"] },
    "Rumonge": { center: [-3.9736, 29.4393], communes: ["Rumonge Town", "Burambi", "Buyengero", "Bugarama", "Muhuta"] },
    "Makamba": { center: [-4.1348, 29.8040], communes: ["Makamba Town", "Nyanza-Lac", "Kayogoro", "Mabanda", "Kibago", "Vugizo"] },
    "Gitega": { center: [-3.4271, 29.9246], communes: ["Gitega City", "Mubuga", "Mutaho", "Bugendana", "Makebuko", "Itaba"] },
    "Ngozi": { center: [-2.9077, 29.8306], communes: ["Ngozi Town", "Busiga", "Gashikanwa", "Kiremba", "Marangara"] },
    "Kirundo": { center: [-2.5841, 30.0914], communes: ["Kirundo Town", "Busoni", "Bwambarangwe", "Gitobe", "Vumbi", "Ntega"] },
    "Cibitoke": { center: [-2.8869, 29.1191], communes: ["Cibitoke Town", "Buganda", "Bukinanyana", "Mabayi", "Rugombo", "Murwi"] },
    "Bururi": { center: [-3.9483, 29.6244], communes: ["Bururi Town", "Matana", "Mugamba", "Rutovu", "Songa", "Vyanda"] },
    "Muyinga": { center: [-2.8489, 30.3414], communes: ["Muyinga Town", "Buhinyuza", "Butihinda", "Giteranyi", "Gasorwe"] },
    "Kayanza": { center: [-2.9231, 29.6277], communes: ["Kayanza Town", "Gahombo", "Gatara", "Kabarore", "Matongo"] },
    "Bubanza": { center: [-3.0804, 29.3910], communes: ["Bubanza Town", "Gihanga", "Mpanda", "Musigati", "Rugazi"] },
    "Rutana": { center: [-3.9261, 29.9922], communes: ["Rutana Town", "Bukemba", "Giharo", "Gitanga", "Musongati"] },
    "Ruyigi": { center: [-3.4764, 30.2486], communes: ["Ruyigi Town", "Butezi", "Bweru", "Gisuru", "Kinyinya"] },
    "Muramvya": { center: [-3.2682, 29.6231], communes: ["Muramvya Town", "Bukeye", "Kiganda", "Mbuye", "Rutegama"] },
    "Mwaro": { center: [-3.5133, 29.7033], communes: ["Mwaro Town", "Bisoro", "Gisozi", "Kayokwe", "Ndava"] },
    "Karuzi": { center: [-3.1014, 30.1614], communes: ["Karuzi Town", "Bugenyuzi", "Buhiga", "Gihogazi"] },
    "Cankuzo": { center: [-3.2181, 30.4528], communes: ["Cankuzo Town", "Cendajuru", "Gisagara", "Kigamba"] },
    "Bujumbura Rural": { center: [-3.4542, 29.4122], communes: ["Isare", "Mubimbi", "Mugongomanga", "Mutimbuzi"] }
};

const updateUserLocationInDB = async (locationData) => {
    if (!user || !db || !appId) return;
    try {
        const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
        await updateDoc(userRef, {
            location: locationData,
            lastLocationUpdate: serverTimestamp()
        });
        console.log("Location synced to Firebase!");
    } catch (error) {
        console.error("Error updating location:", error);
    }
};
// Add these right above const ListingsPage = ({ ... }) => {
let globalListingsCache = [];
let globalFilteredCache = [];
let globalHasMoreCache = true;
let globalRadiusCache = 10;


const ListingsPage = ({ user, db, t, appId, i18n, changeLanguageHandler, isLoading, setUserLocation, formatTimeAgo, ImageSwiper, userLocation, setIsLoading, countryName, setCountryName, formatPrice, isLocationModalOpen,setIsLocationModalOpen }) => {
    const navigate = useNavigate();
    const listingsCollectionPath = `/artifacts/${appId}/listings`;

    const [viewMode, setViewMode] = useState('list'); 
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [lastVisible, setLastVisible] = useState(null);
    const [unreadNotifCount, setUnreadNotifCount] = useState(0); 
   
    const [tempProvince, setTempProvince] = useState("Bujumbura Mairie");
    const [neighborhoodName, setNeighborhoodName] = useState('Select Locality');

    // 🟢 ADD THESE TWO LINES HERE
    const [countrySearchText, setCountrySearchText] = useState("");
    const globalCountries = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
        "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
        "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
        "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
        "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary",
        "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyzstan",
        "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar",
        "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Sweden", "Switzerland", "Syria",
        "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    const prevUserUid = useRef(user?.uid);
    const [selectedItem, setSelectedItem] = useState(null);
    
   
    const hasInitialDataFetched = useRef(false);
    // 🟢 FORCE REFRESH: Whenever the app wakes up from the background!
    useEffect(() => {
        const handleAppState = async ({ isActive }) => {
            if (isActive) {
                // 1. Wipe the old cache to force a fresh fetch
                setAllListings([]); 
                globalListingsCache = [];
                hasInitialDataFetched.current = false;
                
                // 2. Trigger your pull-to-refresh spinner automatically
                if (typeof setIsRefreshing === 'function') setIsRefreshing(true);
            }
        };

        let appStateListener;
        CapApp.addListener('appStateChange', handleAppState).then(listener => {
            appStateListener = listener;
        });

        return () => {
            if (appStateListener) appStateListener.remove();
        };
    }, []);
    const [savedHeight, setSavedHeight] = useState(0);

    // 🟢 FRAMER MOTION VALUES (Hardware accelerated for buttery smooth dragging)
    const y = useMotionValue(0);
    const pullDistance = 80;
    const rotate = useTransform(y, [0, pullDistance], [0, 360]);
    const opacity = useTransform(y, [0, pullDistance], [0, 1]);
    const dynamicScale = useTransform(y, [0, pullDistance], [0.5, 1]);

    const forcedScale = isRefreshing ? 1 : dynamicScale;
    const forcedOpacity = isRefreshing ? 1 : opacity;

    const PAGE_SIZE = 20;
    const observer = useRef();
    const scrollAttempted = useRef(false);
    const location = useLocation();
    
    const [allListings, setAllListings] = useState(globalListingsCache);
    const [filteredListings, setFilteredListings] = useState(globalFilteredCache);
    const [hasMore, setHasMore] = useState(globalHasMoreCache);
    const [radius, setRadius] = useState(globalRadiusCache);

    const categories = [
        'All', 'Houses for Rent', 'Lands and Houses for Sale', 'Smartphones',
        'Cars', 'Motorbikes and Bicycles', 'Home Appliances', 'Fashions',
        'Foods and Drinks', 'Jobs', 'Others'
    ];

    // 🟢 UNIFIED DRAG REFRESH LOGIC (Works perfectly on Mouse AND Touch)
    const scrollContainerRef = useRef(null);
    const startY = useRef(0);
    const isPulling = useRef(false);

    // 🟢 Catch the back button event to close the Map View
    useEffect(() => {
        const closeMap = () => setViewMode('list');
        window.addEventListener('closeMapView', closeMap);
        return () => window.removeEventListener('closeMapView', closeMap);
    }, []);

   // 🟢 Repaired state tracking framework for map views, active categories, and modal interactions
    useEffect(() => {
        if (viewMode === 'map' || selectedCategory !== 'All' || isLocationModalOpen) {
            window.history.pushState({ viewScope: true }, '');
        }
        const handleHardwareBack = (e) => {
            if (isLocationModalOpen) {
                setIsLocationModalOpen(false);
                setCountrySearchText("");
            } else if (viewMode === 'map') {
                setViewMode('list');
            } else if (selectedCategory !== 'All') {
                setSelectedCategory('All');
            }
        };
        window.addEventListener('popstate', handleHardwareBack);
        return () => window.removeEventListener('popstate', handleHardwareBack);
    }, [viewMode, selectedCategory, isLocationModalOpen]);

    useEffect(() => {
        const el = scrollContainerRef.current;
        if (!el) return;

        // Helper to grab the Y coordinate from either a mouse or a finger
        const getPageY = (e) => e.touches ? e.touches[0].clientY : e.clientY;

        const handleStart = (e) => {
            if (window.scrollY <= 10) {
                startY.current = getPageY(e);
                isPulling.current = true;
            }
        };

        const handleMove = (e) => {
            if (!isPulling.current || isRefreshing) return;
            const currentY = getPageY(e);
            const diff = currentY - startY.current;

            if (diff > 0 && window.scrollY <= 10) {
                if (e.cancelable) e.preventDefault(); // Physically blocks browser refresh
                // Set the motion value directly. Multiplier 0.75 makes it feel very responsive!
                y.set(Math.min(diff * 0.75, 120)); 
            } else {
                isPulling.current = false;
            }
        };

        const handleEnd = () => {
            if (!isPulling.current) return;
            isPulling.current = false;

            // Trigger threshold lowered to 50 for a smoother snap
            if (y.get() >= 50) {
                setIsRefreshing(true);
                sessionStorage.removeItem(`madili_scroll_${user?.uid || 'guest'}`);
                scrollAttempted.current = true;
                window.scrollTo(0, 0);

                setTimeout(() => {
                    setAllListings(prev => [...prev].sort(() => Math.random() - 0.5));
                    setIsRefreshing(false);
                    animate(y, 0, { type: "spring", stiffness: 300, damping: 30 });
                }, 1000); 
            } else {
                // Snap back if let go too early
                animate(y, 0, { type: "spring", stiffness: 300, damping: 30 });
            }
        };

        // Attach listeners for Smartphone Touch
        el.addEventListener('touchstart', handleStart, { passive: true });
        el.addEventListener('touchmove', handleMove, { passive: false });
        el.addEventListener('touchend', handleEnd, { passive: true });
        el.addEventListener('touchcancel', handleEnd, { passive: true });

        // Attach listeners for Computer Mouse
        el.addEventListener('mousedown', handleStart, { passive: true });
        window.addEventListener('mousemove', handleMove, { passive: false });
        window.addEventListener('mouseup', handleEnd, { passive: true });

        return () => {
            el.removeEventListener('touchstart', handleStart);
            el.removeEventListener('touchmove', handleMove);
            el.removeEventListener('touchend', handleEnd);
            el.removeEventListener('touchcancel', handleEnd);
            el.removeEventListener('mousedown', handleStart);
            window.removeEventListener('mousemove', handleMove);
            window.removeEventListener('mouseup', handleEnd);
        };
    }, [isRefreshing, user?.uid, y]);

    // --- 4. SCROLL RESTORATION ---
    useEffect(() => {
        if (user?.uid !== prevUserUid.current) {
            hasInitialDataFetched.current = false;
            const scrollKey = `madili_scroll_${user?.uid || 'guest'}`;
            const heightKey = `madili_height_${user?.uid || 'guest'}`;
            sessionStorage.removeItem(scrollKey);
            sessionStorage.removeItem(heightKey);
            window.scrollTo(0, 0);
            setAllListings([]); 
            prevUserUid.current = user?.uid;
        }
    }, [user?.uid]);

    useEffect(() => {
        const handleScroll = () => {
            if (filteredListings.length > 0 && !isRefreshing) {
                const scrollKey = `madili_scroll_${user?.uid || 'guest'}`;
                const heightKey = `madili_height_${user?.uid || 'guest'}`;
                sessionStorage.setItem(scrollKey, window.scrollY.toString());
                sessionStorage.setItem(heightKey, document.documentElement.scrollHeight.toString());
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [filteredListings.length, isRefreshing, user?.uid]);

    useEffect(() => {
        if (!loading && allListings.length > 0) {
            const scrollKey = `madili_scroll_${user?.uid || 'guest'}`;
            const heightKey = `madili_height_${user?.uid || 'guest'}`;
            const savedPos = sessionStorage.getItem(scrollKey);
            const savedH = sessionStorage.getItem(heightKey);
            
            if (savedPos && savedH) {
                setSavedHeight(parseInt(savedH));
                requestAnimationFrame(() => {
                    window.scrollTo({ top: parseInt(savedPos), behavior: 'instant' });
                    setTimeout(() => setSavedHeight(0), 150);
                });
            }
        }
    }, [loading, allListings.length, user?.uid]);

    // --- NEW: LOAD RADIUS ON MOUNT ---
   // --- 🟢 FIXED: LOAD RADIUS ON MOUNT & UNLOCK SLIDER ---
    useEffect(() => {
        const fetchUserRadius = async () => {
            if (user?.uid && db) {
                // 1. Automatically kill the "Visitor Mode" lock the moment they log in
                localStorage.setItem('is_visitor_mode', 'false');
                
                try {
                    const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
                    const userSnap = await getDoc(userDocRef);
                    
                    // 2. Restore their custom distance, OR default to 3km for new accounts
                    if (userSnap.exists() && userSnap.data().preferredRadius) {
                        setRadius(userSnap.data().preferredRadius);
                    } else {
                        setRadius(3); // Fixes the 11km trap for brand new users
                    }
                } catch (error) {
                    console.error("Error loading radius:", error);
                    setRadius(3);
                }
            }
        };
        fetchUserRadius();
    }, [user?.uid, db, appId]);

   const saveRadiusPreference = async (val) => {
        if (!user?.uid || !db) return;
        try {
            const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
            await setDoc(userDocRef, { 
                preferredRadius: parseFloat(val),
                savedLocalRadius: parseFloat(val) // 🟢 NEW: Secure backup memory added here!
            }, { merge: true });
            console.log("Radius saved:", val);
        } catch (error) {
            console.error("Error saving radius:", error);
        }
    };

    

    const handleAdClick = async (ad) => {
        try {
            const adRef = doc(db, "artifacts", appId, "ads", ad.id);
            await updateDoc(adRef, { clicks: increment(1) });

            if (ad.actionType === 'whatsapp') {
                const cleanNumber = ad.actionValue.replace(/\D/g, '');
                const message = encodeURIComponent(`Hello, I saw your ad for "${ad.title}" on Boom Market.`);
                window.open(`https://wa.me/${cleanNumber}?text=${message}`, '_blank');
            } else if (ad.actionValue) {
                const url = ad.actionValue.startsWith('http') ? ad.actionValue : `https://${ad.actionValue}`;
                window.open(url, '_blank');
            }
        } catch (error) {
            console.error("Error tracking ad click:", error);
        }
    };

   const [teamAds, setTeamAds] = useState([]);
    const [videoAds, setVideoAds] = useState([]); // 🟢 NEW STATE FOR VIDEOS

    // 🟢 FETCH OFFICIAL ADS (Separating Images and Videos)
    useEffect(() => {
        if (!db || !appId) return;
        const adsRef = collection(db, `artifacts/${appId}/ads`);
        // Removed limit(5) so we grab all active campaigns to sort them
        const q = query(adsRef, orderBy('createdAt', 'desc')); 
        
        const unsubscribe = onSnapshot(q, (snap) => {
            const allAds = snap.docs.map(d => ({ id: d.id, ...d.data(), isAd: true }));
            
            // Separate them by type so we can handle the math properly
            setTeamAds(allAds.filter(ad => ad.mediaType !== 'video'));
            setVideoAds(allAds.filter(ad => ad.mediaType === 'video'));
        });
        return () => unsubscribe();
    }, [db, appId]);

    // 1. NOTIFICATIONS & CHATS
    useEffect(() => {
        if (!user || !db) return;
        const q = query(
            collection(db, `artifacts/${appId}/notifications`),
            where('recipientId', '==', user.uid),
            where('seen', '==', false)
        );
        return onSnapshot(q, (snap) => setUnreadNotifCount(snap.docs.length));
    }, [user, db, appId]);

    // This handles the "Live Zone" (Top 20 items)
    useEffect(() => {
        if (!db || !appId) return;

        if (hasInitialDataFetched.current && !isRefreshing && allListings.length > 0) {
            setLoading(false);
            if (typeof setIsLoading === 'function') setIsLoading(false);
            return; 
        }

        setLoading(true);

        let constraints = [
            orderBy('createdAt', 'desc'), 
            limit(PAGE_SIZE)
        ];
        
        if (selectedCategory !== 'All') {
            constraints.unshift(where('category', '==', selectedCategory));
        }

        const q = query(collection(db, listingsCollectionPath), ...constraints);

        const unsubscribe = onSnapshot(q, (snap) => {
            const HISTORY_KEY = user?.uid ? `Madili_history_${user.uid}` : 'Madili_history_guest';
            const savedHistory = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');

            const listingsData = snap.docs.map(d => {
                const data = d.data();
                let score = 0;

                const nowInSeconds = Date.now() / 1000;
                const createdAtSeconds = data.createdAt?.seconds || nowInSeconds;
                const postAgeInDays = (nowInSeconds - createdAtSeconds) / 86400;

                if (savedHistory.length > 0) {
                    savedHistory.slice(0, 5).forEach((term) => {
                        if (term && data.title?.toLowerCase().includes(term.toLowerCase())) {
                            const baseSearchBonus = 100000000; 
                            const decayFactor = Math.max(0, 1 - (postAgeInDays * 0.10));
                            score += (baseSearchBonus * decayFactor); 
                        }
                    });
                }

                score += createdAtSeconds;
                score += (data.likesCount || data.favorites || 0) * 1000;

                return { id: d.id, ...data, baseScore: score };
            });

            setAllListings(listingsData);
            globalListingsCache = listingsData; 

            setLoading(false);
            if (typeof setIsLoading === 'function') setIsLoading(false); 
            
            if (snap.docs.length < PAGE_SIZE) {
                setHasMore(false);
                globalHasMoreCache = false; 
            } else {
                setHasMore(true); 
                globalHasMoreCache = true; 
            }

            setLoading(false);
            setIsRefreshing(false);
        }, (error) => {
            console.error("Listener failed:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [selectedCategory, appId, db, user?.uid, PAGE_SIZE]); 

    // 2. UPDATE FILTER & FINAL SORT (The Proximity Tier)
    useEffect(() => {
        const filterData = () => {
            setIsRefreshing(true);

            setTimeout(() => {
                const HISTORY_KEY = user?.uid ? `Madili_history_${user.uid}` : 'Madili_history_guest';
                const savedHistory = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');

                // 🟢 Hides the seller's own items AND completely hides flagged/dangerous content
                let result = allListings.filter(item => item.sellerId !== user?.uid && item.status !== 'flagged');

                // 🟢 1. FLAG CHECK: Are we in Visitor Mode?
                const isVisitorMode = localStorage.getItem('is_visitor_mode') === 'true' || radius > 10;

                result = result.map(item => {
                    let currentScore = item.baseScore || 0;
                    let dist = null;

                    if (savedHistory.length > 0) {
                        savedHistory.slice(0, 5).forEach((term) => {
                            const titleMatch = item.title?.toLowerCase().includes(term.toLowerCase());
                            const categoryMatch = item.category?.toLowerCase() === term.toLowerCase();
                            if (titleMatch || categoryMatch) currentScore += 100000000; 
                        });
                    }

                    // Retrieve true physical coordinates
                    let trueLat = parseFloat(localStorage.getItem('true_physical_lat') || localStorage.getItem('device_lat')) || 37.3212;
                    let trueLon = parseFloat(localStorage.getItem('true_physical_lon') || localStorage.getItem('device_lon')) || 126.8312;

                    // If visitor, calculate from physical body. If local, calculate from map center.
                    const calcLat = isVisitorMode ? trueLat : (userLocation?.lat || trueLat);
                    const calcLon = isVisitorMode ? trueLon : (userLocation?.lon || trueLon);

                    const itemLat = item.latitude || item.lat;
                    const itemLon = item.longitude || item.lng;
                    
                    if (itemLat && itemLon) {
                        dist = calculateDistance(calcLat, calcLon, itemLat, itemLon);
                        if (dist <= 3 && !isVisitorMode) currentScore += 500000;
                    }

                    return { 
                        ...item, 
                        finalScore: currentScore, 
                        distValue: dist, 
                        distanceText: dist ? (dist > 100 ? `${Math.round(dist).toLocaleString()}km` : `${dist.toFixed(1)}km`) : '' 
                    };
                });

                // 🟢 2. VISITOR SLIDER BYPASS: Only filter by distance if NOT in visitor mode
                if (!isVisitorMode) {
                    result = result.filter(item => item.distValue !== null && item.distValue <= radius);
                } else {
                    const targetCountry = (localStorage.getItem('user_country') || countryName || 'Burundi').toLowerCase();
                    result = result.filter(item => {
                        const itemCountry = (item.countryCode || item.country || '').toLowerCase();
                        if (targetCountry.includes('burundi')) return itemCountry === 'burundi' || itemCountry === '';
                        if (targetCountry.includes('korea') || targetCountry.includes('corée')) return itemCountry.includes('korea') || itemCountry.includes('corée');
                        return itemCountry === targetCountry;
                    });
                }

                let listWithAds = [];
                
                // 🟢 Filter ads by the user's current country (or Global)
                const userTargetCountry = (localStorage.getItem('user_country') || countryName || 'Burundi').toLowerCase();
                
                const validImageAds = teamAds.filter(ad => 
                    ad.targetScope === 'worldwide' || ad.targetValue === 'Global' || (ad.targetValue || '').toLowerCase() === userTargetCountry
                );
                
                const validVideoAds = videoAds.filter(ad => 
                    ad.targetScope === 'worldwide' || ad.targetValue === 'Global' || (ad.targetValue || '').toLowerCase() === userTargetCountry
                );

                result.forEach((item, index) => {
                    listWithAds.push(item);
                    
                    const productPosition = index + 1;

                    // 🟢 EVERY 20 PRODUCTS: Insert the Horizontal Video Ad Block
                    if (productPosition % 20 === 0 && validVideoAds.length > 0) {
                        listWithAds.push({ 
                            uiKey: `video-block-${index}`,
                            isVideoBlock: true, 
                            videos: validVideoAds.slice(0, 5) // Show up to 5 targeted videos in the swiper
                        });
                    } 
                    // 🟢 EVERY 5 PRODUCTS (except the 20th): Insert an Image Ad
                    else if (productPosition % 5 === 0 && validImageAds.length > 0) {
                        const adIndex = (Math.floor(productPosition / 5) - 1) % validImageAds.length;
                        listWithAds.push({ ...validImageAds[adIndex], uiKey: `ad-ui-${index}` });
                    }
                });

                setFilteredListings(listWithAds);
                globalFilteredCache = listWithAds;

                setIsRefreshing(false);
            }, 400);
        };

        filterData();
    }, [allListings, userLocation, radius, user?.uid, teamAds]); 

    const fetchMoreListings = async () => {
        if (loadingMore || !hasMore || allListings.length === 0) return;

        setLoadingMore(true);
        try {
            const lastItem = allListings[allListings.length - 1];
            const lastTimestamp = lastItem.createdAt;

            let constraints = [
                orderBy('createdAt', 'desc'),
                startAfter(lastTimestamp), 
                limit(PAGE_SIZE)
            ];

            if (selectedCategory !== 'All') {
                constraints.unshift(where('category', '==', selectedCategory));
            }

            const q = query(collection(db, listingsCollectionPath), ...constraints);
            const snap = await getDocs(q);

            if (!snap.empty) {
                const olderItems = snap.docs.map(d => {
                    const data = d.data();
                    return { id: d.id, ...data, baseScore: data.createdAt?.seconds || 0 };
                });
                
                setAllListings(prev => [...prev, ...olderItems]);

                if (snap.docs.length < PAGE_SIZE) setHasMore(false);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Boom Market Pagination Error:", error);
        } finally {
            setLoadingMore(false);
        }
    };

    const lastElementRef = useCallback(node => {
        if (loading || loadingMore || viewMode === 'map') return;
        
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                if (allListings.length >= PAGE_SIZE) {
                    fetchMoreListings(); 
                } else {
                    setHasMore(false);
                }
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, loadingMore, hasMore, viewMode, allListings.length]);

    const handleProductClick = (input) => {
        let listing = typeof input === 'object' ? input : allListings.find(l => l.id === input);

        if (!listing) {
            navigate(`/product/${typeof input === 'object' ? input.id : input}`);
            return;
        }

        sessionStorage.setItem(`madili_scroll_${user?.uid || 'guest'}`, window.scrollY.toString());
        scrollAttempted.current = false; 

        const HISTORY_KEY = user?.uid ? `Madili_history_${user.uid}` : 'Madili_history_guest';
        let savedHistory = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');

        const category = listing.category || "";
        const title = listing.title || "";

        const keywords = [category, ...title.toLowerCase().split(' ').slice(0, 2)];

        keywords.forEach(word => {
            if (word && word.length > 3 && !savedHistory.includes(word)) savedHistory.unshift(word); 
        });

        const updatedHistory = savedHistory.slice(0, 15);
        localStorage.setItem(HISTORY_KEY, JSON.stringify(updatedHistory));

        navigate(`/product/${listing.id}`);
    };

    const handleManualLocality = async (loc, province) => {
        setNeighborhoodName(loc);
        setCountryName("Burundi"); 
        setIsLocationModalOpen(false);
        
        try {
            const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${loc}, ${province}, Burundi`);
            const data = await res.json();
            
            if (data?.[0] && user?.uid) {
                const newLoc = { 
                    lat: parseFloat(data[0].lat), 
                    lon: parseFloat(data[0].lon),
                    name: loc,
                    _forceMove: Date.now() 
                };

                setUserLocation(newLoc);

                const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
                await setDoc(userDocRef, { 
                    location: newLoc,
                    lastLocationUpdate: serverTimestamp() 
                }, { merge: true });
            }
        } catch (e) {
            console.error("Failed to index location in database", e);
        }
    };

 // 🟢 FIXED: Sync BOTH location and country directly from the database!
useEffect(() => {
    if (!user?.uid || !db) return;

    const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
    const unsubscribe = onSnapshot(userRef, (docSnap) => {
        if (docSnap.exists()) {
            const data = docSnap.data();
            
            if (data.location) {
                setUserLocation(data.location);
                setNeighborhoodName(data.location.name);
            }
            
            if (data.country && typeof setCountryName === 'function') {
                setCountryName(data.country);
            }
            
            // 🔥 ADD THIS: Make the slider instantly snap to the restored radius
            if (data.preferredRadius && data.preferredRadius < 11) {
                setRadius(data.preferredRadius);
            }
        }
    });

    return () => unsubscribe();
}, [user?.uid, db, appId, setCountryName]);
 
    const migrateToMadili = () => {
        const oldPrefix = 'buja';
        const newPrefix = 'madili';
        
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(oldPrefix)) {
                const newKey = key.replace(oldPrefix, newPrefix);
                localStorage.setItem(newKey, localStorage.getItem(key));
                localStorage.removeItem(key);
            }
        });

        Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(oldPrefix)) {
                const newKey = key.replace(oldPrefix, newPrefix);
                sessionStorage.setItem(newKey, sessionStorage.getItem(key));
                sessionStorage.removeItem(key);
            }
        });
    };

    useEffect(() => { migrateToMadili(); }, []);

    return (
        <div className="min-h-screen bg-gray-50 relative overflow-x-hidden">
            {/* 🟢 THE MAGIC CSS: physically stops Chrome/Safari from pulling to refresh on mobile */}
            <style>{` body { overscroll-behavior-y: none; } `}</style>

            <header className="p-3 bg-white sticky top-0 z-[1001] border-b shadow-sm">
                <div className="flex items-center justify-between max-w-4xl mx-auto w-full gap-1">
                   <div 
                        className="flex items-center gap-0.5 cursor-pointer w-[25%] active:opacity-60 transition-opacity" 
onClick={() => {
    // 🟢 Save the current radius before opening the menu
    localStorage.setItem('temp_saved_radius', radius);
    if (typeof setIsLocationModalOpen === 'function') {
        setIsLocationModalOpen(true);
    }
}}
                    >
                        {/* 🟢 FIXED TITLE: It will now say the Country Name if you are zoomed all the way out */}
                        <h1 className="text-[13px] sm:text-base font-black text-gray-900 truncate">
                     {localStorage.getItem('is_visitor_mode') === 'true' || radius > 10 ? (countryName || localStorage.getItem('user_country') || 'Select') : (userLocation?.name || neighborhoodName || 'Select')}
                      </h1>
                        <span className="text-orange-600 text-[8px]">▼</span>
                    </div>

                    <div className="flex justify-center items-center w-[45%] text-center px-1">
                        <h1 className="text-[17px] sm:text-xl font-black text-orange-600 tracking-tighter whitespace-nowrap">
                            Madili Market
                        </h1>
                    </div>

                    <div className="flex items-center justify-end space-x-1 w-[30%]">
                        <button onClick={() => navigate('/notifications')} className="relative p-1 bg-gray-100 rounded-full">
                            <span className="text-base">🔔</span>
                            {unreadNotifCount > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[8px] min-w-[14px] h-[14px] rounded-full flex items-center justify-center border border-white font-bold">
                                    {unreadNotifCount}
                                </span>
                            )}
                        </button>
                       <select onChange={changeLanguageHandler} value={i18n?.language || 'en'} className="p-0.5 border rounded text-[9px] font-bold bg-white outline-none cursor-pointer max-w-[45px] sm:max-w-none">
    <option value="en">English</option>
    <option value="fr">Français</option>
    <option value="sw">Kiswahili</option>
    <option value="ki">Kirundi</option>
    <option value="rw">Kinyarwanda</option>
    <option value="ln">Lingala</option>
</select>
                        <button onClick={() => navigate('/search')} className="p-1 bg-gray-100 rounded-full text-base">🔍</button>
                    </div>
                </div>

                <div className="w-full max-w-4xl mx-auto flex overflow-x-auto py-3 no-scrollbar mt-1">
                    {categories.map(cat => (
                        <button 
                            key={cat} 
                            onClick={() => setSelectedCategory(cat)}
                            className={`px-4 py-1.5 mr-2 rounded-full text-[11px] font-bold whitespace-nowrap transition-colors ${selectedCategory === cat ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                        >
                            {t ? t(`categories.${cat}`, cat) : cat}
                        </button>
                    ))}
                </div>

<div className="max-w-4xl mx-auto flex items-center gap-3 pt-1 pb-1">
                    {/* 🟢 THE ULTIMATE LOCK: Renders a fake visual slider in Visitor Mode so it is physically impossible to click */}
                    {localStorage.getItem('is_visitor_mode') === 'true' ? (
                        <div className="flex-grow h-1.5 bg-gray-200 rounded-full relative cursor-not-allowed opacity-40 mx-1">
                            <div className="absolute top-0 left-0 h-full w-full bg-orange-600 rounded-full"></div>
                            <div className="absolute top-1/2 right-0 w-3.5 h-3.5 bg-orange-600 border-2 border-white rounded-full -translate-y-1/2 shadow-sm"></div>
                        </div>
                    ) : (
                        <input 
                            type="range" 
                            min="0.5" 
                            max="10.5" 
                            step="0.5" 
                            value={radius} 
                            onChange={(e) => {
                                const val = parseFloat(e.target.value);
                                setRadius(val);
                                if (typeof setIsRefreshing === 'function') setIsRefreshing(true);
                            }} 
                            onMouseUp={(e) => saveRadiusPreference(e.target.value)}
                            onTouchEnd={(e) => saveRadiusPreference(e.target.value)}
                            className="flex-grow accent-orange-600 h-1.5 cursor-pointer" 
                        />
                    )}
                    <span className="text-[11px] font-black text-orange-600 min-w-[55px] text-right">
                        {localStorage.getItem('is_visitor_mode') === 'true' || radius > 10 ? countryName : radius < 1 ? `${radius * 1000}m` : `${radius}km`}
                    </span>
                </div>

            </header>

            {/* 🟢 THE REFRESH SPINNER */}
            <div className="absolute left-0 right-0 flex justify-center items-center z-[50] pointer-events-none" style={{ top: "165px", height: "50px" }}>
                <motion.div 
                    style={{ rotate, opacity: forcedOpacity, scale: forcedScale }} 
                    className="bg-white rounded-full p-2 shadow-lg border border-orange-100"
                >
                    <svg className={`w-6 h-6 text-orange-500 ${isRefreshing ? 'animate-spin' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                </motion.div>
            </div>

            {/* 🟢 THE MAIN CONTAINER WITH REF */}
            <main ref={scrollContainerRef} className="relative z-10 w-full select-none touch-pan-y">
                {viewMode === 'list' ? (
                   <motion.div 
                        style={{ y, minHeight: savedHeight > 0 ? `${savedHeight}px` : '100vh' }} 
                        className="px-4 pt-4 pb-24 max-w-lg mx-auto"
                    >
                        <div className="space-y-4">
                            
                              {/* 🟢 EMPTY STATE MESSAGE */}
                            {filteredListings.length === 0 && !loading && !isRefreshing && (
                                <div className="text-center py-20 px-4">
                                     <div className="text-6xl mb-4">🌍</div>
                                     <h3 className="text-lg font-bold text-gray-800">
                                          {radius > 10 ? (localStorage.getItem('user_country') || 'this country') : userLocation?.name}
                                     </h3>
                                    
                                    
                                </div>
                            )}
                            {filteredListings.map((listing, index) => {

                                // 🟢 1. RENDER THE HORIZONTAL VIDEO ADS BLOCK
                                if (listing.isVideoBlock) {
                                    return (
                                        <div key={listing.uiKey} className="mb-4 bg-white p-3 rounded-xl shadow-sm border border-gray-100">
                                            <div className="flex items-center justify-between mb-3 px-1">
                                                <h3 className="text-[11px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-1">
                                                    <span className="text-orange-500">▶</span> Sponsored Videos
                                                </h3>
                                            </div>
                                            <div className="flex overflow-x-auto gap-3 pb-2 no-scrollbar snap-x">
                                                {listing.videos.map((video) => (
                                                    <div key={video.id} onClick={() => handleAdClick(video)} className="relative w-36 h-64 flex-shrink-0 rounded-xl overflow-hidden bg-black snap-center cursor-pointer active:scale-95 transition-transform shadow-md border-2 border-orange-100">
                                                        <video 
                                                            src={video.imageUrl} 
                                                            className="w-full h-full object-cover"
                                                            muted
                                                            autoPlay 
                                                            loop
                                                            playsInline
                                                        />
                                                        {/* Gradient Overlay for text readability */}
                                                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent pointer-events-none"></div>
                                                        
                                                        {/* Text and Button Overlay */}
                                                        <div className="absolute bottom-2 left-2 right-2 pointer-events-none">
                                                            <div className="flex items-center justify-center gap-1 bg-orange-600 text-white px-2 py-1 rounded-md w-max mb-1.5 shadow-sm">
                                                                <span className="text-[9px] font-black uppercase tracking-tight">Shop Now</span>
                                                            </div>
                                                            <p className="text-[11px] text-white font-bold line-clamp-2 leading-tight">
                                                                {video.title}
                                                            </p>
                                                        </div>
                                                        
                                                        <div className="absolute top-2 right-2 bg-black/60 text-white text-[8px] px-1.5 py-0.5 rounded font-black uppercase tracking-widest backdrop-blur-sm">
                                                            Ad
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                }

                              if (listing.isAd) {
                                    return (
                                        // Made the ad card match the new Karrot flat-list styling
                                        <div key={listing.uiKey} onClick={() => handleAdClick(listing)} className="bg-orange-50 p-4 flex border-b border-orange-100 relative cursor-pointer active:bg-orange-100 transition-colors">
                                            <div className="absolute top-0 right-0 bg-orange-600 text-white text-[9px] px-3 py-1 rounded-bl-xl font-black uppercase tracking-wider z-10">Sponsored</div>
                                            {/* 🟢 INCREASED TO 110px PERFECT SQUARE */}
                                            <div className="w-[110px] h-[110px] flex-shrink-0 rounded-xl overflow-hidden mr-4 border border-orange-200 bg-white">
                                                <img src={listing.imageUrl} alt={listing.title} className="w-full h-full object-cover" />
                                            </div>
                                            <div className="flex flex-col justify-center py-1 flex-grow">
                                                <div>
                                                    <span className="text-[9px] font-bold text-orange-600 bg-orange-100 px-1.5 py-0.5 rounded uppercase">Official Ad</span>
                                                    <h2 className="text-[16px] font-medium text-gray-900 line-clamp-2 leading-tight mt-1">{listing.title}</h2>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }

                                return (
                                    // 🟢 Removed shadow, added flat bottom border (Karrot Style)
                                    <div key={listing.id} ref={filteredListings.length === index + 1 ? lastElementRef : null} className="bg-white p-4 flex relative border-b border-gray-100 active:bg-gray-50 transition-colors">
                                        
                                        {/* 🟢 INCREASED TO 110px PERFECT SQUARE */}
                                        <div className="w-[110px] h-[110px] flex-shrink-0 rounded-xl overflow-hidden mr-4 border border-gray-100" onClick={(e) => e.stopPropagation()}>
                                           <img 
                                                src={(listing.imageUrls && listing.imageUrls.length > 0) ? listing.imageUrls[0] : (listing.imageUrl || "https://placehold.co/150")} 
                                                alt="" 
                                                className="w-full h-full object-cover" 
                                            />
                                        </div>

                                        <div className="flex flex-col justify-between py-1 flex-grow cursor-pointer" onClick={() => handleProductClick(listing.id)}>
                                            <div>
                                                {/* 🟢 Slightly larger text to match Karrot */}
                                                <h2 className="text-[16px] font-medium text-gray-900 line-clamp-2 leading-tight">{listing.title}</h2>
                                                <p className="text-[13px] text-gray-500 mt-1">
                                                    {listing.location} {listing.distanceText && ` • ${listing.distanceText}`} • {typeof formatTimeAgo === 'function' ? formatTimeAgo(listing.createdAt, t) : 'Recently'}
                                                </p>
                                            </div>
                                            <div className="flex items-center justify-between mt-auto">
                                                <div className="flex items-center gap-1.5">
                                                    {/* Karrot uses darker, subtle badges for sold items */}
                                                    {listing.status === 'sold' && <span className="bg-gray-700 text-[10px] text-white px-2 py-0.5 rounded-sm font-bold uppercase">SOLD</span>}
                                                    {listing.status === 'reserved' && <span className="bg-green-600 text-[10px] text-white px-2 py-0.5 rounded-sm font-bold uppercase">RESERVED</span>}
                                                    <p className="text-[17px] font-bold text-gray-900">{typeof formatPrice === 'function' ? formatPrice(listing.price, countryName) : listing.price}</p>
                                                </div>
                                                <div className="flex items-center space-x-2 text-gray-400">
                                                     {(listing.messageCount > 0 || listing.chats > 0) && <span className="text-[10px] font-bold">💬 {listing.messageCount || listing.chats}</span>}
                                                    {(listing.likesCount > 0 || listing.favorites > 0) && <span className="text-[10px] font-bold text-blue-500">👍 {listing.likesCount || listing.favorites}</span>}
                                              
                                               </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {viewMode === 'list' && (
                                <div ref={lastElementRef} className="py-10 flex flex-col items-center justify-center">
                                    {loadingMore ? (
                                        <div className="flex flex-col items-center gap-2">
                                            <div className="w-6 h-6 border-2 border-gray-200 border-t-orange-600 rounded-full animate-spin" />
                                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Loading More...</p>
                                        </div>
                                    ) : !hasMore && allListings.length > 0 ? (
                                        <p className="text-[11px] font-bold text-gray-300 uppercase tracking-tighter">✨ End of Listings</p>
                                    ) : null}
                                </div>
                            )}
                        </div>
                    </motion.div>
               ) : (
                    <div id="map-view-container" className="h-[75vh] w-full px-4 pt-4">
                        <div className="h-full w-full rounded-2xl overflow-hidden border-4 border-white shadow-xl">
               {userLocation ? (
                                <MapContainer center={[userLocation.lat, userLocation.lon]} zoom={13} style={{ height: '100%', width: '100%' }} zoomControl={false}>
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <MapInteractionHandler userLocation={userLocation} radius={radius} countryName={countryName} />
                                    {radius <= 10 && <Circle center={[userLocation.lat, userLocation.lon]} radius={radius * 1000} pathOptions={{ color: '#ea580c', fillColor: '#ea580c', fillOpacity: 0.1 }} />}
                                    <Marker 
                                        position={[userLocation.lat, userLocation.lon]}
                                        icon={L.divIcon({
                                            className: 'user-position-marker',
                                            html: `<div style="position: relative; display: flex; justify-content: center; align-items: center;">
                                                       <div style="width: 14px; height: 14px; background: #3b82f6; border: 2.5px solid white; border-radius: 50%; box-shadow: 0 0 8px rgba(0,0,0,0.3); z-index: 2;"></div>
                                                       <div class="pulse-ring"></div>
                                                   </div>`,
                                            iconSize: [20, 20],
                                            iconAnchor: [10, 10]
                                        })}
                                    />
                                </MapContainer>
                            ) : (
                                <div className="flex items-center justify-center h-full bg-gray-100 text-gray-400">Locating...</div>
                            )}
                        </div>
                    </div>
                )}
            </main>

{/* 🟢 GLOBAL COUNTRY SELECTOR MODAL */}
            {isLocationModalOpen && (
                <div className="fixed inset-0 z-[2000] bg-white flex flex-col animate-in slide-in-from-bottom-4 duration-200">
                    <div className="p-4 flex items-center gap-3 bg-white sticky top-0 shadow-sm z-10">
                        <button onClick={() => { setIsLocationModalOpen(false); setCountrySearchText(""); }} className="p-1 active:scale-90">
                            <ArrowLeft size={24} className="text-gray-700" />
                        </button>
                        <div className="flex-grow bg-gray-100 rounded-xl px-4 py-2.5 flex items-center border border-gray-200">
                            <Search size={18} className="text-gray-400 mr-2 shrink-0" />
                            <input 
                                type="text" 
                                autoFocus
                                placeholder={t('common.search', 'Search country...')}
                                value={countrySearchText}
                                onChange={(e) => setCountrySearchText(e.target.value)}
                                className="bg-transparent text-[15px] w-full outline-none text-gray-800 font-medium"
                            />
                            {countrySearchText && <X size={16} className="text-gray-400 ml-2" onClick={() => setCountrySearchText('')} />}
                        </div>
                    </div>

                    <div className="flex-grow overflow-y-auto bg-gray-50 pb-20">
                    {!countrySearchText && (
    <div 
        className="p-4 bg-white mb-2 border-b cursor-pointer active:bg-orange-50 transition-colors"
        onClick={() => {
            // 🟢 RESTORE: Get the radius we saved before opening the menu
            localStorage.setItem('is_visitor_mode', 'false');
            const savedRadius = parseFloat(localStorage.getItem('temp_saved_radius')) || 3;
            setRadius(savedRadius); 
            setIsLocationModalOpen(false);
            if (typeof setIsRefreshing === 'function') setIsRefreshing(true);
        }}
    >
        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Current Location</p>
        <div className="flex items-center gap-3 text-orange-600 font-bold">
            <Navigation size={18} />
            <span>{userLocation?.name || 'Locating...'}</span>
        </div>
    </div>
)}

                        {/* Filtered Country List */}
                        <div className="bg-white">
                            {!countrySearchText && <p className="px-4 pt-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">All Countries</p>}
                            {globalCountries
                                .filter(c => c.toLowerCase().includes(countrySearchText.toLowerCase()))
                                .map((country, idx) => (
                                    <div 
                                        key={country} 
                                       onClick={() => {
    if (typeof setCountryName === 'function') setCountryName(country);
    
    // 🟢 Only force 11km if the country has actually changed
    if (localStorage.getItem('user_country') !== country) {
        setRadius(11); 
    }
    
    localStorage.setItem('user_country', country);
    localStorage.setItem('is_visitor_mode', 'true');
    setIsLocationModalOpen(false);
    setCountrySearchText("");
    if (typeof setIsRefreshing === 'function') setIsRefreshing(true);
}}
                                        className={`p-4 border-b border-gray-50 text-[15px] font-semibold text-gray-700 active:bg-orange-50 transition-colors flex justify-between items-center ${idx === 0 ? 'border-t mt-2' : ''}`}
                                    >
                                        <span>{country}</span>
                                        {countryName === country && <Check size={18} className="text-orange-500" />}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            )}

        <>
                {viewMode === 'map' && (
              
<button onClick={() => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
            const { latitude, longitude } = position.coords;
            const newLoc = { lat: latitude, lon: longitude, name: 'Locating...', _forceMove: Date.now() };
            setUserLocation(newLoc);
            try {
                const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18`);
                const data = await res.json();
                
                // 1. Get the real country
                const detectedCountry = data.address.country || 'Burundi';
                
                // 2. Update React State
                setCountryName(detectedCountry); 
                
                // 3. 🔥 FIX: Update LocalStorage to completely wipe the Visitor Mode trace
                localStorage.setItem('user_country', detectedCountry); 
                localStorage.setItem('is_visitor_mode', 'false');
                localStorage.setItem('device_lat', latitude.toString());
                localStorage.setItem('device_lon', longitude.toString());
                
                // 🟢 NEW: Fetch the secure backup memory for the Map
                let trueRadius = 3;
                if (user?.uid) {
                    try {
                        const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
                        const snap = await getDoc(userDocRef);
                        if (snap.exists()) {
                            const data = snap.data();
                            trueRadius = data.savedLocalRadius || (data.preferredRadius < 11 ? data.preferredRadius : 3);
                        }
                    } catch(e) { console.error(e); }
                }

                setRadius(trueRadius);
                
                const realName = data.address.suburb || data.address.city || data.address.town || 'My Location';
                const finalLoc = { ...newLoc, name: realName };
                setUserLocation(finalLoc);
                setNeighborhoodName(realName);

                if (user?.uid) {
                    const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
                    await setDoc(userDocRef, { 
                        location: finalLoc, 
                        country: detectedCountry,
                        preferredRadius: trueRadius, // 🟢 Syncs the backup radius to the DB
                        updatedAt: serverTimestamp() 
                    }, { merge: true });
                }
            } catch (e) {
                console.error("GPS Reverse Geocoding failed", e);
            }
        }, (err) => alert("Please allow location access."), { enableHighAccuracy: true });
    }
}} className="fixed bottom-36 right-6 bg-white text-gray-800 p-3 rounded-full shadow-xl z-[1002] active:scale-90 transition-transform border border-gray-100">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
    </svg>
</button>
                )}

                <button onClick={() => setViewMode(viewMode === 'list' ? 'map' : 'list')} className="fixed bottom-24 right-6 bg-gray-900 text-white px-5 py-2.5 rounded-full shadow-2xl z-[1002] font-bold text-xs flex items-center gap-2 active:scale-90 transition-transform">
                    {viewMode === 'list' ? '🗺️ Map' : '📋 List'}
                </button>
            </> 
        </div> 
    );
};


const ProductDetailPage = ({ db, appId, user, t,countryName, ImageSwiper,formatPrice }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [similarProducts, setSimilarProducts] = useState([]);
    const [sellerProducts, setSellerProducts] = useState([]); // 🟢 ADD THIS
    const [isLiked, setIsLiked] = useState(false);
    const [showFullGallery, setShowFullGallery] = useState(false);

    // 🟢 Intercepts device hardware actions to cleanly dismiss full screen overlay maps/images
    useEffect(() => {
        if (showFullGallery) {
            window.history.pushState({ galleryActive: true }, '');
        }
        const handleGalleryBack = () => {
            if (showFullGallery) setShowFullGallery(false);
        };
        window.addEventListener('popstate', handleGalleryBack);
        return () => window.removeEventListener('popstate', handleGalleryBack);
    }, [showFullGallery]);

    const [liveSeller, setLiveSeller] = useState(null);
    const viewedRef = useRef(false);

    const [sellerLive, setSellerLive] = useState({ name: "", photo: "" });

  // --- THE SHIELD: Instantly bounce bad IDs back to the shop ---
    useEffect(() => {
        if (id === 'my-shop' || !id) {
            navigate('/my-shop', { replace: true });
            return;
        }
        window.scrollTo(0, 0);
    }, [id, navigate]);

useEffect(() => {
        const sellerId = product?.sellerId || product?.userId;
        if (!sellerId || !db || !appId) return;

        const modernRef = doc(db, `artifacts/${appId}/users`, sellerId);
        const unsubscribe = onSnapshot(modernRef, async (s) => {
            // 1. Grab data from the new folder (like the updated photo)
            let modernData = s.exists() ? s.data() : {};
            let legacyData = {};
            
            // 2. Grab data from the old folder (like the original nickname)
            try {
                const legacySnap = await getDoc(doc(db, "users", sellerId));
                if (legacySnap.exists()) legacyData = legacySnap.data();
            } catch(e) {}

            // 3. Merge them together!
            setLiveSeller({
                displayName: modernData.displayName || modernData.nickname || legacyData.displayName || legacyData.nickname || product?.sellerNickname || "Seller",
                photoURL: modernData.photoURL || modernData.photo || modernData.avatar || legacyData.photoURL || legacyData.photo || product?.sellerImage || ""
            });
        });
        
        return () => unsubscribe();
    }, [product?.sellerId, product?.userId, db, appId, product?.sellerNickname, product?.sellerImage]);

    // --- NATIVE SHARE LOGIC ---
    const handleShare = async () => {
        // 🟢 FIXED: Capacitor runs on localhost, so we must manually construct the real web link.
        // CHANGE THIS URL to your actual live website domain (e.g., https://madilimarket.com)
        const APP_DOMAIN = "https://madilimarket.com"; 
        const realProductLink = `${APP_DOMAIN}/product/${id}`;

        const shareData = {
            title: product?.title || 'Madili Market',
            text: `Check out this ${product?.title} on Madili Market!`,
            url: realProductLink,
        };
        
        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(realProductLink);
                alert("Link copied to clipboard!");
            }
        } catch (err) { 
            console.error('Share failed:', err); 
        }
    };
 

    // --- TIME LOGIC ---
    const formatTimeAgo = (timestamp) => {
        if (!timestamp) return "Just now";
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        const seconds = Math.floor((new Date() - date) / 1000);
        let interval = Math.floor(seconds / 31536000);
        if (interval >= 1) return interval + "y ago";
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) return interval + "mo ago";
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) return interval + "d ago";
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) return interval + "h ago";
        interval = Math.floor(seconds / 60);
        if (interval >= 1) return interval + "m ago";
        return "Just now";
    };

   

      // --- 🟢 KARROT-STYLE FETCH: Exactly Similar Items ---
    const fetchSimilarItems = async (category, currentTitle) => {
        try {
            // Fetch products in the exact same category
            const qSimilar = query(
                collection(db, `artifacts/${appId}/listings`),
                where("category", "==", category),
                limit(12) 
            );
            const similarSnap = await getDocs(qSimilar);
            
           const userHomeCountry = (localStorage.getItem('user_country') || 'Burundi').toLowerCase();
            let similarList = similarSnap.docs
                .map(d => ({ id: d.id, ...d.data() }))
                
        .filter(p => {
                    const pCountry = (p.countryCode || p.country || '').toLowerCase();
                    const matchesCountry = userHomeCountry.includes('korea') ? pCountry.includes('korea') : pCountry === userHomeCountry;
                    return p.id !== id && matchesCountry;
                });

            if (currentTitle) {
                const titleWords = currentTitle.toLowerCase().split(' ').filter(w => w.length > 2);
                similarList.sort((a, b) => {
                    let aScore = 0; let bScore = 0;
                    titleWords.forEach(w => {
                        if (a.title?.toLowerCase().includes(w)) aScore++;
                        if (b.title?.toLowerCase().includes(w)) bScore++;
                    });
                    if (bScore === aScore) return (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0);
                    return bScore - aScore;
                });
            }
            setSimilarProducts(similarList.slice(0, 6));
        } catch (err) {
            console.error("Similar Fetch Error:", err);
        }
    };
    // --- DATA SYNC & TRACKING ---
    useEffect(() => {
        if (!id || !appId || !db) return;
        const docRef = doc(db, `artifacts/${appId}/listings`, id);

        const unsubscribe = onSnapshot(docRef, (snap) => {
            if (snap.exists()) {
                const data = snap.data();
                setProduct({ id: snap.id, ...data });
                setIsLiked(!!(user && data.likedBy?.includes(user.uid)));
                
                // Trigger the new Karrot fetch logic
                if (data.category) {
                    fetchSimilarItems(data.category, data.title);
                }  


                if (user?.uid && data.category) {
                    const interestRef = doc(db, `artifacts/${appId}/users/${user.uid}/interests`, data.category);
                    setDoc(interestRef, {
                        category: data.category,
                        lastViewed: serverTimestamp(),
                        interestScore: increment(1) 
                    }, { merge: true }).catch(e => console.error(e));
                }
            }
        });

        const hasAlreadyViewed = localStorage.getItem(`viewed_${id}`);
        if (!hasAlreadyViewed && !viewedRef.current) {
            updateDoc(docRef, { views: increment(1) })
                .then(() => {
                    viewedRef.current = true;
                    localStorage.setItem(`viewed_${id}`, 'true');
                })
                .catch(e => console.error(e));
        }

        return () => unsubscribe();
    }, [id, appId, db, user?.uid]);

    // --- 3. UI RENDERING (FIXED AVATAR & NAME) ---
    if (!product) return <div className="p-10 text-center font-bold text-orange-500 italic">Loading...</div>;



  // --- CHAT LOGIC (FIXED TRANSITION DATA) ---
    const handleChat = async () => {
        if (!user || !product) return;
        
        if (user.uid === product.sellerId) {
            // ⭐ 1. SEND THE ID HERE
            navigate('/my-shop', { state: { scrollToProduct: id } });
            return;
        }

        try {
            const chatId = user.uid < product.sellerId
                ? `${user.uid}_${product.sellerId}_${id}`
                : `${product.sellerId}_${user.uid}_${id}`;

            navigate(`/messages/${chatId}`, {
                state: {
                    sellerData: {
                        id: product.sellerId,
                        // This ensures the ChatWindowPage gets the LATEST name/photo even before the first message
                        nickname: liveSeller?.displayName || liveSeller?.nickname || product.sellerNickname || "Seller",
                        photo: liveSeller?.photoURL || liveSeller?.photo || product.sellerImage || ""
                    },
                    productData: {
                        id,
                        title: product.title,
                        price: product.price,
                        imageUrl: product.imageUrl || product.imageUrls?.[0] || ""
                    }
                }
            });
        } catch (error) { 
            console.error("Navigation Error:", error); 
        }
    };

    // --- UPDATED LIKE LOGIC (Blue Thumbs Up) ---
    const handleToggleLike = async () => {
        if (!user) { alert("Please log in"); return; }
        const docRef = doc(db, `artifacts/${appId}/listings`, id);
        
        // We use 'isLiked' state to determine if we are adding or removing
        const newLikedState = !isLiked;
        
        // Optimistic UI update
        setIsLiked(newLikedState);

try {
            await updateDoc(docRef, {
                likesCount: newLikedState ? increment(1) : increment(-1),
                favorites: newLikedState ? increment(1) : increment(-1), 
                likedBy: newLikedState ? arrayUnion(user.uid) : arrayRemove(user.uid)
            });

            // 🚀 TRIGGER NOTIFICATION ONLY ON NEW LIKE
            if (newLikedState && user.uid !== product.sellerId) {
                
                // 1. In-App Notification (Firestore)
                await addDoc(collection(db, `artifacts/${appId}/notifications`), {
                    recipientId: product.sellerId,
                    senderId: user.uid,
                    senderName: user.displayName || 'User',
                    type: 'like',
                    message: "notifications.liked_your_product", 
                    productName: product.title, 
                    link: `/product/${id}`,
                    productId: id, // ⭐ ADD THIS LINE: Explicitly attach the ID
                    image: product.imageUrls?.[0] || product.imageUrl || "",
                    seen: false,
                    createdAt: serverTimestamp()
                });
          

    // 2. Real-Time Push Popup (Optional)
    if (window.NotificationService && window.NotificationService._save) {
        await window.NotificationService._save(
            db,
            product.sellerId,
            'like',
            { 
                title: t('notifications.title'), 
                msg: `${user.displayName || 'User'} ${t('notifications.liked_your_product')}` 
            },
            `/product/${id}`
        );
    }

            }
        } catch (e) {
            console.error("Like Error:", e);
            setIsLiked(!newLikedState); // Revert if failed
        }
    };

    if (!product) return <div className="p-10 text-center font-bold text-orange-500 italic">Loading...</div>;

    const images = product.imageUrls || [product.imageUrl];

    return (
        <div className="max-w-md mx-auto bg-white min-h-screen pb-24 relative shadow-2xl overflow-x-hidden font-sans">
            
            {/* NAVIGATION */}
            <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-start z-50 pointer-events-none">
                <div className="flex gap-2 pointer-events-auto">
                    <button onClick={() => navigate(-1)} className="bg-black/30 backdrop-blur-md p-2 rounded-full text-white shadow-lg"><ChevronLeft size={24} /></button>
                    <button onClick={() => navigate('/')} className="bg-black/30 backdrop-blur-md p-2 rounded-full text-white shadow-lg"><Home size={22} /></button>
                </div>
                <button onClick={handleShare} className="bg-black/30 backdrop-blur-md p-2 rounded-full text-white pointer-events-auto shadow-lg"><Share size={22} /></button>
            </div>

           {/* MAIN PICTURE */}
            <div className="relative h-[400px] w-full bg-gray-200 cursor-pointer" onClick={() => setShowFullGallery(true)}>
                <img src={images[0]} className="w-full h-full object-contain" alt={product.title} />
                {images.length > 1 && (
                    <div className="absolute bottom-4 right-4 bg-black/40 text-white text-[10px] px-2 py-1 rounded-full font-bold">1 / {images.length}</div>
                )}
            </div>

           {/* SELLER BAR */}
<div className="flex items-center justify-between p-4 border-b bg-white">
    <div className="flex items-center gap-3">
       {/* Avatar with Live Update */}
        <div className="w-12 h-12 bg-gray-100 rounded-full border border-gray-100 overflow-hidden flex-shrink-0">
            {liveSeller?.photoURL || liveSeller?.photo || product?.sellerImage ? (
                <img src={liveSeller?.photoURL || liveSeller?.photo || product?.sellerImage} className="w-full h-full object-cover" alt="" />
            ) : (
                <div className="w-full h-full flex items-center justify-center bg-orange-100 text-orange-500 font-bold text-lg">
                    {(liveSeller?.displayName || liveSeller?.nickname || product?.sellerNickname || "S").charAt(0).toUpperCase()}
                </div>
            )}
        </div>

        {/* Name with Live Update */}
        <div className="min-w-0">
            <h4 className="font-bold text-[15px] text-gray-900 truncate">
                {liveSeller?.displayName || liveSeller?.nickname || product.sellerNickname || "Seller"}
            </h4>
            <p className="text-xs text-gray-500">{product.location || "Local area"}</p>
        </div>
    </div>

    {/* Manner Temp (Karrot Style) */}
    <div className="text-right">
        <div className="flex items-center gap-1 justify-end">
            <span className="text-blue-500 font-bold text-lg">36.5°C</span>
            <span className="text-xl">😊</span>
        </div>
        <div className="w-20 h-1 bg-gray-100 rounded-full mt-1 overflow-hidden ml-auto">
            <div className="bg-blue-500 h-full w-[36.5%]" />
        </div>
        <p className="text-[10px] text-gray-400 font-bold mt-1 uppercase tracking-tighter">Manner Temp</p>
    </div>
</div>

            {/* PRODUCT INFO - Updated Stats Icons */}
            <div className="p-4 border-b">
                <h1 className="text-xl font-bold text-gray-900 leading-tight break-words">{product.title}</h1>
                <div className="flex gap-2 text-xs text-gray-400 mt-2 mb-4 font-medium">
                    <span>{product.category}</span><span>•</span><span>{formatTimeAgo(product.createdAt)}</span>
                </div>
                <p className="text-[15px] text-gray-700 whitespace-pre-line leading-relaxed break-words">{product.description}</p>
                <div className="flex gap-4 mt-6 text-xs text-gray-400 font-medium pt-4 border-t">
                    <span className="flex items-center gap-1"><MessageCircle size={14} /> {product.chats || 0} chats</span>
                    {/* CHANGED TO THUMBS UP */}
                    <span className="flex items-center gap-1 text-blue-500 font-bold">
                        <ThumbsUp size={14} className={isLiked ? "fill-blue-500" : ""} /> 
                        {product.likesCount || product.favorites || 0} likes
                    </span>
                    <span className="flex items-center gap-1"><Eye size={14} /> {product.views || 0} views</span>
                </div>
            </div>

           

           {/* 🟢 KARROT STYLE: Unified Similar Items List Context */}
            {similarProducts.length > 0 && (
                <div className="p-4 bg-gray-50 border-t border-gray-200 pb-6">
                    <h3 className="font-bold text-gray-900 text-[15px] mb-4">Similar Items</h3>
                    <div className="grid grid-cols-2 gap-3">
                        {similarProducts.map((item) => {
                            const isMine = user && (item.sellerId === user.uid || item.userId === user.uid);
                            return (
                                <div key={item.id} onClick={() => isMine ? navigate('/my-shop', { state: { scrollToProduct: item.id } }) : navigate(`/product/${item.id}`)} className="cursor-pointer bg-white p-2 rounded-xl shadow-sm active:scale-95 transition-transform group relative border">
                                    <div className="aspect-square rounded-lg overflow-hidden bg-gray-100 mb-2">
                                        <img src={item.imageUrl || item.imageUrls?.[0] || "https://placehold.co/150"} className="w-full h-full object-cover" alt="" />
                                    </div>
                                    {isMine && (<div className="absolute top-3 left-3"><span className="bg-orange-500 text-white text-[8px] px-1.5 py-0.5 rounded font-black shadow-sm">MINE</span></div>)}
                                    <p className="text-sm font-medium truncate text-gray-800">{item.title}</p>
                                    <p className="font-black text-sm text-gray-900">{formatPrice(item.price, item.countryCode || item.country || 'Burundi')}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
                   
            

            {/* BOTTOM ACTION BAR - Updated Button */}
            <div className="fixed bottom-0 max-w-md w-full bg-white border-t px-4 py-3 flex items-center gap-4 z-50 shadow-[0_-4px_10px_rgba(0,0,0,0.03)] pb-6">
                <button onClick={handleToggleLike} className="pr-4 border-r border-gray-100 transition-transform active:scale-125">
                    {/* THE NEW BLUE LIKE BUTTON */}
                    <ThumbsUp 
                        className={isLiked ? "text-blue-500 fill-blue-500" : "text-gray-300"} 
                        size={28} 
                    />
                </button>
                <div className="flex-1 min-w-0">
{/* ⭐ UPDATED MAIN PRICE */}
                    <p className="text-lg font-black text-gray-900 truncate">
                {/* SMART FETCH: 
                   Uses the user's live 'countryName' state from the GPS.
                   Works worldwide automatically.
                */}
                {formatPrice(product.price, countryName)}
            </p>
                    <button className="text-orange-500 text-xs font-bold underline">Make offer</button>
                </div>
                <button onClick={handleChat} className="bg-orange-500 text-white px-10 py-3 rounded-xl font-black text-[16px]">
                    {user?.uid === product.sellerId ? "My Shop" : "Chat"}
                </button>
            </div>

            {/* FULLSCREEN GALLERY */}
            {showFullGallery && (
                <div className="fixed inset-0 bg-black z-[100] flex flex-col items-center justify-center">
                    {/* BUG 8 FIX: Moved top-10 to top-4 and increased z-index so it doesn't hide behind mobile notches */}
                    <button onClick={() => setShowFullGallery(false)} className="absolute top-4 right-4 text-white p-2 z-[120] bg-white/20 rounded-full backdrop-blur-md active:scale-90">
                        <X size={28} />
                    </button>
                    <div className="w-full h-full flex items-center justify-center pb-8">
                        <ImageSwiper imageUrls={images} title={product.title} isFullScreen={true} />
                    </div>
                </div>
            )}
        </div>
    );
};


const initializeNotifications = async (user, db, appId) => {
    try {
        const messaging = getMessaging();
        
        // 1. Ask permission (The popup the user sees in the browser)
        const permission = await Notification.requestPermission();
        
        if (permission === 'granted') {
            // 2. Get the Token from Google
            const token = await getToken(messaging, { 
                vapidKey: "YOUR_PUBLIC_VAPID_KEY" // Generate this in Firebase Console
            });

            if (token && user) {
                // 3. Save this address to the user's Firestore profile
                // Now your database knows exactly which phone belongs to which user
                const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
                await updateDoc(userRef, { 
                    pushToken: token 
                });
            }
        }
    } catch (err) {
        console.error("Setup failed:", err);
    }
};

const notifyInterestedUsers = async (db, appId, newProduct, currentUser) => {
    try {
        const q = query(
            collectionGroup(db, 'interests'), 
            where('category', '==', newProduct.category),
            orderBy('lastViewed', 'desc'),
            limit(50) 
        );
        const querySnapshot = await getDocs(q);
        
        const notificationPromises = querySnapshot.docs.map(async (interestDoc) => {
            // Path: artifacts/{appId}/users/{userId}/interests/{interestId}
            const interestedUserId = interestDoc.ref.parent.parent.id;
            
            if (interestedUserId !== currentUser.uid) {
                // 🌐 STEP 1: Fetch recipient's language preference
                const userRef = doc(db, `artifacts/${appId}/users`, interestedUserId);
                const userSnap = await getDoc(userRef);
                const lang = userSnap.exists() ? userSnap.data().language : 'fr';

                // 🌐 STEP 2: Localized Content Logic
                const content = {
                    fr: {
                        title: 'Nouvelle Suggestion 💡',
                        msg: `Un nouveau ${newProduct.title} vient d'être publié dans ${newProduct.category} !`
                    },
                    rn: {
                        title: 'Ivyiyumviro Bishasha 💡',
                        msg: `${newProduct.title} nshasha yashizweko mu muryango wa ${newProduct.category} !`
                    },
                    sw: {
                        title: 'Pendekezo Jipya 💡',
                        msg: `${newProduct.title} mpya imewekwa katika kategoria ya ${newProduct.category} !`
                    },
                    en: {
                        title: 'New Suggestion 💡',
                        msg: `A new ${newProduct.title} was just posted in ${newProduct.category}!`
                    }
                };

                const activeContent = content[lang] || content['fr'];

                // STEP 3: Save the notification
                return addDoc(collection(db, `artifacts/${appId}/notifications`), {
                    recipientId: interestedUserId,
                    type: 'suggestion',
                    title: activeContent.title,
                    message: activeContent.msg,
                    link: `/product/${newProduct.id}`,
                    image: newProduct.imageUrl || "",
                    seen: false,
                    createdAt: serverTimestamp()
                });
            }
        });
        
        await Promise.all(notificationPromises);
    } catch (err) {
        console.error("Suggestion trigger failed:", err);
    }
};

// Add this inside your main App component or a useEffect
const setupNotifications = async (currentUser, db, appId) => {
    try {
        const messaging = getMessaging();
        
        // 1. Request permission from the browser/phone
        const permission = await Notification.requestPermission();
        
        if (permission === 'granted') {
            // 2. Get the unique token for this device
            const token = await getToken(messaging, { 
                vapidKey: "YOUR_GENERATED_VAPID_KEY_HERE" 
            });

            if (token && currentUser) {
                // 3. Save the token to the user's document
                // This allows the server to know which phone to "ping"
                const userRef = doc(db, `artifacts/${appId}/users`, currentUser.uid);
                await updateDoc(userRef, { 
                    pushToken: token,
                    notificationsEnabled: true 
                });
                console.log("Push token saved to Firestore");
            }
        }
    } catch (error) {
        console.error("Notification setup failed:", error);
    }
};

const requestNotificationPermission = async (user, db, appId) => {
  try {
    const messaging = getMessaging();
    
    // 1. Ask the user: "Can we send you notifications?"
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // 2. Get the unique token for THIS smartphone
      const token = await getToken(messaging, { 
        vapidKey: 'YOUR_PUBLIC_VAPID_KEY' // Get this from Firebase Console
      });

      // 3. Save it to Firestore so we know where to send messages later
      if (token && user) {
        const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
        await updateDoc(userRef, { pushToken: token });
        console.log("Token saved!");
      }
    }
  } catch (error) {
    console.error("Error getting token:", error);
  }
};



const AddProductPage = ({ user, db, storage, appId, t, onProductAdded, userLocation, countryName }) => { 
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [mainCategory, setMainCategory] = useState('');
    const [location, setLocation] = useState('');
    const [imageFiles, setImageFiles] = useState([]); 
    const [imagePreviews, setImagePreviews] = useState([]); 
    const [submitting, setSubmitting] = useState(false);
    const [modalMessage, setModalMessage] = useState(null); 

    // --- ⭐ GPS STATES ---
    const [coords, setCoords] = useState(null);
    const [isFetchingLocation, setIsFetchingLocation] = useState(false);

    const listingsCollectionPath = `/artifacts/${appId}/listings`;

    const mainCategories = [
        'Houses for Rent', 'Lands and Houses for Sale', 'Smartphones', 
        'Cars', 'Motorbikes and Bicycles', 'Home Appliances', 
        'Fashions', 'Foods and Drinks', 
        'Renting equipments, vehicles, and clothes for festivals', 
        'Jobs', 'Others'
    ];

    const [countryCode, setCountryCode] = useState(''); 

    useEffect(() => {
        window.scrollTo(0, 0);
        // STRICT VERIFICATION LOCKOUT: Keep form empty until GPS tap
        setCoords(null);
        setLocation("");
        setCountryCode("");
    }, []); 

    const requestLocation = async () => {
        setIsFetchingLocation(true);
        try {
            const permStatus = await Geolocation.checkPermissions();
            if (permStatus.location !== 'granted') {
                const reqStatus = await Geolocation.requestPermissions();
                if (reqStatus.location !== 'granted') {
                    alert("Please allow location permissions to tag your product.");
                    setIsFetchingLocation(false);
                    return;
                }
            }

            const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true });
            const { latitude, longitude } = position.coords;
            setCoords({ lat: latitude, lng: longitude });

            const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
            const data = await res.json();
            
            const fullCountry = data.address?.country || "Burundi"; 
            setCountryCode(fullCountry); 

            const neighborhood = data.address.suburb || data.address.city || data.address.town || "Local Area";
            setLocation(neighborhood);
        } catch (err) {
            console.error("GPS Error:", err);
            alert("Please enable GPS/Location services on your phone.");
        } finally {
            setIsFetchingLocation(false);
        }
    };
    
    // --- HELPER: NOTIFICATION LOGIC ---
    const notifyInterestedUsers = async (newProduct) => {
        try {
            const q = query(
                collectionGroup(db, 'interests'), 
                where('category', '==', newProduct.category),
                orderBy('lastViewed', 'desc'),
                limit(50) 
            );

            const querySnapshot = await getDocs(q);
            
            const notificationPromises = querySnapshot.docs.map(async (interestDoc) => {
                const interestedUserId = interestDoc.ref.parent.parent.id;

                if (interestedUserId !== user.uid) { 
                    return addDoc(collection(db, `artifacts/${appId}/notifications`), {
                        recipientId: interestedUserId,
                        type: 'suggestion',
                        title: 'New Suggestion 💡',
                        message: `A new ${newProduct.title} was just posted in ${newProduct.category}!`,
                        link: `/product/${newProduct.id}`,
                        image: newProduct.imageUrl || "",
                        seen: false,
                        createdAt: serverTimestamp()
                    });
                }
                return null;
            });

            await Promise.all(notificationPromises);
        } catch (err) {
            console.error("Suggestion trigger failed:", err);
        }
    };

    // 🟢 MEMORY-SAFE COMPRESSOR
    const compressProductImage = (file) => {
        return new Promise((resolve) => {
            try {
                const img = new window.Image();
                const objectUrl = URL.createObjectURL(file);
                
                img.onload = () => {
                    try {
                        URL.revokeObjectURL(objectUrl); 
                        const canvas = document.createElement('canvas');
                        const MAX_SIZE = 800; 
                        let width = img.width, height = img.height;
                        
                        if (width > height && width > MAX_SIZE) { height *= MAX_SIZE / width; width = MAX_SIZE; } 
                        else if (height > MAX_SIZE) { width *= MAX_SIZE / height; height = MAX_SIZE; }
                        
                        canvas.width = width; canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);
                        
                        const base64 = canvas.toDataURL('image/jpeg', 0.7);
                        
                        canvas.toBlob((blob) => {
                            resolve({ base64, blob }); 
                        }, 'image/jpeg', 0.7);
                        
                    } catch (canvasErr) {
                        alert("CANVAS ERROR: " + canvasErr.message);
                        resolve(null);
                    }
                };
                
                img.onerror = () => {
                    alert("IMAGE LOAD ERROR! The phone could not process this file format.");
                    resolve(null);
                };
                
                img.src = objectUrl;
                
            } catch (mainErr) {
                alert("COMPRESSOR CRASH: " + mainErr.message);
                resolve(null);
            }
        });
    };

    // 🟢 NATIVE PLUGIN REMOVED - PURE WEB LOGIC
    const handleFileChange = async (e) => {
        try {
            const files = Array.from(e.target.files);
            const validFiles = files.filter(file => file.type.startsWith('image/'));
            
            if (imageFiles.length + validFiles.length > 10) {
                alert(t ? t('common.limit_reached', 'Max 10 photos allowed.') : 'Max 10 photos.'); 
                return;
            }

            let newBlobs = [], newPreviews = [];
            
            for (let file of validFiles) {
                const compressed = await compressProductImage(file);
                if (compressed) {
                    newBlobs.push(compressed.blob);      
                    newPreviews.push(compressed.base64); 
                }
            }

            setImageFiles(prev => [...prev, ...newBlobs]);
            setImagePreviews(prev => [...prev, ...newPreviews]);
            
        } catch (fileErr) {
            alert("FILE SELECTION CRASH: " + fileErr.message);
        } finally {
            e.target.value = '';
        }
    };


    const handleRemoveImage = (indexToRemove) => {
        setImageFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
        setImagePreviews(prevPreviews => {
            URL.revokeObjectURL(prevPreviews[indexToRemove]);
            return prevPreviews.filter((_, index) => index !== indexToRemove);
        });
    };

    const handleAddListing = async (e) => {
        e.preventDefault();

        if (!coords) {
            setModalMessage({ title: "Location Missing", body: "Please tap the GPS icon to set your neighborhood.", type: "error" });
            return;
        }

        if (!mainCategory) {
            setModalMessage({ 
                title: t('errors.category_missing_title'), 
                body: t('errors.category_missing_body'), 
                type: "error" 
            });
            return;
        }

        setSubmitting(true);
        if (!user) {
            setModalMessage({ title: "Error", body: "You must be logged in.", type: "error" });
            setSubmitting(false);
            return;
        }
        
      try {
        let isFlaggedByAI = false;
        
        // --- ADD YOUR FIREBASE AI CHECK HERE LATER IF NEEDED ---
// 🟢 AUTOMATIC IMAGE TRACKER: Run the AI checker
        if (imageFiles.length > 0) {
            setModalMessage({ title: "Scanning...", body: "Running security check on images...", type: "success" });
            
            for (let file of imageFiles) {
                try {
                    const isUnsafe = await analyzeImageSafety(file); 
                    if (isUnsafe) {
                        // 🚨 HARD STOP: Do not upload to Firebase Storage at all!
                        setSubmitting(false);
                        setModalMessage({ 
                            title: "Upload Blocked 🚨", 
                            body: "Your image violates community safety guidelines (Inappropriate content detected).", 
                            type: "error" 
                        });
                        return; // This immediately kills the upload process
                    }
                } catch (aiError) {
                    console.error("AI Check Failed:", aiError);
                }
            }
        }

          let imageUrls = []; 
            if (imageFiles.length > 0) {
                const uploadPromises = imageFiles.map(async (blob, index) => {
                    const storageRef = ref(storage, `listings/${user.uid}/${Date.now()}_${index}.jpg`);
                    const snapshot = await uploadBytes(storageRef, blob);
                    return await getDownloadURL(snapshot.ref);
                });
                imageUrls = await Promise.all(uploadPromises);
            }

        const productRef = await addDoc(collection(db, listingsCollectionPath), {
            title, 
            description, 
            price: Number(price), 
            category: mainCategory, 
            location, 
            countryCode, 
            latitude: coords.lat,  
            longitude: coords.lng, 
            imageUrls,
            sellerId: user.uid, 
            createdAt: serverTimestamp(),
            status: isFlaggedByAI ? 'flagged' : 'active', 
        });

            await notifyInterestedUsers({
                id: productRef.id,
                title,
                category: mainCategory,
                imageUrl: imageUrls[0] || ""
            });

            setModalMessage({
                title: "Success! 🎉", 
                body: t("create_listing_success") || "Your item is now live!", 
                type: "success"
            });

            setTitle(''); setDescription(''); setPrice(''); setImageFiles([]); setImagePreviews([]);

            setTimeout(() => {
                navigate('/my-shop');
            }, 2000);

        } catch (error) {
            console.error("Error adding listing:", error);
            setModalMessage({ title: "Error", body: error.message, type: "error" });
        } finally {
            setSubmitting(false);
        }
    };

    const MessageModal = ({ message, onClose }) => {
        if (!message) return null;
        const isError = message.type === 'error';

        const handleButtonClick = () => {
            onClose();
            if (message.type === 'success') {
                navigate('/my-shop'); 
            }
        };

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                <div className={`bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full border-t-4 ${isError ? 'border-red-400' : 'border-green-500'}`}>
                    <h3 className={`text-xl font-bold mb-2 ${isError ? 'text-red-600' : 'text-green-600'}`}>{message.title}</h3>
                    <p className="text-gray-700 text-sm">{message.body}</p>
                    <button onClick={handleButtonClick} className={`mt-4 w-full py-2 rounded-lg font-semibold text-white ${isError ? 'bg-red-500' : 'bg-green-500'}`}>
                        {t('common.close') || 'Close'}
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4 font-['Inter']">
            <MessageModal message={modalMessage} onClose={() => setModalMessage(null)} />
            <div className="mb-20">
                <h2 className="text-3xl font-extrabold text-gray-900 my-6 text-center">{t('sell_item') || 'Sell Your Item'}</h2>
                <form onSubmit={handleAddListing} className="bg-white p-6 rounded-2xl shadow-xl max-w-lg mx-auto border border-gray-100">
                    <div className="mb-5">
                        <label className="block text-gray-700 font-medium mb-2">{t('title_label')}</label>
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 focus:ring-4 focus:ring-orange-200 outline-none" required />
                    </div>
                    <div className="mb-5">
                        <label className="block text-gray-700 font-medium mb-2">{t('description_label')}</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 focus:ring-4 focus:ring-orange-200 outline-none" rows="3" required />
                    </div>
                    
                    <div className="mb-5">
                        <label className="block text-gray-700 font-medium mb-2">{t('location_placeholder')}</label>
                        <div className="relative flex items-center">
                            <input 
                                type="text" 
                                value={coords ? location : ""}
                                readOnly 
                                placeholder="Tap GPS icon to set neighborhood"
                                className="w-full border border-gray-300 rounded-lg p-3 bg-gray-50 focus:ring-4 focus:ring-orange-200 outline-none pr-12" 
                                required 
                            />
                            <button 
                                type="button"
                                onClick={requestLocation}
                                className={`absolute right-2 p-2 transition ${isFetchingLocation ? 'text-orange-500 animate-spin' : 'text-gray-400 hover:text-orange-500'}`}
                            >
                                <Navigation size={22} />
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 mb-5">
                        <div className="w-full sm:w-1/2">
                            <label className="block text-gray-700 font-medium mb-2">{t('price_label')}</label>
                            <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} className="w-full border border-gray-300 rounded-lg p-3 focus:ring-4 focus:ring-orange-200 outline-none" required />
                        </div>
                       <div className="w-full sm:w-1/2">
                            <label className="block text-gray-700 font-medium mb-2">{t('category_label')}</label>
                            <div className="relative">
                                <select 
                                    value={mainCategory} 
                                    onChange={(e) => setMainCategory(e.target.value)} 
                                    className="w-full border border-gray-300 rounded-lg p-3 bg-white focus:ring-4 focus:ring-orange-200 outline-none appearance-none pr-10 text-gray-800"
                                >
                                    <option value="" disabled>Select a category...</option>
                                    {mainCategories.map(catKey => (
                                        <option key={catKey} value={catKey}>{t(`categories.${catKey}`) || catKey}</option>
                                    ))}
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                                    <svg className="w-4 h-4 text-orange-500 fill-current" viewBox="0 0 24 24">
                                        <polygon points="5,9 19,9 12,17" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-8">
                        <label className="block text-gray-700 font-medium mb-2">
                            {t('image_upload_label') || 'Product Pictures'} 📸 
                            <span className="ml-2 text-sm font-bold text-orange-500">({imageFiles.length}/10)</span>
                        </label>
                        <div className="flex flex-wrap gap-3 p-3 border border-gray-200 rounded-lg bg-gray-50">
                            {imagePreviews.map((previewUrl, index) => (
                                <div key={index} className="relative w-20 h-20 rounded-lg overflow-hidden border-2 border-orange-500">
                                    <img src={previewUrl} alt="preview" className="w-full h-full object-cover" />
                                    <button type="button" onClick={() => handleRemoveImage(index)} className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">&times;</button>
                                </div>
                            ))}
                          {imageFiles.length < 10 && (
                                <div 
                                    className="w-20 h-20 border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center text-gray-500 cursor-pointer hover:border-orange-500 bg-white"
                                    onClick={async () => {
                                        if (Capacitor.isNativePlatform()) {
                                            try {
                                                let perm = await CapacitorCamera.checkPermissions();
                                                if (perm.photos !== 'granted') {
                                                    perm = await CapacitorCamera.requestPermissions({ permissions: ['photos'] });
                                                }
                                                if (perm.photos !== 'granted') {
                                                    alert("Please allow photo gallery permissions in your settings to select images.");
                                                    return;
                                                }
                                            } catch (e) { console.error("Permission error", e); }
                                        }
                                        document.getElementById('product-image-input').click();
                                    }}
                                >
                                    <span className="text-2xl">+</span>
                                    <input id="product-image-input" type="file" multiple onChange={handleFileChange} className="hidden" accept="image/*" />
                                </div>
                            )}
                            
                        </div>
                    </div>
                    <button type="submit" disabled={submitting} className="w-full bg-orange-500 text-white p-3.5 rounded-xl font-bold text-lg hover:bg-orange-600 disabled:bg-gray-400 transition">
                        {submitting ? t('common.loading') || 'Processing...' : t('add_product')}
                    </button>
                </form>
            </div>
        </div>
    );
};

// --- Helper Function: Merges and sorts chats from buyer and seller queries ---
const mergeAndSort = (arr1, arr2) => {
    const combined = [...arr1, ...arr2];
    
    // Remove duplicates based on chat ID
    const uniqueMap = combined.reduce((map, item) => {
        map.set(item.id, item);
        return map;
    }, new Map());
    
    const unique = Array.from(uniqueMap.values());
    
    // Sort by lastUpdated (newest first)
    unique.sort((a, b) => (b.lastUpdated?.toMillis() || 0) - (a.lastUpdated?.toMillis() || 0));
    
    return unique;
};

const ChatWindowPage = ({ user, db, appId, storage,t }) => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [chatData, setChatData] = useState(null);
  const [replyTo, setReplyTo] = useState(null);
  const scrollRef = useRef();
  const location = useLocation(); 
  
  const [mediaUrls, setMediaUrls] = useState([]); // Now it's always defined!
  // Add this near your other state definitions (around line 15)
const chat = chatData;

  // Media & Interaction States
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]); 
  const [isSending, setIsSending] = useState(false); 
  
  const mediaRecorder = useRef(null);
  const audioChunks = useRef([]);
  const timerRef = useRef(null);
  const longPressTimer = useRef(null);

  // UI States
  const [activeMenu, setActiveMenu] = useState(null);
  const [lightbox, setLightbox] = useState({ isOpen: false, images: [], index: 0 });
  // 🟢 PERFECTIONIST FIX: Intercept Hardware Back Button for Menus & Images
  useEffect(() => {
      if (activeMenu || lightbox.isOpen) {
          window.history.pushState({ popup: 'open' }, '');
      }
      const handleHardwareBack = () => {
          if (activeMenu) setActiveMenu(null);
          if (lightbox.isOpen) setLightbox(prev => ({ ...prev, isOpen: false }));
      };
      window.addEventListener('popstate', handleHardwareBack);
      return () => window.removeEventListener('popstate', handleHardwareBack);
  }, [activeMenu, lightbox.isOpen]);
 
  

// Keep your state for when it's available (internal navigation)
const { state } = useLocation();

// Create a state that can update if the database provides the name later
const [otherUserLive, setOtherUserLive] = useState({
    name: state?.sellerData?.nickname || "...", 
    photo: state?.sellerData?.photo || ""
});
useEffect(() => {
        if (!chatData?.participants) return;
        const otherId = chatData.participants.find(id => id !== user.uid);
        if (!otherId) return;

        const modernRef = doc(db, `artifacts/${appId}/users`, otherId);
        const unsubscribe = onSnapshot(modernRef, (docSnap) => {
            if (docSnap.exists()) {
                const d = docSnap.data();
                setOtherUserLive({
                    name: d.displayName || d.nickname || chatData.participantNames?.[otherId] || state?.sellerData?.nickname || "Seller",
                    photo: d.photoURL || d.photo || chatData.participantPhotos?.[otherId] || state?.sellerData?.photo || ""
                });
            }
        });
        return unsubscribe;
    }, [chatData, db, appId, user.uid, state?.sellerData]);

   // 🟢 FIXED: Actively fetch the Chat Document to retrieve missing Product Info
  useEffect(() => {
      if (!chatId || !db) return;
      const chatRef = doc(db, `artifacts/${appId}/chats`, chatId);
      const unsubscribe = onSnapshot(chatRef, (docSnap) => {
          if (docSnap.exists()) {
              setChatData({ id: docSnap.id, ...docSnap.data() });
          }
      });
      return unsubscribe;
  }, [chatId, db, appId]);

useEffect(() => {
    if (!chatId || !db) return;
    const q = query(collection(db, `artifacts/${appId}/chats/${chatId}/messages`), orderBy('createdAt', 'asc'));
 const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setMessages(prev => {
        if (msgs.length > prev.length) {
          setTimeout(() => scrollRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
        }
        return msgs;
      });
    });
    return unsubscribe;
  }, [chatId, db, appId]);

useEffect(() => {
    if (!chatId || !db || !user || messages.length === 0) return;

    const markAsRead = async () => {
        try {
            // 1. Identify messages that are UNREAD and NOT sent by me
            const unreadMessages = messages.filter(m => m.senderId !== user.uid && !m.seen);
            
            if (unreadMessages.length > 0) {
                const batch = writeBatch(db);
                
                // Add each unread message to the batch
                unreadMessages.forEach((msg) => {
                    const msgRef = doc(db, `artifacts/${appId}/chats/${chatId}/messages`, msg.id);
                    batch.update(msgRef, { seen: true });
                });

                // 2. Clear the main chat badge in the same transaction
                const chatRef = doc(db, `artifacts/${appId}/chats`, chatId);
                batch.update(chatRef, { unreadCount: 0 });

                // Execute all updates at once
                await batch.commit();
            } else {
                // Even if no specific messages are unread, ensure the badge is 0 
                // (This handles cases where the count gets out of sync)
                const chatRef = doc(db, `artifacts/${appId}/chats`, chatId);
                const chatSnap = await getDoc(chatRef);
                if (chatSnap.exists() && chatSnap.data().unreadCount > 0 && chatSnap.data().lastSenderId !== user.uid) {
                    await updateDoc(chatRef, { unreadCount: 0 });
                }
            }
            
            // 3. Clear global notifications for THIS chat
            // This handles the notification list you see in your screenshots
            const notificationsRef = collection(db, `artifacts/${appId}/notifications`);
            const q = query(
                notificationsRef, 
                where("recipientId", "==", user.uid), 
                where("link", "==", `/messages/${chatId}`),
                where("seen", "==", false)
            );
            
            const notifSnap = await getDocs(q);
            if (!notifSnap.empty) {
                const notifBatch = writeBatch(db);
                notifSnap.docs.forEach(d => notifBatch.update(d.ref, { seen: true }));
                await notifBatch.commit();
            }

        } catch (err) {
            console.error("Error marking messages as read:", err);
        }
    };

    markAsRead();
}, [messages, chatId, user.uid, appId, db]);

  const handleDelete = async (msgId) => {
    try {
      await deleteDoc(doc(db, `artifacts/${appId}/chats/${chatId}/messages`, msgId));
      setActiveMenu(null);
    } catch (err) { console.error("Delete failed", err); }
  };

  const handleSingleImageDelete = async (msgId, imageUrl) => {
    try {
      const msg = messages.find(m => m.id === msgId);
      if (!msg) return;
      if (msg.mediaUrls.length <= 1) {
        await deleteDoc(doc(db, `artifacts/${appId}/chats/${chatId}/messages`, msgId));
      } else {
        const updatedUrls = msg.mediaUrls.filter(url => url !== imageUrl);
        await updateDoc(doc(db, `artifacts/${appId}/chats/${chatId}/messages`, msgId), {
          mediaUrls: updatedUrls
        });
      }
      setLightbox({ ...lightbox, isOpen: false });
    } catch (err) { console.error("Single delete failed", err); }
  };

  const handlePressStart = (msgId) => {
    longPressTimer.current = setTimeout(() => {
      setActiveMenu(msgId);
    }, 700);
  };

  const handlePressEnd = () => {
    if (longPressTimer.current) clearTimeout(longPressTimer.current);
  };

  // 🟢 Native Image Compressor (800px, 70% quality for extreme speed)
  const compressImage = (file) => {
      return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {
              const img = new window.Image();
              img.src = e.target.result;
              img.onload = () => {
                  const canvas = document.createElement('canvas');
                  const MAX_SIZE = 800;
                  let width = img.width, height = img.height;
                  if (width > height && width > MAX_SIZE) { height *= MAX_SIZE / width; width = MAX_SIZE; } 
                  else if (height > MAX_SIZE) { width *= MAX_SIZE / height; height = MAX_SIZE; }
                  canvas.width = width; canvas.height = height;
                  const ctx = canvas.getContext('2d');
                  ctx.drawImage(img, 0, 0, width, height);
                  resolve(canvas.toDataURL('image/jpeg', 0.7)); 
              };
          };
      });
  };

const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => file.type.startsWith('image/'));
    if (selectedFiles.length + validFiles.length > 5) {
        alert(t ? t('common.limit_reached', 'Max 5 photos.') : 'Max 5 photos.'); return;
    }

    for (let file of validFiles) {
        const compressedPreview = await compressImage(file);
        file.safePreview = compressedPreview;
        setSelectedFiles(prev => [...prev, file]);
    }
    e.target.value = ''; 
  };



const sendMessage = async (e) => {
    if (e) e.preventDefault();
    if (!newMessage.trim() && selectedFiles.length === 0) return;
    
    const shouldShowSpinner = selectedFiles.length > 0 || (replyTo && replyTo.messageType !== 'text');
    if (shouldShowSpinner) setIsSending(true);

    try {
        
     let mediaUrls = [];
        
        // 🟢 PARALLEL COMPRESSION & UPLOAD (SUPER FAST + CAPACITOR SAFE)
        if (selectedFiles.length > 0) {
            const uploadPromises = selectedFiles.map(async (file, index) => {
                    const storageRef = ref(storage, `chat_images/${user.uid}/${Date.now()}_${index}`);
                    const response = await fetch(file.safePreview);
                    const pureBlob = await response.blob();
                    const snapshot = await uploadBytes(storageRef, pureBlob);
                    return await getDownloadURL(snapshot.ref);
                });
                mediaUrls = await Promise.all(uploadPromises);
        }
        

        const chatRef = doc(db, `artifacts/${appId}/chats`, chatId);
        const chatSnap = await getDoc(chatRef);
        const isNewChat = !chatSnap.exists();

        // STEP A: Create the Chat Shell ONLY if it doesn't exist yet
        if (isNewChat && state?.sellerData) {
            await setDoc(chatRef, {
                participants: [user.uid, state.sellerData.id],
                participantNames: {
                    [user.uid]: user.displayName || "Buyer",
                    [state.sellerData.id]: state.sellerData.nickname
                },
                participantPhotos: {
                    [user.uid]: user.photoURL || "",
                    [state.sellerData.id]: state.sellerData.nickname ? "" : state.sellerData.photo // Fix fallback
                },
                sellerId: state.sellerData.id,
                productInfo: state.productData,
                createdAt: serverTimestamp(),
                lastUpdated: serverTimestamp(),
                unreadCount: 0 
            });
            
            await updateDoc(doc(db, `artifacts/${appId}/listings`, state.productData.id), { chats: increment(1) });

          await addDoc(collection(db, `artifacts/${appId}/notifications`), {
    recipientId: state.sellerData.id,
    type: 'chat_interest',
    senderName: user.displayName || "Someone",
    productTitle: state.productData.title, // Save the title separately
    // We save the KEY instead of the full sentence
    message: "notifications.chat_interest_msg", 
    link: `/messages/${chatId}`,
    productId: state.productData.id,
    image: state.productData.imageUrl || state.productData.imageUrls?.[0] || "",
    seen: false,
    createdAt: serverTimestamp()
});
        } 

    

        // STEP B: Send the actual message
        await addDoc(collection(db, `artifacts/${appId}/chats/${chatId}/messages`), {
            text: newMessage,
            mediaUrls,
            messageType: mediaUrls.length > 0 ? 'images' : 'text',
            senderId: user.uid,
            createdAt: serverTimestamp(),
            replyTo: replyTo ? { 
                text: replyTo.text, 
                id: replyTo.id, 
                messageType: replyTo.messageType, 
                mediaUrl: replyTo.mediaUrl || (replyTo.mediaUrls?.[0] || null),
                moreCount: replyTo.moreCount || 0
            } : null,
            seen: false
        });

// STEP B.2: Add a notification document
// The "if" below prevents the "participants of null" crash
if (chatData && chatData.participants) {
    const targetRecipientId = chatData.participants.find(id => id !== user.uid);
    
    if (targetRecipientId) {
        await addDoc(collection(db, `artifacts/${appId}/notifications`), {
            recipientId: targetRecipientId,
            type: 'chat_start',
            senderName: user.displayName || "User",
            senderId: user.uid,
            // Automatically handles Text or Photo icons
            message: newMessage || (selectedFiles.length > 0 ? "Sent a photo 📷" : "New message"),
            link: `/messages/${chatId}`,
            image: chatData.productInfo?.imageUrl || "", 
            seen: false,
            createdAt: serverTimestamp()
        });
    }
}

 // STEP C: Update Chat Preview & Unread Status
await updateDoc(chatRef, {
    // Matches the camera icon logic in MessagesPage
    lastMessage: newMessage || (mediaUrls.length > 0 ? "Photo 📷" : "Message"),
    lastUpdated: serverTimestamp(),
    lastSenderId: user.uid,
    unreadCount: increment(1) 
});



        setNewMessage('');
        setSelectedFiles([]);
        setReplyTo(null);
    } catch (err) { 
        console.error("Send error:", err); 
    } finally { 
        setIsSending(false); 
    }
};

  const startRecording = async () => {
    try {
      // FIX: Explicitly request permission and add mobile constraints
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      mediaRecorder.current = new MediaRecorder(stream);
      audioChunks.current = [];
      mediaRecorder.current.ondataavailable = (e) => audioChunks.current.push(e.data);
      mediaRecorder.current.onstop = async () => {
        setIsSending(true);
        try {
          const finalDuration = formatDuration(recordingTime);
          const audioBlob = new Blob(audioChunks.current); 
          const fileName = `audio_${Date.now()}.mp4`;
          const storageRef = ref(storage, `artifacts/${appId}/chats/${chatId}/${fileName}`);
          const snapshot = await uploadBytes(storageRef, audioBlob);
          const url = await getDownloadURL(snapshot.ref);

          const chatRef = doc(db, `artifacts/${appId}/chats`, chatId);
          const chatSnap = await getDoc(chatRef);
          const isNewChat = !chatSnap.exists();

          if (isNewChat && state?.sellerData) {
            await setDoc(chatRef, {
              participants: [user.uid, state.sellerData.id],
              participantNames: {
                [user.uid]: user.displayName || "Buyer",
                [state.sellerData.id]: state.sellerData.nickname
              },
              participantPhotos: {
                [user.uid]: user.photoURL || "",
                [state.sellerData.id]: state.sellerData.photo || ""
              },
              sellerId: state.sellerData.id,
              productInfo: state.productData,
              createdAt: serverTimestamp(),
              lastUpdated: serverTimestamp(),
              unreadCount: 0 
            });

            await addDoc(collection(db, `artifacts/${appId}/notifications`), {
              recipientId: state.sellerData.id,
              type: 'chat_interest',
              message: `${user.displayName || "A user"} is interested in your ${state.productData.title}`,
              link: `/messages/${chatId}`,
              image: state.productData.imageUrl || state.productData.imageUrls?.[0] || "",
              seen: false,
              createdAt: serverTimestamp()
            });

            await updateDoc(doc(db, `artifacts/${appId}/listings`, state.productData.id), { chats: increment(1) });
          }
          
          await addDoc(collection(db, `artifacts/${appId}/chats/${chatId}/messages`), {
            text: newMessage, 
            mediaUrls: [url], 
            messageType: 'audio', 
            audioDuration: finalDuration,
            senderId: user.uid, 
            createdAt: serverTimestamp(), 
            seen: false,
            replyTo: replyTo ? { 
              text: replyTo.text, 
              id: replyTo.id, 
              messageType: replyTo.messageType, 
              mediaUrl: replyTo.mediaUrl || (replyTo.mediaUrls?.[0] || null),
              moreCount: replyTo.moreCount || 0
            } : null
          });

          if (chatData && chatData.participants) {
              const targetRecipientId = chatData.participants.find(id => id !== user.uid);
              if (targetRecipientId) {
                  await addDoc(collection(db, `artifacts/${appId}/notifications`), {
                      recipientId: targetRecipientId,
                      type: 'chat_start',
                      senderName: user.displayName || "User",
                      message: "Sent a voice message 🎤",
                      link: `/messages/${chatId}`,
                      seen: false,
                      createdAt: serverTimestamp()
                  });
              }
          }

          await updateDoc(chatRef, {
            lastMessage: "Voice message 🎤",
            lastUpdated: serverTimestamp(),
            lastSenderId: user.uid,
            unreadCount: increment(1) 
          });

          setNewMessage('');
          setReplyTo(null);
        } catch (err) { 
          console.error("Audio send error:", err); 
        } finally { 
          setIsSending(false); 
        }
      };
      
      mediaRecorder.current.start();
      setIsRecording(true);
      setRecordingTime(0);
      timerRef.current = setInterval(() => setRecordingTime(p => p + 1), 1000);
    } catch (err) { 
      // FIX: Alert the user if they deny the permission on their smartphone
      console.error("Microphone permission denied:", err);
      alert("Please allow microphone permissions in your phone settings to send voice messages.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorder.current && isRecording) {
      mediaRecorder.current.stop();
      setIsRecording(false);
      clearInterval(timerRef.current);
    }
  };

  const formatDuration = (s) => `${Math.floor(s/60)}:${(s%60).toString().padStart(2,'0')}`;
  const formatTime = (ts) => {
    if (!ts || !ts.toDate) return "";
    const date = ts.toDate();
    const now = new Date();
    const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    if (diffInDays === 1) {
        return `${t('common.yesterday')} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

  return (
    <div className="flex flex-col h-screen bg-white max-w-md mx-auto shadow-2xl overflow-hidden relative font-sans">
      
     {/* 🟢 MOBILE-OPTIMIZED GALLERY LIGHTBOX */}
      {lightbox.isOpen && (
        <div className="fixed inset-0 bg-black/95 z-[9999] flex flex-col pb-6">
          
          {/* Top Action Bar */}
          <div className="flex items-center justify-between p-3 sm:p-5 z-[110] w-full">
             <div className="flex gap-3 sm:gap-6 overflow-x-auto no-scrollbar pr-2">
                {messages.find(m => m.mediaUrls?.includes(lightbox.images[lightbox.index]))?.senderId !== user.uid && (
                  <>
                    <button onClick={() => {
                       const currentMsg = messages.find(m => m.mediaUrls?.includes(lightbox.images[lightbox.index]));
                       setReplyTo({ ...currentMsg, mediaUrl: lightbox.images[lightbox.index], moreCount: 0 });
                       setLightbox({ ...lightbox, isOpen: false });
                    }} className="text-white flex flex-col items-center gap-1 active:scale-90 transition-transform">
                        <Reply size={24} />
                        <span className="text-[10px] font-bold">Répondre</span>
                    </button>

                    <button onClick={async () => {
                       const res = await fetch(lightbox.images[lightbox.index]);
                       const blob = await res.blob();
                       const url = window.URL.createObjectURL(blob);
                       const a = document.createElement('a'); a.href = url; a.download = `IMG_${Date.now()}.jpg`; a.click();
                    }} className="text-white flex flex-col items-center gap-1 active:scale-90 transition-transform">
                        <Download size={24} />
                        <span className="text-[10px] font-bold">Enregistrer</span>
                    </button>
                  </>
                )}
                <button onClick={() => {
                   const currentMsg = messages.find(m => m.mediaUrls?.includes(lightbox.images[lightbox.index]));
                   if(window.confirm("Supprimer cette image?")) { handleSingleImageDelete(currentMsg.id, lightbox.images[lightbox.index]); }
                }} className="text-white flex flex-col items-center gap-1 active:scale-90 transition-transform">
                    <Trash2 size={24} />
                    <span className="text-[10px] font-bold">Supprimer</span>
                </button>
             </div>
             
             {/* Close Button pushed safely to the right */}
             <button onClick={() => setLightbox({ ...lightbox, isOpen: false })} className="text-white ml-auto active:scale-90 transition-transform shrink-0">
                 <XCircle size={32} />
             </button>
          </div>

          {/* Image Area with Responsive Arrows */}
          <div className="flex-1 relative flex items-center justify-center w-full touch-none px-1">
            
            {/* Left Arrow (Shrinks on mobile, grows on PC) */}
            {lightbox.images.length > 1 && (
                <button onClick={(e) => { e.stopPropagation(); setLightbox({...lightbox, index: (lightbox.index - 1 + lightbox.images.length) % lightbox.images.length})}} 
                        className="absolute left-2 sm:left-6 text-white bg-black/50 p-2 sm:p-3 rounded-full z-[110] active:scale-90 transition-transform">
                    <ChevronLeft size={28} className="sm:w-10 sm:h-10" />
                </button>
            )}
            
            <img 
                src={lightbox.images[lightbox.index]} 
                className="max-w-full max-h-[80vh] object-contain shadow-2xl" 
                alt="Selected" 
            />
            
            {/* Right Arrow */}
            {lightbox.images.length > 1 && (
                <button onClick={(e) => { e.stopPropagation(); setLightbox({...lightbox, index: (lightbox.index + 1) % lightbox.images.length})}} 
                        className="absolute right-2 sm:right-6 text-white bg-black/50 p-2 sm:p-3 rounded-full z-[110] active:scale-90 transition-transform">
                    <ChevronRight size={28} className="sm:w-10 sm:h-10" />
                </button>
            )}
          </div>
        </div>
      )}

{/* Header */}
{/* Header */}
<div className="flex items-center p-3 border-b bg-white z-20 sticky top-0">
    <button 
      onClick={() => {
        // If there is no history (entry from notification), go to the messages list.
        // Otherwise, go back normally.
        if (window.history.length <= 2) {
          navigate('/messages'); 
        } else {
          navigate(-1);
        }
      }} 
      className="mr-3 text-gray-600"
    >
        <ChevronLeft size={24} />
    </button>
    
    <div className="w-10 h-10 rounded-full bg-orange-100 overflow-hidden mr-3 shrink-0 border border-gray-100 flex items-center justify-center">
        {otherUserLive.photo ? (
            <img src={otherUserLive.photo} className="w-full h-full object-cover" alt="" />
        ) : (
            <div className="text-orange-500 font-bold text-lg">
                {/* Safe check: use first letter of name, or 'U' if name is empty */}
                {(otherUserLive.name || state?.sellerData?.nickname || "U").charAt(0).toUpperCase()}
            </div>
        )}
    </div>

    <div className="flex flex-col min-w-0">
        <h2 className="font-bold text-[16px] text-gray-900 truncate">
            {/* Fallback to state data if live listener hasn't finished yet */}
            {otherUserLive.name || state?.sellerData?.nickname || "Loading..."}
        </h2>
    {/* Optional: Add "Seller" label to make it look professional */}
        <span className="text-[10px] text-gray-400 font-medium -mt-1">
            
        </span>
    </div>
</div>

      {/* 🟢 KARROT STYLE: Sticky Product Briefing Header (Safe Render) */}
      {(chatData?.productInfo || state?.productData) && (
          <div 
              onClick={() => {
                  const targetId = (chatData?.productInfo || state?.productData).id;
                  if (targetId) navigate(`/product/${targetId}`);
              }} 
              className="bg-white border-b px-4 py-3 flex items-center gap-3 cursor-pointer active:bg-gray-50 transition-colors z-10 sticky top-[65px] shadow-sm"
          >
              <img 
                  src={(chatData?.productInfo || state?.productData).imageUrl || (chatData?.productInfo || state?.productData).imageUrls?.[0] || 'https://placehold.co/150'} 
                  className="w-11 h-11 rounded-md object-cover border border-gray-100 shrink-0" 
                  alt="Product" 
              />
              <div className="flex flex-col min-w-0 flex-1 justify-center">
                  <div className="flex items-center gap-1.5 truncate">
                      <span className="text-[13px] font-extrabold text-gray-800">
                          {(chatData?.productInfo || state?.productData).status === 'sold' ? 'Sold' : (chatData?.productInfo || state?.productData).status === 'reserved' ? 'Reserved' : 'Active'}
                      </span>
                      <span className="text-[13px] text-gray-700 truncate">
                          {(chatData?.productInfo || state?.productData).title || 'Product Loading...'}
                      </span>
                  </div>
                  <span className="text-[15px] font-black text-gray-900 mt-0.5">
                      {(chatData?.productInfo || state?.productData).price ? (chatData?.productInfo || state?.productData).price.toLocaleString() : "---"} {t ? t('common.currency', 'FBu') : 'FBu'}
                  </span>
              </div>
              <div className="text-gray-400">
                  <ChevronRight size={20} />
              </div>
          </div>
      )}

      {/* Messages */}
      <div className="flex-1 overflow-y-auto space-y-6 p-4 pb-48">
        {messages.map((msg) => {
          const isMe = msg.senderId === user.uid;
          const isAudio = msg.messageType === 'audio';
          const isImage = msg.messageType === 'images';

          return (
            <div key={msg.id} id={`msg-${msg.id}`} className={`flex flex-col ${isMe ? 'items-end' : 'items-start'} w-full`}>
              
              {msg.replyTo && (
                <div 
                  onClick={() => document.getElementById(`msg-${msg.replyTo.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
                  className={`text-[10px] mb-1 p-2 rounded-lg border-l-4 flex gap-2 items-center cursor-pointer max-w-[80%] ${isMe ? 'bg-orange-500 text-white border-white' : 'bg-gray-200 border-gray-400 text-gray-700'}`}
                >
                  {msg.replyTo.mediaUrl && (
                    <div className="relative shrink-0">
                      <img src={msg.replyTo.mediaUrl} className="w-8 h-8 rounded object-cover" alt="re" />
                      {msg.replyTo.moreCount > 0 && <div className="absolute inset-0 bg-black/40 rounded flex items-center justify-center text-[8px] text-white">+{msg.replyTo.moreCount}</div>}
                    </div>
                  )}
                  <div className="truncate">
                    <p className="font-bold opacity-70 text-[8px]">Réponse à :</p>
                    <p className="truncate italic">
                      {msg.replyTo.text || (msg.replyTo.messageType === 'audio' ? "Message vocal" : "Photo")}
                    </p>
                  </div>
                </div>
              )}

              {/* 🟢 FIXED: Added onContextMenu preventDefault to stop the phone's native "Copy/Save" popup from blocking our reply menu! */}
              <div 
                onPointerDown={() => handlePressStart(msg.id)} 
                onPointerUp={handlePressEnd} 
                onPointerLeave={handlePressEnd}
                onContextMenu={(e) => e.preventDefault()} 
                className="flex flex-col max-w-[85%] relative select-none"
              >

              {isImage && (
                  <div className="grid grid-cols-2 gap-1 w-full max-w-[240px] mb-1">
                    {msg.mediaUrls.slice(0, 4).map((url, idx) => (
                        <div key={idx} className="relative aspect-square">
                            <img src={url} onClick={() => setLightbox({ isOpen: true, images: msg.mediaUrls, index: idx })} className="object-cover w-full h-full rounded-xl" alt="c" />
                            {idx === 3 && msg.mediaUrls.length > 4 && <div className="absolute inset-0 bg-black/50 rounded-xl flex items-center justify-center text-white font-bold">+{msg.mediaUrls.length - 3}</div>}
                        </div>
                    ))}
                  </div>
                )}
                
                {isAudio && (
                  <div className="flex flex-col gap-1 mb-1 bg-gray-100/50 p-2 rounded-xl border border-gray-100">
                    <audio controls controlsList="nodownload noplaybackrate" className="h-8 w-44">
                        <source src={msg.mediaUrls[0]} type="audio/webm" />
                    </audio>
                    {msg.audioDuration && <span className="text-[10px] font-bold text-gray-500 px-1">{msg.audioDuration}</span>}
                  </div>
                )}

                {msg.text && (
                  <div className={`px-3 py-2 rounded-2xl text-[14px] leading-tight break-words shadow-sm ${isMe ? 'bg-orange-500 text-white rounded-tr-none' : 'bg-gray-100 text-gray-800 rounded-tl-none'}`}>
                    {msg.text}
                  </div>
                )}

                <div className={`flex items-center gap-1 mt-1 ${isMe ? 'justify-end' : 'justify-start'}`}>
                  <span className="text-[9px] font-bold text-gray-400">{formatTime(msg.createdAt)}</span>
                  {isMe && <span className="text-orange-500">{msg.seen ? <CheckCheck size={12} strokeWidth={3} /> : <Check size={12} strokeWidth={3} />}</span>}
                </div>

                {activeMenu === msg.id && (
                  <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/10" onClick={() => setActiveMenu(null)}>
                    <div className="bg-white shadow-2xl rounded-2xl p-1 min-w-[180px]" onClick={(e) => e.stopPropagation()}>
                        {!isMe && (
                            <button onClick={() => { 
                                setReplyTo({ ...msg, mediaUrl: msg.mediaUrls?.[0] || null, moreCount: msg.mediaUrls?.length > 1 ? msg.mediaUrls.length - 1 : 0 }); 
                                setActiveMenu(null); 
                            }} className="flex items-center gap-3 w-full px-4 py-3 text-sm font-bold text-blue-600 border-b">
                                <Reply size={18} /> Répondre
                            </button>
                        )}
                        <button onClick={() => handleDelete(msg.id)} className="flex items-center gap-3 w-full px-4 py-3 text-sm font-bold text-red-600 border-b"><Trash2 size={18} /> Supprimer</button>
                        <button onClick={() => setActiveMenu(null)} className="flex items-center gap-3 w-full px-4 py-3 text-sm font-bold text-gray-400"><XCircle size={18} /> Annuler</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        <div ref={scrollRef} />
      </div>


      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t p-3 z-[60] shadow-[0_-5px_15px_rgba(0,0,0,0.1)]">
        {replyTo && (
          <div className="bg-gray-50 border-l-4 border-orange-500 p-2 mb-2 flex justify-between items-center rounded-r-lg">
            <div className="flex items-center gap-2 overflow-hidden">
                {replyTo.mediaUrl && (
                    <div className="relative shrink-0">
                        <img src={replyTo.mediaUrl} className="w-10 h-10 object-cover rounded" alt="re" />
                        {replyTo.moreCount > 0 && <div className="absolute inset-0 bg-black/40 rounded flex items-center justify-center text-[10px] text-white font-bold">+{replyTo.moreCount}</div>}
                    </div>
                )}
                {!replyTo.mediaUrl && replyTo.messageType === 'audio' && <div className="w-10 h-10 bg-orange-100 flex items-center justify-center rounded shrink-0"><Mic size={18} className="text-orange-600" /></div>}
                <div className="text-xs text-gray-500 truncate italic">
                    <span className="font-bold text-orange-600 block">Réponse à :</span>
                    {replyTo.text || (replyTo.messageType === 'audio' ? "Message vocal" : "Photo")}
                </div>
            </div>
            <button onClick={() => setReplyTo(null)} className="p-1"><XCircle size={18} className="text-gray-400" /></button>
          </div>
        )}

       {selectedFiles.length > 0 && (
          <div className="flex gap-2 overflow-x-auto py-1 mb-2 no-scrollbar">
            {selectedFiles.map((f, i) => (
              <div key={i} className="relative shrink-0 w-16 h-16">
                {/* 🟢 FIXED: Changed 'file' to 'f' to match your map function */}
                <img src={f.safePreview || URL.createObjectURL(f)} alt="preview" className="w-full h-full object-cover rounded-md" />
                
                <button onClick={() => setSelectedFiles(selectedFiles.filter((_, idx) => idx !== i))} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-0.5">
                    <XCircle size={12} />
                </button>
              </div>
            ))}
          </div>
        )}

       <div className="flex items-center gap-2">
         <div 
              className="p-2 text-gray-400 cursor-pointer active:scale-90 transition-transform"
              onClick={async () => {
                  if (Capacitor.isNativePlatform()) {
                      try {
                          let perm = await CapacitorCamera.checkPermissions();
                          if (perm.photos !== 'granted') {
                              perm = await CapacitorCamera.requestPermissions({ permissions: ['photos'] });
                          }
                          if (perm.photos !== 'granted') {
                              alert("Please allow photo gallery permissions to send images.");
                              return;
                          }
                      } catch (e) { console.error("Permission error", e); }
                  }
                  document.getElementById('chat-image-input').click();
              }}
          >
              <ImageIcon size={24} />
              <input id="chat-image-input" type="file" multiple accept="image/*" onChange={handleFileSelect} className="hidden" />
          </div>
         <input 
            value={newMessage} onChange={(e) => setNewMessage(e.target.value)}
            placeholder={isRecording ? `Enregistrement... ${formatDuration(recordingTime)}` : "Écrire..."} 
            className="flex-1 bg-gray-100 rounded-full px-4 py-2 text-sm focus:outline-none"
            onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
          />
         {/* 🟢 MIC ICON: Only visible when NOT recording */}
          {!isRecording && (
              <button type="button" onClick={startRecording} className="p-2 text-gray-500 active:scale-90 transition-transform">
                  <Mic size={24} />
              </button>
          )}
          
          {/* 🟢 MASTER SEND BUTTON: Acts as 'Stop & Send' when recording */}
          <button 
              onClick={(e) => {
                  e.preventDefault();
                  if (isRecording) {
                      stopRecording(); // This stops and automatically sends the voice
                  } else {
                      sendMessage();
                  }
              }} 
              className={`text-white p-2.5 rounded-full shadow-lg flex items-center justify-center transition-all active:scale-95 
                ${isRecording ? 'bg-red-500 animate-pulse' : 'bg-orange-500'}`}
          >
            {isSending ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : isRecording ? (
                <Send size={20} className="rotate-90" /> // Visual cue: Send the audio
            ) : (
                <Send size={20} />
            )}
          </button>
        </div>
      </div>
      <style>{` .no-scrollbar::-webkit-scrollbar { display: none; } `}</style>
    </div>
  );
};

// Helper to show the User's Photo live
const LiveChatAvatar = ({ userId, db, appId, fallback, name }) => {
    const [photo, setPhoto] = useState(fallback);

    useEffect(() => {
        if (!userId || !db || !appId) return;
        const userRef = doc(db, `artifacts/${appId}/users`, userId);
        return onSnapshot(userRef, (docSnap) => {
            if (docSnap.exists()) {
                setPhoto(docSnap.data().photoURL || docSnap.data().photo || fallback);
            }
        });
    }, [userId, db, appId, fallback]);

    return photo ? (
        <img src={photo} className="w-full h-full object-cover" alt="" />
    ) : (
        <div className="w-full h-full flex items-center justify-center text-orange-400 font-bold text-lg">
            {name?.charAt(0).toUpperCase()}
        </div>
    );
};



const MessagesPage = ({ user, db, appId, t,countryName}) => {
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all'); 
    const navigate = useNavigate();

    // Long Press Logic
    const [longPressedChat, setLongPressedChat] = useState(null);
    const timerRef = useRef(null);
    const touchStartPos = useRef(null);

    // --- NEW: Smart Date Formatter ---
    const formatChatDate = (timestamp) => {
        if (!timestamp || !timestamp.toDate) return "";
        const date = timestamp.toDate();
        const now = new Date();
        const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

        if (diffInDays === 0) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
        if (diffInDays === 1) {
            return t('common.yesterday'); // Make sure this is in your translations
        }
        return date.toLocaleDateString();
    };

    useEffect(() => {
    window.scrollTo(0, 0);
}, []);

    useEffect(() => {
        if (!user || !db || !appId) return;

        const q = query(
            collection(db, `artifacts/${appId}/chats`),
            where('participants', 'array-contains', user.uid)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const chatList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })).sort((a, b) => {
                const aPinned = a.isPinned ? 1 : 0;
                const bPinned = b.isPinned ? 1 : 0;
                if (bPinned !== aPinned) return bPinned - aPinned;
                return (b.lastUpdated?.seconds || 0) - (a.lastUpdated?.seconds || 0);
            });
            
            setChats(chatList);
            setLoading(false);
        });

        return unsubscribe;
    }, [user, db, appId]);

    // Long Press Handlers
    const handlePressStart = (e, chatId) => {
        touchStartPos.current = { y: e.clientY || e.touches?.[0].clientY };
        timerRef.current = setTimeout(() => {
            setLongPressedChat(chatId);
        }, 600);
    };

    const handlePressMove = (e) => {
        if (!touchStartPos.current) return;
        const currentY = e.clientY || e.touches?.[0].clientY;
        const diffY = Math.abs(currentY - touchStartPos.current.y);
        if (diffY > 10) handlePressEnd();
    };

    const handlePressEnd = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        touchStartPos.current = null;
    };

    const togglePin = async (chat) => {
        if (!chat) return;
        try {
            const chatRef = doc(db, `artifacts/${appId}/chats`, chat.id);
            await updateDoc(chatRef, { isPinned: !chat.isPinned });
            setLongPressedChat(null);
        } catch (err) { console.error("Pin error:", err); }
    };

    const deleteConversation = async (chatId) => {
        if (window.confirm(t('shop.delete_confirm'))) {
            try {
                await deleteDoc(doc(db, `artifacts/${appId}/chats`, chatId));
                setLongPressedChat(null);
            } catch (err) { console.error("Delete error:", err); }
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
                <span className="ml-3 text-gray-500 italic">{t('common.loading_listings')}</span>
            </div>
        );
    }

    const filteredChats = chats.filter(chat => {
        const isMeTheSeller = chat.sellerId === user.uid;
        if (filter === 'selling') return isMeTheSeller;
        if (filter === 'buying') return !isMeTheSeller;
        if (filter === 'unread') return chat.lastSenderId !== user.uid && (chat.unreadCount || 0) > 0;
        return true; 
    });

    return (
        <div className="max-w-md mx-auto bg-white min-h-screen pb-20 shadow-lg font-sans relative select-none">
            {/* Header */}
            <div className="sticky top-0 bg-white z-20 border-b">
                <div className="p-4">
                    <h1 className="text-xl font-black text-gray-900">{t('my_messages_heading')}</h1>
                </div>
                <div className="flex px-2 overflow-x-auto no-scrollbar">
                    {['all', 'buying', 'selling', 'unread'].map((f) => (
                        <button
                            key={f}
                            onClick={() => setFilter(f)}
                            className={`flex-1 min-w-[80px] py-3 text-sm font-bold border-b-2 transition-colors ${
                                filter === f ? 'border-orange-500 text-orange-500' : 'border-transparent text-gray-400'
                            }`}
                        >
                            {t(`chat_tab_${f}`)}
                        </button>
                    ))}
                </div>
            </div>

            {/* Chat List */}
            <div className="divide-y divide-gray-100">
                {filteredChats.length === 0 ? (
                    <div className="p-20 text-center text-gray-400 text-sm">{t('no_chats_found')}</div>
                ) : (
     filteredChats.map((chat) => {
    const otherUserId = chat.participants?.find(id => id !== user.uid);
    const unreadCount = chat.unreadCount || 0;
    const isUnread = chat.lastSenderId !== user.uid && unreadCount > 0;

    const fallbackName = chat.participantNames?.[otherUserId] || chat.sellerNickname || t('placeholders.unknown_item');
    const fallbackPhoto = chat.participantPhotos?.[otherUserId] || "";

    return (
        <div
            key={chat.id}
            onPointerDown={(e) => handlePressStart(e, chat.id)}
            onPointerMove={handlePressMove}
            onPointerUp={handlePressEnd}
            onPointerLeave={handlePressEnd}
            onClick={() => !longPressedChat && navigate(`/messages/${chat.id}`)}
            className={`flex flex-col p-4 cursor-pointer relative transition-all active:bg-gray-50 ${
                isUnread ? 'bg-orange-50/40' : chat.isPinned ? 'bg-gray-50/50' : 'bg-white'
            }`}
        >
            {/* Pin Icon */}
            {chat.isPinned && (
                <div className="absolute top-2 right-2 text-orange-500">
                    <Pin size={12} fill="currentColor" />
                </div>
            )}

            {/* Top Row: Avatar, Name, and Date */}
            <div className="flex justify-between items-start w-full">
                <LiveChatParticipant 
                    userId={otherUserId}
                    db={db}
                    appId={appId}
                    fallbackName={fallbackName}
                    fallbackPhoto={fallbackPhoto}
                    isUnread={isUnread}
                />
                <span className="text-[10px] text-gray-400 whitespace-nowrap ml-2 pt-1">
                    {formatChatDate(chat.lastUpdated)}
                </span>
            </div>

            {/* Bottom Row: Message Preview and Product Info */}
            <div className="ml-[60px] -mt-4">
                <div className="flex justify-between items-center gap-2">
                    <p className={`text-sm truncate flex-1 ${isUnread ? 'text-black font-semibold' : 'text-gray-400'}`}>
                        {chat.lastMessage === "Photo 📷" ? (
                            <span className="flex items-center gap-1 text-orange-600 font-bold italic">
                                <Camera size={14} /> {t('chat.photo_sent')}
                            </span>
                        ) : (
                            chat.lastMessage || t('chat_unread_badge')
                        )}
                    </p>
                    
                    {/* Unread Badge (inline with message) */}
                    {isUnread && (
                        <div className="min-w-[18px] h-[18px] px-1 bg-orange-600 rounded-full flex items-center justify-center border border-white flex-shrink-0">
                            <span className="text-white text-[9px] font-black">{unreadCount > 9 ? '9+' : unreadCount}</span>
                        </div>
                    )}
                </div>

                {/* Compact Product Info */}
{chat.productInfo && (
                                        <div className="flex items-center mt-2 bg-gray-50 rounded-lg p-1.5 w-fit max-w-full border border-gray-100 shadow-sm">
                                            <img src={chat.productInfo.imageUrl} className="w-7 h-7 rounded object-cover flex-shrink-0" alt="" />
                                            <div className="ml-2 truncate max-w-[120px]">
                                                <span className="text-[11px] text-gray-700 font-semibold truncate block">{chat.productInfo.title}</span>
                                                <span className="text-[10px] text-orange-600 font-bold">
                                                    {formatPrice(chat.productInfo.price, countryName)}
                                                </span>
                                            </div>
                    </div>
                )}
            </div>
        </div>
    );
                    })
                )}
            </div>

            {/* Options Menu (Long Press) */}
            {longPressedChat && (
                <div className="fixed inset-0 bg-black/40 z-[100] flex items-end sm:items-center justify-center animate-in fade-in duration-200" onClick={() => setLongPressedChat(null)}>
                    <div className="bg-white w-full max-w-sm rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl transition-transform" onClick={e => e.stopPropagation()}>
                        <div className="p-4 bg-gray-50 text-center text-[10px] font-black text-gray-400 uppercase tracking-widest border-b">
                            {t('common.options')}
                        </div>
                        
                        <button 
                            onClick={() => togglePin(chats.find(c => c.id === longPressedChat))}
                            className="w-full p-5 text-left font-bold flex items-center gap-4 border-b hover:bg-gray-50 active:bg-gray-100"
                        >
                            <Pin size={20} className={chats.find(c => c.id === longPressedChat)?.isPinned ? "text-orange-500" : "text-gray-400"} />
                            <span className="text-gray-700">
                                {chats.find(c => c.id === longPressedChat)?.isPinned ? t('messages.unpin') : t('messages.pin')}
                            </span>
                        </button>
                        
                        <button 
                            onClick={() => deleteConversation(longPressedChat)}
                            className="w-full p-5 text-left font-bold flex items-center gap-4 border-b text-red-600 hover:bg-red-50 active:bg-red-100"
                        >
                            <Trash2 size={20} /> {t('shop.action_delete')}
                        </button>
                        
                        <button 
                            onClick={() => setLongPressedChat(null)}
                            className="w-full p-5 text-center font-bold text-gray-400 hover:bg-gray-50"
                        >
                            {t('common.close')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

const LiveChatParticipant = ({ userId, db, appId, fallbackName, fallbackPhoto, isUnread }) => {
    const [live, setLive] = useState({ name: fallbackName, photo: fallbackPhoto });

    useEffect(() => {
        if (!userId || !db || !appId) return;
        return onSnapshot(doc(db, `artifacts/${appId}/users`, userId), (s) => {
            if (s.exists()) {
                const d = s.data();
                setLive({
                    name: d.displayName || d.nickname || fallbackName,
                    photo: d.photoURL || d.photo || fallbackPhoto
                });
            }
        });
    }, [userId, db, appId]);

    return (
        <div className="flex items-center flex-1 min-w-0">
            {/* Avatar */}
            <div className="w-12 h-12 rounded-full bg-orange-100 border border-orange-50 overflow-hidden flex-shrink-0">
                {live.photo ? (
                    <img src={live.photo} className="w-full h-full object-cover" alt="" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-orange-400 font-bold text-lg">
                        {live.name.charAt(0).toUpperCase()}
                    </div>
                )}
            </div>
            {/* Name */}
            <h3 className={`ml-3 text-[15px] truncate ${isUnread ? 'font-black text-black' : 'font-bold text-gray-700'}`}>
                {live.name}
            </h3>
        </div>
    );
};




const ChatListItem = ({ chat, currentUserId, onClick }) => {
    // Logic to determine role and other participant remains the same (perfect)
    const otherParticipantId = chat.sellerId === currentUserId ? chat.buyerId : chat.sellerId;
    const isSeller = chat.sellerId === currentUserId;
    
    return (
        <div 
            className="p-4 border border-gray-200 rounded-xl bg-white shadow-lg cursor-pointer transition-all duration-200 
                       hover:shadow-xl hover:border-orange-400" // Hover effects use orange
            onClick={onClick}
        >
            <div className="flex justify-between items-start">
                {/* Product Title - Changed color to match Madili Market orange */}
                <p className="font-bold text-lg text-orange-600 truncate">{chat.listingTitle || "Unknown Product"}</p>
                
                {/* Role Tag - Uses orange/gray palette */}
                <span className={`text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap ml-4 ${
                    isSeller 
                    ? 'bg-orange-100 text-orange-800' // Seller role: Light orange background
                    : 'bg-gray-100 text-gray-700'     // Buyer role: Light gray background
                }`}>
                    {isSeller ? 'Seller' : 'Buyer'}
                </span>
            </div>
            
            <p className="text-sm text-gray-700 mt-1 line-clamp-1">
                {chat.lastMessage ? `Last message: "${chat.lastMessage}"` : "Start the conversation!"}
            </p>
            
            <p className="text-xs text-gray-500 mt-2">
                Talking with: <span className="font-mono text-gray-600">{otherParticipantId.substring(0, 8)}...</span>
            </p>
            
            <p className="text-xs text-gray-400 mt-1">
                {chat.lastUpdated ? new Date(chat.lastUpdated.seconds * 1000).toLocaleString() : 'New Chat'}
            </p>
        </div>
    );
};
 




const AdminSupport = ({ db, auth }) => {
    const [tickets, setTickets] = useState([]);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [replyText, setReplyText] = useState('');
    const chatEndRef = useRef(null);

    // 1. Listen for ALL tickets
    useEffect(() => {
        if (!db) return;
        const q = query(collection(db, "support_tickets")); 
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const ticketData = snapshot.docs.map(doc => ({ 
                id: doc.id, 
                ...doc.data() 
            }));
            console.log("Admin Side - Found tickets:", ticketData);
            setTickets(ticketData);
        }, (error) => {
            console.error("Admin Side - Fetch error:", error);
        });

        return () => unsubscribe();
    }, [db]);

    // 2. Listen for messages in a selected ticket
    useEffect(() => {
        if (!selectedTicket || !db) return;
        
        // Removed orderBy temporarily to prevent "Missing Index" errors
        const q = collection(db, "support_tickets", selectedTicket.id, "messages");
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // Sort manually in JS to avoid needing a Firestore Index immediately
            const sortedMsgs = msgs.sort((a, b) => (a.timestamp?.seconds || 0) - (b.timestamp?.seconds || 0));
            setMessages(sortedMsgs);
        });
        return () => unsubscribe();
    }, [selectedTicket, db]);

    const handleSelectTicket = async (ticket) => {
        setSelectedTicket(ticket);
        try {
            await updateDoc(doc(db, "support_tickets", ticket.id), {
                unreadByAdmin: false
            });
        } catch (err) {
            console.error("Failed to clear admin notification:", err);
        }
    };

    const handleSendReply = async () => {
        if (!replyText.trim() || !selectedTicket) return;

        const textToSend = replyText.trim();
        setReplyText(''); 

        try {
            await addDoc(collection(db, "support_tickets", selectedTicket.id, "messages"), {
                text: textToSend,
                senderName: "Admin / Joseph",
                timestamp: serverTimestamp(),
                isAdmin: true 
            });
            
            await updateDoc(doc(db, "support_tickets", selectedTicket.id), {
                lastMessage: `Admin: ${textToSend}`,
                updatedAt: serverTimestamp(),
                status: "replied",
                unreadByAdmin: false,
                unreadByUser: true 
            });
        } catch (error) {
            console.error("Error sending reply:", error);
        }
    };

    return (
        <div className="flex h-screen bg-gray-100 p-4 gap-4 font-sans">
            {/* Left Side: Ticket List */}
            <div className="w-1/3 bg-white rounded-xl shadow-md overflow-hidden flex flex-col border border-gray-200">
                <h2 className="p-4 font-bold border-b bg-gray-800 text-white flex justify-between items-center">
                    Support Tickets
                    <span className="bg-blue-500 text-[10px] px-2 py-1 rounded-full">
                        {tickets.length} Active
                    </span>
                </h2>
                <div className="flex-grow overflow-y-auto">
                    {tickets.length === 0 ? (
                        <p className="p-10 text-center text-gray-400 text-sm italic">No tickets found.</p>
                    ) : (
                        tickets.map(ticket => (
                            <div 
                                key={ticket.id} 
                                onClick={() => handleSelectTicket(ticket)}
                                className={`p-4 border-b cursor-pointer transition-colors hover:bg-blue-50 ${selectedTicket?.id === ticket.id ? 'bg-blue-100' : ''}`}
                            >
                                <div className="flex justify-between items-start mb-1">
                                    <p className="font-bold text-sm text-gray-800 truncate w-4/5">{ticket.userEmail}</p>
                                    {ticket.unreadByAdmin && (
                                        <span className="w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white shadow-sm"></span>
                                    )}
                                </div>
                                <p className="text-xs text-gray-500 truncate">{ticket.lastMessage}</p>
                                <p className="text-[9px] text-gray-400 mt-2 uppercase font-black">
                                    Status: {ticket.status || 'open'}
                                </p>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* Right Side: Chat Window */}
            <div className="w-2/3 bg-white rounded-xl shadow-md flex flex-col border border-gray-200">
                {selectedTicket ? (
                    <>
                        <div className="p-4 border-b font-bold bg-blue-600 text-white flex justify-between items-center">
                            <span>Chatting with {selectedTicket.userName || selectedTicket.userEmail}</span>
                            <button 
                                onClick={() => setSelectedTicket(null)}
                                className="text-xs bg-blue-700 hover:bg-blue-800 px-2 py-1 rounded"
                            >
                                Close Chat
                            </button>
                        </div>
                        
                        <div className="flex-grow p-4 overflow-y-auto space-y-4 bg-gray-50">
                            {messages.map((msg) => (
                                <div key={msg.id} className={`flex ${msg.isAdmin ? 'justify-end' : 'justify-start'}`}>
                                    <div className={`max-w-[75%] p-3 rounded-2xl shadow-sm ${msg.isAdmin ? 'bg-blue-500 text-white' : 'bg-white border border-gray-200 text-gray-800'}`}>
                                        <p className="text-[10px] opacity-75 mb-1 font-bold">
                                            {msg.isAdmin ? "You" : (msg.senderName || "User")}
                                        </p>
                                        <p className="text-sm leading-relaxed">{msg.text}</p>
                                    </div>
                                </div>
                            ))}
                            <div ref={chatEndRef} />
                        </div>

                        <div className="p-4 border-t bg-white flex gap-2 items-center">
                            <input 
                                type="text" 
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleSendReply()}
                                className="flex-grow border border-gray-300 rounded-xl p-3 text-sm outline-none focus:ring-2 focus:ring-blue-400 transition-all"
                                placeholder="Write your reply and press Enter..."
                            />
                            <button 
                                onClick={handleSendReply} 
                                disabled={!replyText.trim()}
                                className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white px-6 py-3 rounded-xl font-bold transition-all active:scale-95"
                            >
                                Reply
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="flex-grow flex flex-col items-center justify-center text-gray-400 space-y-2">
                        <div className="text-5xl">💬</div>
                        <p className="font-medium">Select a ticket from the left to start helping your users.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

// --- 1. NEW COMPONENT: ANALYTICS VISUALIZER (Add this above AdminAdsPage) ---
const AnalyticsChart = ({ ads }) => {
    const totalClicks = ads.reduce((acc, ad) => acc + (ad.clicks || 0), 0);
    const maxClicks = Math.max(...ads.map(a => a.clicks || 0), 1);

    return (
        <div className="bg-white p-6 rounded-3xl shadow-xl border-2 border-orange-50 mb-8 mt-2">
            <div className="flex justify-between items-end mb-6">
                <div>
                    <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Total Engagement</h3>
                    <p className="text-3xl font-black text-orange-600">{totalClicks.toLocaleString()}</p>
                </div>
                <div className="text-right">
                    <span className="text-[10px] bg-green-100 text-green-600 px-2 py-1 rounded-full font-bold uppercase tracking-tighter">
                        {ads.length} Active Ads
                    </span>
                </div>
            </div>

            {/* Bar Chart representing top ads */}
            <div className="flex items-end justify-between h-24 gap-2 px-1">
                {ads.slice(0, 7).map((ad, i) => (
                    <div key={i} className="flex-grow flex flex-col items-center group">
                        <div 
                            style={{ height: `${((ad.clicks || 0) / maxClicks) * 100}%`, minHeight: '8%' }}
                            className="w-full bg-orange-400 rounded-t-md group-hover:bg-orange-600 transition-all relative"
                        >
                             <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-[8px] font-black text-orange-700">
                                {ad.clicks || 0}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            <p className="text-[9px] text-center text-gray-400 mt-4 font-black uppercase tracking-widest">Ad Performance Distribution</p>
        </div>
    );
};

// --- 2. UPDATED ADMIN PAGE ---
const AdminAdsPage = ({ t, db, storage, user, ADMIN_UID, appId }) => {
    const [title, setTitle] = React.useState('');
    const [targetArea, setTargetArea] = React.useState('Global');
    const [adMedia, setAdMedia] = React.useState(null);
    const [mediaType, setMediaType] = React.useState('image'); // Tracks if it is 'image' or 'video'
    const [loading, setLoading] = React.useState(false);
    const [actionType, setActionType] = React.useState('website');
    const [actionValue, setActionValue] = React.useState('');
    const [duration, setDuration] = React.useState('1');
    const [activeAds, setActiveAds] = React.useState([]);

    const countries = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
        "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
        "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
        "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
        "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary",
        "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan",
        "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
        "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
        "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
        "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Urguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    useEffect(() => {
        if (user?.uid !== ADMIN_UID) return;
        const q = query(collection(db, "artifacts", appId, "ads"), orderBy("createdAt", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setActiveAds(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, [db, appId, user?.uid, ADMIN_UID]);

    const handleDeleteAd = async (adId, imageUrl) => {
        if (!window.confirm("Are you sure you want to delete this ad?")) return;
        try {
            await deleteDoc(doc(db, "artifacts", appId, "ads", adId));
            if (imageUrl) {
                const imageRef = ref(storage, imageUrl);
                await deleteObject(imageRef).catch(e => console.log("Storage delete skipped"));
            }
        } catch (error) {
            alert("Delete failed: " + error.message);
        }
    };

    const calculateExpiryDate = (daysStr) => {
        const days = parseInt(daysStr);
        const date = new Date();
        if (days >= 60 && days <= 300) {
            date.setMonth(date.getMonth() + (days / 30));
        } else if (days === 365) {
            date.setFullYear(date.getFullYear() + 1);
        } else {
            date.setDate(date.getDate() + days);
        }
        return date;
    };

    // 🟢 NEW: File Selection Handler with 60s Video Limit
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type.startsWith('video/')) {
            // Check video duration before allowing upload
            const videoElement = document.createElement('video');
            videoElement.preload = 'metadata';
            
            videoElement.onloadedmetadata = function() {
                window.URL.revokeObjectURL(videoElement.src);
                const vidDuration = videoElement.duration;
                
                if (vidDuration > 60) {
                    alert(`Video is too long (${Math.round(vidDuration)} seconds). Maximum allowed is 60 seconds.`);
                    e.target.value = ''; // Clear the input
                    setAdMedia(null);
                } else {
                    setMediaType('video');
                    setAdMedia(file);
                }
            }
            videoElement.src = URL.createObjectURL(file);
        } else if (file.type.startsWith('image/')) {
            setMediaType('image');
            setAdMedia(file);
        } else {
            alert("Please upload a valid image or video file.");
            e.target.value = '';
        }
    };

   const handlePostAd = async () => {
        if (!adMedia) return alert("Please select an image or video");
        const currentTitle = (title || "").trim();
        const currentActionValue = (actionValue || "").trim();
        if (!currentTitle || !currentActionValue) return alert("Fill all fields");

        setLoading(true);
        try {
            const finalActionValue = currentActionValue.startsWith('http') ? currentActionValue : `https://${currentActionValue}`;
            const fileName = `${Date.now()}_ad`;
            const storageRef = ref(storage, `ads/${fileName}`);
            
            // 🟢 COMPRESS IMAGES (Ignore videos)
            let fileToUpload = adMedia;
            if (mediaType === 'image') {
                fileToUpload = await compressImage(adMedia);
            }

            const snapshot = await uploadBytes(storageRef, fileToUpload);
            const imageUrl = await getDownloadURL(snapshot.ref);
            const expiryDate = calculateExpiryDate(duration);

            await addDoc(collection(db, "artifacts", appId, "ads"), {
                title: currentTitle,
                imageUrl, // We keep the name 'imageUrl' so we don't break old data, even if it's a video
                mediaType: mediaType, // 🟢 CRUCIAL: Tells the feed to render a video player or an image tag
                targetScope: targetArea === "Global" ? "worldwide" : "country",
                targetValue: targetArea,
                actionType: actionType || "website",
                actionValue: finalActionValue,
                createdAt: serverTimestamp(),
                expiresAt: Timestamp.fromDate(expiryDate),
                adType: "team_sponsored",
                createdBy: user.uid,
                isAd: true,
                clicks: 0
            });

            alert(`Ad Published!`);
            setTitle('');
            setAdMedia(null);
            setActionValue('');
            document.getElementById('admin-ad-upload').value = ''; // Reset UI
        } catch (error) {
            alert("Error: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    if (user?.uid !== ADMIN_UID) return <div className="p-10 text-center">Unauthorized Access</div>;

    return (
        <div className="p-6 max-w-md mx-auto mb-20 bg-gray-50 min-h-screen">
            <h2 className="text-2xl font-black mb-6 uppercase text-orange-600 text-center tracking-tighter">Madili Ad Manager</h2>
            
            {/* 📊 ANALYTICS VIEW */}
            <AnalyticsChart ads={activeAds} />

            {/* 📢 POST AD FORM */}
            <details className="mb-10 group bg-white rounded-3xl shadow-md overflow-hidden border border-orange-100">
                <summary className="list-none p-4 font-black text-center text-xs uppercase cursor-pointer bg-orange-50 text-orange-600 group-open:bg-white transition-colors">
                    + Create New Campaign
                </summary>
                <div className="p-4 space-y-4">
                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} 
                           className="w-full border p-3 rounded-xl text-sm" placeholder="Campaign Title" />

                    <div className="grid grid-cols-2 gap-2">
                        <div>
                            <label className="text-[9px] font-black uppercase text-gray-400 ml-1">Target</label>
                            <select value={targetArea} onChange={(e) => setTargetArea(e.target.value)} 
                                    className="w-full border p-2 rounded-xl bg-gray-50 text-xs font-bold mt-1">
                                <option value="Global">🌍 Global</option>
                                {countries.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="text-[9px] font-black uppercase text-gray-400 ml-1">Duration</label>
                            <select value={duration} onChange={(e) => setDuration(e.target.value)} 
                                    className="w-full border p-2 rounded-xl bg-gray-50 text-xs font-bold mt-1">
                                <option value="1">1 Day</option>
                        <option value="7">1 Week</option>
                        <option value="14">2 Weeks</option>
                        <option value="30">4 Weeks (1 Month)</option>
                        <option value="60">2 Months</option>
                        <option value="120">4 Months</option>
                        <option value="180">6 Months</option>
                        <option value="240">8 Months</option>
                        <option value="300">10 Months</option>
                        <option value="365">1 Year</option>
                            </select>
                        </div>
                    </div>

                    <input type="text" value={actionValue} onChange={(e) => setActionValue(e.target.value)} 
                           className="w-full border p-3 rounded-xl text-sm" placeholder="Website or WhatsApp Number" />

                   <div className="border border-dashed border-gray-300 p-4 rounded-xl text-center bg-gray-50">
                        <label className="text-[10px] font-bold text-gray-500 block mb-2">Upload Image or Video (Max 60s)</label>
                        <input 
                            id="admin-ad-upload"
                            type="file" 
                            onChange={handleFileSelect} 
                            className="text-[10px] w-full" 
                            accept="image/*,video/*" 
                        />
                    </div>


                    <button onClick={handlePostAd} disabled={loading} className="w-full bg-orange-600 text-white py-3 rounded-xl font-black shadow-lg">
                        {loading ? "PROCESSING..." : "ACTIVATE CAMPAIGN"}
                    </button>
                </div>
            </details>

            {/* 📋 LIVE CAMPAIGNS LIST */}
            <h3 className="text-xs font-black uppercase text-gray-400 mb-4 ml-2 tracking-widest">Active Campaigns ({activeAds.length})</h3>
            <div className="space-y-3">
                {activeAds.map(ad => (
                    <div key={ad.id} className="bg-white border border-gray-100 rounded-2xl p-3 flex items-center gap-4 shadow-sm">
                        <img src={ad.imageUrl} alt="" className="w-12 h-12 rounded-lg object-cover bg-gray-100" />
                        <div className="flex-grow">
                            <h4 className="font-bold text-xs truncate w-32">{ad.title}</h4>
                            <div className="flex items-center gap-2 mt-1">
                                <span className="text-[9px] text-gray-400 font-bold uppercase">{ad.targetValue}</span>
                                <span className="bg-orange-50 text-orange-600 text-[9px] px-2 py-0.5 rounded-full font-black">
                                    📈 {ad.clicks || 0}
                                </span>
                            </div>
                        </div>
                        <button onClick={() => handleDeleteAd(ad.id, ad.imageUrl)} className="text-red-300 hover:text-red-500 p-2">🗑️</button>
                    </div>
                ))}
            </div>
        </div>
    );
};




const ProfilePage = ({ user, t, auth, storage, db,registerPushNotification,appId }) => {
    // --- UI STATES (KEEPING YOUR PROGRESS) ---
    const [showAccount, setShowAccount] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showContact, setShowContact] = useState(false);
    const [showAppInfo, setShowAppInfo] = useState(false);
    const [isChatNotificationOn, setIsChatNotificationOn] = useState(true);
    const [chatMessages, setChatMessages] = useState([]);
    const chatEndRef = useRef(null);
    const navigate = useNavigate();

    // --- INPUT STATES ---
    const [chatInput, setChatInput] = useState('');
    // Initialize with current user data if available
    const [newNickname, setNewNickname] = useState(user?.displayName || '');
    const [newEmail, setNewEmail] = useState(user?.email || '');
    const [newProfilePic, setNewProfilePic] = useState(null);
    
    // --- STATUS STATES ---
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('error');
    // THE ADMIN UID FOR JOSEPH14
    const ADMIN_UID = "K0zYcBiTkfZJ0gNhyytR6w5gvmI3";
    const [flaggedItems, setFlaggedItems] = useState([]);

    // 🟢 ADMIN ONLY: Fetch Flagged Content
    useEffect(() => {
        if (user?.uid === ADMIN_UID && db) {
            const q = query(collection(db, `artifacts/${appId}/listings`), where('status', '==', 'flagged'));
            const unsubscribe = onSnapshot(q, (snap) => {
                setFlaggedItems(snap.docs.map(d => ({id: d.id, ...d.data()})));
            });
            return () => unsubscribe();
        }
    }, [user, db, appId]);

     useEffect(() => {
    window.scrollTo(0, 0);
}, []);

    // 1. SYNC FIX: Fills the boxes when the user logs in, 
    // but doesn't overwrite while you are typing.
    useEffect(() => {
        if (user) {
            if (!newNickname && user.displayName) setNewNickname(user.displayName);
            if (!newEmail && user.email) setNewEmail(user.email);
        }
    }, [user]);

    // 2. SUPPORT CHAT LISTENER (KEEPING YOUR PROGRESS)
    useEffect(() => {
        if (!user || !db) return;
        const q = query(
            collection(db, "support_tickets", user.uid, "messages"),
            orderBy("timestamp", "asc")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedMessages = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setChatMessages(fetchedMessages);
        });
        return () => unsubscribe();
    }, [user, db]);

    // 3. MESSAGE TIMER
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => setMessage(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    // --- THE MASTER UPDATE FUNCTION ---
    const handleUpdateField = async (field) => {
    if (!auth?.currentUser || !db) return;
    setLoading(true);
    setMessage('');

    try {
        if (field === 'nickname') {
            const trimmedName = newNickname.trim();
            await updateProfile(auth.currentUser, { displayName: trimmedName });

            // Unified Path: artifacts/{appId}/users/{uid}
            await setDoc(doc(db, `artifacts/${appId}/users`, auth.currentUser.uid), {
                nickname: trimmedName,
                email: auth.currentUser.email,
                photoURL: auth.currentUser.photoURL || "",
                lastUpdated: serverTimestamp()
            }, { merge: true });

            await auth.currentUser.reload();
            setMessageType('success');
            setMessage("Surnom mis à jour !");
        } 
else if (field === 'profilePic' && newProfilePic) {
            if (!storage) throw new Error("Storage prop missing");
            // 🟢 AI SAFETY CHECK: Scan the profile picture before anything else
            setMessage(t('common.scanning', 'Scanning image safety...')); 
            try {
                const isUnsafe = await analyzeImageSafety(newProfilePic);
                if (isUnsafe) {
                    setMessageType('error');
                    setMessage("Upload rejected: Image violates community safety guidelines.");
                    setLoading(false);
                    setNewProfilePic(null); 
                    return; // 🚨 HARD STOP: Do not upload to Firebase!
                }
            } catch (aiError) {
                console.error("AI Check Failed:", aiError);
            }

            // 🟢 1. Compress the profile picture before uploading
            setMessage(t('common.compressing', 'Compressing image...')); 
            const compressedPic = await compressImage(newProfilePic);

            // 🟢 2. Upload the COMPRESSED image to Firebase
            const storageRef = ref(storage, `users/${auth.currentUser.uid}/profile.jpg`);
            const snapshot = await uploadBytes(storageRef, compressedPic);
            const photoURL = await getDownloadURL(snapshot.ref);
            
            await updateProfile(auth.currentUser, { photoURL });
            
            // Sync to Unified Firestore Path
            await setDoc(doc(db, `artifacts/${appId}/users`, auth.currentUser.uid), { 
                photoURL 
            }, { merge: true });
            
            await auth.currentUser.reload();

            setMessageType('success');
            setMessage("Photo mise à jour !");
            setNewProfilePic(null);
            setTimeout(() => window.location.reload(), 1500);
        }


    } catch (error) {
        console.error("Update Error:", error);
        setMessageType('error');
        setMessage(error.code === 'storage/unauthorized' ? "Accès refusé au stockage." : "Échec de la mise à jour.");
    } finally {
        setLoading(false);
    }
};

   // 2. Add this useEffect to auto-scroll
useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [chatMessages]);

// 3. Update the send function
const handleSendSupportMessage = async () => {
    if (chatInput.trim() && auth.currentUser) {
        const text = chatInput.trim();
        const uid = auth.currentUser.uid;
        setChatInput(''); // Clear input immediately

        try {
            // Update Master Ticket - Matches AdminSupport expectations
            const ticketRef = doc(db, "support_tickets", uid);
            await setDoc(ticketRef, {
                userEmail: auth.currentUser.email,
                userName: auth.currentUser.displayName || 'User',
                lastMessage: text,
                updatedAt: serverTimestamp(),
                unreadByAdmin: true, // IMPORTANT: Admin looks for this field
                status: "open"
            }, { merge: true });

            // Add to sub-collection
            await addDoc(collection(db, "support_tickets", uid, "messages"), {
                senderId: uid,
                senderName: auth.currentUser.displayName || 'User',
                text: text,
                timestamp: serverTimestamp(),
                isAdmin: false
            });
        } catch (error) {
            console.error("Support Error:", error);
            setMessage("Erreur d'envoi.");
        }
    }
};
   const handleRepairNotifications = async () => {
        if (!auth.currentUser) return;

        setLoading(true);
        setMessage('repairing_start'); 
        
        try {
            // BUG 7 FIX: This explicit user click will force the smartphone to ask for Notification Permissions
            const permission = await Notification.requestPermission();
            
            if (permission !== 'granted') {
                setMessageType('error');
                setMessage("Permission denied. Please enable notifications in your phone settings.");
                setLoading(false);
                return;
            }

            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let registration of registrations) {
                await registration.unregister();
            }

            localStorage.removeItem('fcm_token');
            await registerPushNotification();

            setMessageType('success');
            setMessage("connection_repaired"); 
        } catch (error) {
            console.error("Repair failed:", error);
            setMessageType('error');
            setMessage("repair_failed");
        } finally {
            setLoading(false);
        }
    };

// 🟢 Add this to your ProfilePage logic
useEffect(() => {
    // When the user opens the contact section, mark the ticket as read
    if (showContact && user?.uid && db) {
        const markAsRead = async () => {
            try {
                const ticketRef = doc(db, "support_tickets", user.uid);
                await setDoc(ticketRef, { 
                    unreadByUser: false // Clears the notification dot for the user
                }, { merge: true });
            } catch (err) {
                console.error("Error marking as read:", err);
            }
        };
        markAsRead();
    }
}, [showContact, user?.uid, db]);
    
  return (
        <div className="p-4 mb-24 max-w-lg mx-auto font-sans text-gray-800">
            <h2 className="text-2xl font-bold mb-6 text-center">{t('profile.title', 'My Profile')}</h2>
            
            <div className="flex flex-col items-center mb-8">
                <div className="relative">
                    <img 
                        src={user?.photoURL || "https://placehold.co/120x120?text=User"} 
                        alt="Profile" 
                        className="w-28 h-28 rounded-full object-cover border-4 border-blue-500 shadow-xl" 
                    />
                    {loading && (
                        <div className="absolute inset-0 bg-white/40 flex items-center justify-center rounded-full">
                            <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent animate-spin rounded-full"></div>
                        </div>
                    )}
                </div>
                <h3 className="text-xl font-bold mt-4">{user?.displayName || t('profile.default_user', 'User')}</h3>
                <p className="text-sm text-gray-500">{user?.email}</p>
            </div>

            {message && (
                <div className={`p-3 rounded-xl text-white mb-6 text-center font-bold shadow-md transition-all ${messageType === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
                    {/* Translate dynamic messages from handleUpdateField */}
                    {t(`messages.${message}`, message)}
                </div>
            )}

            {/* Account Settings */}
            <div className="border-b py-4 cursor-pointer" onClick={() => setShowAccount(!showAccount)}>
                <h4 className="font-bold flex justify-between items-center">
                    {t('profile.account_settings', 'Account Settings')}
                    <span className={`transition-transform ${showAccount ? 'rotate-180' : ''}`}>▼</span>
                </h4>
            </div>
            {showAccount && (
                <div className="p-4 bg-gray-50 rounded-2xl mt-2 space-y-4 border shadow-inner">
                    <div>
                        <label className="text-xs font-black text-gray-400 uppercase">{t('profile.nickname', 'Nickname')}</label>
                        <div className="flex gap-2 mt-1">
                            <input 
                                type="text" 
                                value={newNickname} 
                                onChange={(e) => setNewNickname(e.target.value)} 
                                className="flex-grow border rounded-xl p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" 
                            />
                            <button onClick={() => handleUpdateField('nickname')} className="bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-bold active:scale-95">
                                {t('common.save', 'Save')}
                            </button>
                        </div>
                    </div>
                    <div>
                        <label className="text-xs font-black text-gray-400 uppercase">{t('profile.email', 'Email')}</label>
                        <div className="flex gap-2 mt-1">
                            <input type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} className="flex-grow border rounded-xl p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none" />
                            <button onClick={() => handleUpdateField('email')} className="bg-blue-600 text-white px-4 py-2 rounded-xl text-sm font-bold active:scale-95">
                                {t('common.save', 'Save')}
                            </button>
                        </div>
                    </div>
                    <div>
                   <label className="text-xs font-black text-gray-400 uppercase">{t('profile.change_photo', 'Change Photo')}</label>
                        <div 
                            className="w-full mt-2 mb-3 border border-gray-300 rounded-lg p-3 text-sm text-gray-500 cursor-pointer hover:bg-gray-100 transition-colors"
                            onClick={async () => {
                                if (Capacitor.isNativePlatform()) {
                                    try {
                                        let perm = await CapacitorCamera.checkPermissions();
                                        if (perm.photos !== 'granted') {
                                            perm = await CapacitorCamera.requestPermissions({ permissions: ['photos'] });
                                        }
                                        if (perm.photos !== 'granted') {
                                            alert(t('profile.gallery_permission_denied', 'Please allow gallery permissions to change your photo.'));
                                            return;
                                        }
                                    } catch (e) { console.error("Permission error", e); }
                                }
                                document.getElementById('profile-pic-input').click();
                            }}
                        >
                            <span className="font-bold text-gray-700 mr-2">📁 Browse...</span>
                            {newProfilePic ? newProfilePic.name : t('profile.select_file', 'Choose an image')}
                            <input id="profile-pic-input" type="file" onChange={(e) => setNewProfilePic(e.target.files[0])} className="hidden" accept="image/*" />
                        </div>
                      <button 
                            onClick={() => handleUpdateField('profilePic')} 
                            disabled={!newProfilePic || loading}
                            className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold disabled:bg-gray-300 shadow-lg active:scale-95"
                        >
                            {loading ? t('common.uploading', 'Uploading...') : t('profile.update_photo', 'Update Photo')}
                        </button>
                    </div>
                </div>
            )}

            {/* Notifications Section */}
            <div className="border-b py-4 cursor-pointer" onClick={() => setShowNotifications(!showNotifications)}>
                <h4 className="font-bold flex justify-between items-center">
                    {t('profile.notifications', 'Notifications')}
                    <span className={`transition-transform ${showNotifications ? 'rotate-180' : ''}`}>▼</span>
                </h4>
            </div>
          {showNotifications && (
    <div className="p-4 bg-gray-50 rounded-2xl mt-2 space-y-4 border">
        <div className="flex justify-between items-center">
            <span className="text-sm font-semibold">{t('profile.chat_alerts', 'Chat Alerts')}</span>
            <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" checked={isChatNotificationOn} onChange={() => setIsChatNotificationOn(!isChatNotificationOn)} className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
            </label>
        </div>

        {/* The Repair Button */}
        <div className="pt-2 border-t border-gray-200">
            <p className="text-[10px] text-gray-400 mb-2 italic">
                {t('profile.notification_help', 'Not receiving alerts? Try repairing the connection.')}
            </p>
            <button 
                onClick={handleRepairNotifications}
                className="text-xs text-blue-600 font-bold hover:underline flex items-center gap-1"
            >
                🔄 {t('profile.repair_button', 'Repair Notifications')}
            </button>
        </div>
    </div>
)}

            {/* 🟢 HIDE SUPPORT SECTION FOR ADMIN EMAIL */}
{user?.email !== "K0zYcBiTkfZJ0gNhyytR6w5gvmI3"&& (
    <div className="border-b py-4 cursor-pointer" onClick={() => setShowContact(!showContact)}>
        <h4 className="font-bold flex justify-between items-center">
            {t('profile.support', 'Help & Support')}
            <span className={`transition-transform ${showContact ? 'rotate-180' : ''}`}>▼</span>
        </h4>
    </div>
)}
            {showContact && (
                <div className="p-4 bg-gray-50 rounded-2xl mt-2 shadow-inner border">
                    <div className="max-h-60 overflow-y-auto mb-4 space-y-3 pr-2 scrollbar-thin">
                        {chatMessages.length === 0 ? (
                            <div className="text-center py-4 text-gray-400 text-xs italic">{t('messages.empty', 'No messages.')}</div>
                        ) : (
    chatMessages.map((msg) => (
                                <div key={msg.id} className={`flex ${msg.isAdmin ? 'justify-start' : 'justify-end'}`}>
                                    <div className={`max-w-[80%] p-3 rounded-2xl text-sm ${msg.isAdmin ? 'bg-white border' : 'bg-blue-500 text-white'}`}>
                                        <p className="text-[10px] opacity-70 font-bold">{msg.isAdmin ? t('profile.support_label', 'Support') : t('profile.me_label', 'Me')}</p>
                                        <p>{msg.text}</p>
                                    </div>
                                </div>
                            ))
                        )}

{/* 🟢 ADD THIS LINE RIGHT HERE */}
<div ref={chatEndRef} />
                    </div>
                    <div className="flex gap-2">
                        <input 
                            type="text" 
                            value={chatInput} 
                            onChange={(e) => setChatInput(e.target.value)} 
                            onKeyPress={(e) => e.key === 'Enter' && handleSendSupportMessage()}
                            placeholder={t('messages.type_here', 'Write here...')} 
                            className="flex-grow border rounded-xl p-3 text-sm focus:ring-2 focus:ring-blue-400 outline-none" 
                        />
                        <button onClick={handleSendSupportMessage} className="bg-green-600 text-white px-4 rounded-xl font-bold active:scale-95">
                            {t('common.send', 'Send')}
                        </button>
                    </div>
                </div>
            )}

            {/* Admin Controls */}
            {user?.uid === ADMIN_UID && (
                <div className="mt-8 p-4 bg-orange-50 border-2 border-orange-200 rounded-2xl">
                    <h4 className="font-black text-orange-700 uppercase text-[10px] mb-2 text-center tracking-widest">Admin Panel</h4>
                    <button 
                        onClick={() => navigate('/admin-ads')} 
                        className="w-full bg-orange-500 text-white py-4 rounded-xl font-black shadow-md active:scale-95 transition-all"
                    >
                        📢 Post Team Ads
                    </button>
                </div>
            )}

           {/* 🚨 MODERATION JAIL - ADMIN ONLY */}
                    {user?.email === 'ininahazweemeryjoseph@gmail.com' && (
                        <details className="mt-4 bg-white rounded-xl overflow-hidden border-2 border-red-200">
                            <summary className="bg-red-50 text-red-600 font-black p-4 cursor-pointer flex justify-between items-center outline-none">
                                <span>🚨 Flagged Content Jail ({flaggedItems.length})</span>
                                <span>▼</span>
                            </summary>
                            <div className="p-2 max-h-80 overflow-y-auto bg-gray-50">
                                {flaggedItems.length === 0 ? (
                                    <p className="text-center text-xs text-gray-400 py-4 font-bold">Platform is clean! ✨</p>
                                ) : (
                                    flaggedItems.map(item => (
                                        <div key={item.id} className="bg-white p-3 rounded-lg border border-red-100 shadow-sm mb-2">
                                            <div className="flex gap-3">
                                                <img src={item.imageUrls?.[0]} className="w-16 h-16 object-cover rounded-md border border-gray-200" alt="Flagged" />
                                                <div className="flex-1">
                                                    <h5 className="text-[12px] font-black text-gray-900 leading-tight">{item.title}</h5>
                                                    <p className="text-[10px] text-gray-500 font-bold mt-1">Seller ID: {item.sellerId.substring(0,8)}...</p>
                                                </div>
                                            </div>
                                            <div className="flex gap-2 mt-3">
                                                <button 
                                                    onClick={async () => {
                                                        if(window.confirm("Permanently delete this dangerous content?")) {
                                                            await deleteDoc(doc(db, `artifacts/${appId}/listings`, item.id));
                                                        }
                                                    }}
                                                    className="flex-1 bg-red-600 text-white text-[10px] font-black py-2 rounded shadow-sm active:scale-95"
                                                >
                                                    🗑️ DELETE
                                                </button>
                                                <button 
                                                    onClick={async () => {
                                                        if(window.confirm("AI made a mistake. Mark as safe and post to feed?")) {
                                                            await updateDoc(doc(db, `artifacts/${appId}/listings`, item.id), { status: 'active' });
                                                        }
                                                    }}
                                                    className="flex-1 bg-green-500 text-white text-[10px] font-black py-2 rounded shadow-sm active:scale-95"
                                                >
                                                    ✅ APPROVE (MISTAKE)
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </details>
                    )}

            {/* 🟢 NEW: "More" Options Menu for Account Deletion */}
            <div className="border-b py-4 cursor-pointer mt-4" onClick={() => setShowAppInfo(!showAppInfo)}>
                <h4 className="font-bold flex justify-between items-center text-gray-600">
                    {t('profile.more_options', 'More')}
                    <span className={`transition-transform ${showAppInfo ? 'rotate-180' : ''}`}>▼</span>
                </h4>
            </div>
            {showAppInfo && (
                <div className="p-4 bg-gray-50 rounded-2xl mt-2 border shadow-inner">
                    <button 
                        onClick={() => {
                            if(window.confirm(t('profile.delete_confirm', 'Are you sure you want to permanently delete your account? All your data will be lost.'))) {
                                deleteDoc(doc(db, `artifacts/${appId}/users`, user.uid))
                                    .then(() => user.delete())
                                    .then(() => alert("Account successfully deleted."))
                                    .catch((error) => {
                                        console.error(error);
                                        alert("For security reasons, please log out and log back in before deleting your account.");
                                    });
                            }
                        }}
                        className="w-full text-left text-red-500 font-bold p-2 text-sm active:bg-red-50 rounded-lg transition-colors"
                    >
                        {t('profile.delete_account', 'Delete My Account')}
                    </button>
                </div>
            )}

            <button 
                onClick={() => signOut(auth)}
                className="w-full bg-red-50 text-red-600 border-2 border-red-100 p-4 rounded-2xl font-black mt-12 active:scale-95 shadow-sm"
            >
                {t('profile.logout', 'LOGOUT')}
            </button>
        </div>
    );
};

// ====================================================================================
// !!! NECESSARY COMPONENT: PROTECTED ROUTE HOC !!!
// ====================================================================================

/**
 * A wrapper component that checks for user authentication.
 * If a user exists, it renders the child element.
 * NOTE: Because the App component already redirects unauthenticated users globally,
 * this component's role is mainly to enforce that the route requires a 'user' prop.
 * If you implement a global redirect (like the one suggested previously), 
 * this component doesn't strictly need a redirect, but we'll include a warning 
 * as a safe fallback.
 */
const ProtectedRoute = ({ children, user }) => {
    // Check if the user object is null or undefined
    if (!user) {
        // Since the top-level App component handles the main redirect to AuthPage,
        // this fallback prevents a crash if the routing somehow bypasses the main check.
        // It should rarely be reached if the App component logic is correct.
        return (
            <div className="flex justify-center items-center h-screen bg-yellow-50">
                <p className="text-lg text-yellow-800 p-4 border border-yellow-300 rounded-lg">
                    Authentication required.
                </p>
            </div>
        );
    }

    return children;
};



const App = () => {
    const { t, i18n } = useTranslation(); 
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // This handles the local state change
    const changeLanguageHandler = async (e) => {
        const newLang = e.target.value;
        i18n.changeLanguage(newLang);

        // Optional: Update Firestore if user is logged in
        if (auth.currentUser) {
            const userRef = doc(db, `artifacts/${appId}/users`, auth.currentUser.uid);
            await setDoc(userRef, { language: newLang }, { merge: true });
        }
    };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        // 1. IMPORTANT: If logging out, reset to a default immediately
        if (!currentUser) {
            setUser(null);
            i18n.changeLanguage('fr'); // Change 'fr' to your preferred default
            setLoading(false);
            return;
        }

        // 2. If someone is logging in, wait to get THEIR specific language
        try {
            const userRef = doc(db, `artifacts/${appId}/users`, currentUser.uid);
            const userSnap = await getDoc(userRef);
            
        if (userSnap.exists()) {
                const userData = userSnap.data();
                if (userData.language) i18n.changeLanguage(userData.language);
            } else {
                // 🟢 Fresh accounts fallback parameters assignment
                i18n.changeLanguage('fr');
                localStorage.setItem('user_country', 'Burundi');
            }
        } catch (error) { console.error("Error setting local landing parameters:", error); }
        
        setUser(currentUser);
        setLoading(false);
    });

    return () => unsubscribe();
}, [appId, i18n]);

   if (loading) return null;
    
    if (!user) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<AuthPage t={t} i18n={i18n} auth={auth} db={db} appId={appId} />} /> 
                </Routes>
            </BrowserRouter>
        );
    }
    
    return (
        <BrowserRouter>
            <AppLayout 
                user={user} 
                db={db} 
                appId={appId} 
                t={t} 
                i18n={i18n} 
                changeLanguageHandler={changeLanguageHandler} 
                auth={auth} 
                storage={storage} 
            />
        </BrowserRouter>
    );
};

const formatPrice = (amount, country = 'Burundi') => {
    if (!amount) return "---";
    const c = country?.toLowerCase() || 'burundi';

    // 1. Manual check for Burundi (since 'FBu' is your custom display)
    if (c.includes('burundi')) {
        return `${amount.toLocaleString()} FBu`;
    }

    const countryToCurrency = {
    'afghanistan': 'AFN', 'albania': 'ALL', 'algeria': 'DZD', 'andorra': 'EUR', 'angola': 'AOA', 'argentina': 'ARS', 'armenia': 'AMD', 'australia': 'AUD', 'austria': 'EUR', 'azerbaijan': 'AZN',
    'bahamas': 'BSD', 'bahrain': 'BHD', 'bangladesh': 'BDT', 'barbados': 'BBD', 'belarus': 'BYN', 'belgium': 'EUR', 'belize': 'BZD', 'benin': 'XOF', 'bhutan': 'BTN', 'bolivia': 'BOB',
    'bosnia': 'BAM', 'botswana': 'BWP', 'brazil': 'BRL', 'brunei': 'BND', 'bulgaria': 'BGN', 'burkina faso': 'XOF', 'burundi': 'BIF', 'cambodia': 'KHR', 'cameroon': 'XAF', 'canada': 'CAD',
    'cape verde': 'CVE', 'central african republic': 'XAF', 'chad': 'XAF', 'chile': 'CLP', 'china': 'CNY', 'colombia': 'COP', 'comoros': 'KMF', 'congo': 'XAF', 'costa rica': 'CRC', 'croatia': 'EUR',
    'cuba': 'CUP', 'cyprus': 'EUR', 'czech republic': 'CZK', 'denmark': 'DKK', 'djibouti': 'DJF', 'dominica': 'XCD', 'dominican republic': 'DOP', 'ecuador': 'USD', 'egypt': 'EGP', 'el salvador': 'USD',
    'equatorial guinea': 'XAF', 'eritrea': 'ERN', 'estonia': 'EUR', 'eswatini': 'SZL', 'ethiopia': 'ETB', 'fiji': 'FJD', 'finland': 'EUR', 'france': 'EUR', 'gabon': 'XAF', 'gambia': 'GMD',
    'georgia': 'GEL', 'germany': 'EUR', 'ghana': 'GHS', 'greece': 'EUR', 'grenada': 'XCD', 'guatemala': 'GTQ', 'guinea': 'GNF', 'guinea-bissau': 'XOF', 'guyana': 'GYD', 'haiti': 'HTG',
    'honduras': 'HNL', 'hungary': 'HUF', 'iceland': 'ISK', 'india': 'INR', 'indonesia': 'IDR', 'iran': 'IRR', 'iraq': 'IQD', 'ireland': 'EUR', 'israel': 'ILS', 'italy': 'EUR',
    'jamaica': 'JMD', 'japan': 'JPY', 'jordan': 'JOD', 'kazakhstan': 'KZT', 'kenya': 'KES', 'kiribati': 'AUD', 'korea': 'KRW', 'sud': 'KRW', 'corée': 'KRW', 'kuwait': 'KWD',
    'kyrgyzstan': 'KGS', 'laos': 'LAK', 'latvia': 'EUR', 'lebanon': 'LBP', 'lesotho': 'LSL', 'liberia': 'LRD', 'libya': 'LYD', 'liechtenstein': 'CHF', 'lithuania': 'EUR', 'luxembourg': 'EUR',
    'madagascar': 'MGA', 'malawi': 'MWK', 'malaysia': 'MYR', 'maldives': 'MVR', 'mali': 'XOF', 'malta': 'EUR', 'marshall islands': 'USD', 'mauritania': 'MRU', 'mauritius': 'MUR', 'mexico': 'MXN',
    'micronesia': 'USD', 'moldova': 'MDL', 'monaco': 'EUR', 'mongolia': 'MNT', 'montenegro': 'EUR', 'morocco': 'MAD', 'mozambique': 'MZN', 'myanmar': 'MMK', 'namibia': 'NAD', 'nauru': 'AUD',
    'nepal': 'NPR', 'netherlands': 'EUR', 'new zealand': 'NZD', 'nicaragua': 'NIO', 'niger': 'XOF', 'nigeria': 'NGN', 'north macedonia': 'MKD', 'norway': 'NOK', 'oman': 'OMR', 'pakistan': 'PKR',
    'palau': 'USD', 'palestine': 'ILS', 'panama': 'PAB', 'papua new guinea': 'PGK', 'paraguay': 'PYG', 'peru': 'PEN', 'philippines': 'PHP', 'poland': 'PLN', 'portugal': 'EUR', 'qatar': 'QAR',
    'romania': 'RON', 'russia': 'RUB', 'rwanda': 'RWF', 'saint kitts': 'XCD', 'saint lucia': 'XCD', 'saint vincent': 'XCD', 'samoa': 'WST', 'san marino': 'EUR', 'sao tome': 'STN', 'saudi arabia': 'SAR',
    'senegal': 'XOF', 'serbia': 'RSD', 'seychelles': 'SCR', 'sierra leone': 'SLL', 'singapore': 'SGD', 'slovakia': 'EUR', 'slovenia': 'EUR', 'solomon islands': 'SBD', 'somalia': 'SOS', 'south africa': 'ZAR',
    'south sudan': 'SSP', 'spain': 'EUR', 'sri lanka': 'LKR', 'sudan': 'SDG', 'suriname': 'SRD', 'sweden': 'SEK', 'switzerland': 'CHF', 'syria': 'SYP', 'taiwan': 'TWD', 'tajikistan': 'TJS',
    'tanzania': 'TZS', 'thailand': 'THB', 'timor-leste': 'USD', 'togo': 'XOF', 'tonga': 'TOP', 'trinidad': 'TTD', 'tunisia': 'TND', 'turkey': 'TRY', 'turkmenistan': 'TMT', 'tuvalu': 'AUD',
    'uganda': 'UGX', 'ukraine': 'UAH', 'uae': 'AED', 'united arab emirates': 'AED', 'uk': 'GBP', 'united kingdom': 'GBP', 'usa': 'USD', 'united states': 'USD', 'uruguay': 'UYU', 'uzbekistan': 'UZS',
    'vanuatu': 'VUV', 'vatican': 'EUR', 'venezuela': 'VES', 'vietnam': 'VND', 'yemen': 'YER', 'zambia': 'ZMW', 'zimbabwe': 'ZWL'
};

    // 3. Find the matching code or default to USD
    const currencyCode = Object.keys(countryToCurrency).find(key => c.includes(key)) 
        ? countryToCurrency[Object.keys(countryToCurrency).find(key => c.includes(key))] 
        : 'USD';

    // 4. Use the Intl API to format automatically
    try {
        return new Intl.NumberFormat(currencyCode === 'KRW' ? 'ko-KR' : 'en-US', {
            style: 'currency',
            currency: currencyCode,
            maximumFractionDigits: 0,
        }).format(amount);
    } catch (e) {
        // Ultimate fallback
        return `$${amount.toLocaleString()}`;
    }
};


const AppLayout = ({ user, db, appId, t, i18n, changeLanguageHandler, auth, storage }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [countryName, setCountryName] = useState(localStorage.getItem('user_country') || "");
    const [userLocation, setUserLocation] = useState({ lat: -3.3822, lon: 29.3644, name: 'Bujumbura' });
    const [syncStatus, setSyncStatus] = useState("Syncing...");

    const ADMIN_UID = "K0zYcBiTkfZJ0gNhyytR6w5gvmI3";
    const [hasSupportReply, setHasSupportReply] = useState(false);
    const [adminNotifyCount, setAdminNotifyCount] = useState(0);    
    const hasSynced = useRef(false);

    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const [countrySearchText, setCountrySearchText] = useState("");
    const globalCountries = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
        "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
        "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
        "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
        "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary",
        "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyzstan",
        "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar",
        "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Sweden", "Switzerland", "Syria",
        "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    useEffect(() => {
        const syncPush = async () => {
            if (user && db && appId && !hasSynced.current) {
                hasSynced.current = true; 
                const success = await NotificationService.setup(user, db, app, appId);
                if (success) setSyncStatus("✅");
                else { setSyncStatus("❌"); hasSynced.current = false; }
            }
        };
        syncPush();
    }, [user?.uid, db, appId]); 

 useEffect(() => {
        let handler;
        const setupListener = async () => {
            handler = await CapApp.addListener('backButton', ({ canGoBack }) => {
                // 1. SMART CHECK: Is the Country Modal open? Close it!
                if (document.getElementById('global-location-modal')) {
                    window.dispatchEvent(new Event('closeLocationModal'));
                    return;
                }

                // 2. SMART CHECK: Is the Map View open? Close it!
                if (document.getElementById('map-view-container')) {
                    window.dispatchEvent(new Event('closeMapView'));
                    return;
                }

                // 3. Normal Navigation Logic
                const currentPath = window.location.pathname;
                const subTabs = ['/messages', '/my-shop', '/profile', '/notifications', '/add-listing', '/search'];
                
                if (currentPath === '/') {
                    CapApp.exitApp();
                } else if (subTabs.includes(currentPath)) {
                    navigate('/', { replace: true });
                } else if (canGoBack) {
                    window.history.back();
                } else {
                    navigate('/', { replace: true });
                }
            });
        };
        setupListener();
        return () => { if (handler && typeof handler.remove === 'function') handler.remove(); };
    }, [navigate]);

    // 🟢 Catch the event to close the modal inside AppLayout
    useEffect(() => {
        const closeModal = () => setIsLocationModalOpen(false);
        window.addEventListener('closeLocationModal', closeModal);
        return () => window.removeEventListener('closeLocationModal', closeModal);
    }, []);

    useEffect(() => {
        const failsafe = setTimeout(() => setIsLoading(false), 3000);
        if (!countryName) {
            const fetchSilentLocation = async () => {
                try {
                    const res = await fetch('https://ipapi.co/json/');
                    const data = await res.json();
                    if (data.country_name) {
                        setCountryName(data.country_name);
                        if (data.city) setUserLocation(prev => ({ ...prev, name: data.city }));
                    } else setCountryName("Burundi"); 
                } catch (e) {
                    setCountryName("Burundi");
                } finally { setIsLoading(false); }
            };
            fetchSilentLocation();
        } else {
            const quickHide = setTimeout(() => setIsLoading(false), 800);
            return () => clearTimeout(quickHide);
        }
        return () => clearTimeout(failsafe);
    }, [countryName]);

    useEffect(() => {
        if (user?.uid !== ADMIN_UID || !db) return;
        const q = query(collection(db, "support_tickets"), where("unreadByAdmin", "==", true));
        const unsubscribe = onSnapshot(q, (snapshot) => setAdminNotifyCount(snapshot.size));
        return () => unsubscribe();
    }, [user?.uid, db]);

    useEffect(() => {
        if (!user?.uid || user.uid === ADMIN_UID || !db) return;
        const unsubscribe = onSnapshot(doc(db, "support_tickets", user.uid), (docSnap) => {
            if (docSnap.exists()) setHasSupportReply(docSnap.data().unreadByUser === true);
        });
        return () => unsubscribe();
    }, [user?.uid, db]);

    const notifyInterestedUsers = async (newProduct) => {
        try {
            const interestsRef = collectionGroup(db, 'interests');
            const q = query(interestsRef, where('category', '==', newProduct.category));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach(async (interestDoc) => {
                const userId = interestDoc.ref.parent.parent.id; 
                if (userId === user.uid) return;

                await addDoc(collection(db, `artifacts/${appId}/notifications`), {
                    recipientId: userId,
                    type: 'suggestion',
                    message: `A new ${newProduct.title} was just posted in ${newProduct.category}!`,
                    link: `/product/${newProduct.id}`,
                    image: newProduct.imageUrl || newProduct.imageUrls?.[0] || "",
                    seen: false,
                    createdAt: serverTimestamp()
                });
            });
        } catch (err) {}
    };

    useEffect(() => {
        const scrollKey = `madili_scroll_${user?.uid || 'guest'}`;
        sessionStorage.removeItem(scrollKey);
        window.scrollTo(0, 0);
    }, [user?.uid]); 

    const isProductDetail = location.pathname.startsWith('/product/');
    const isChat = location.pathname.includes('/messages/') && location.pathname !== '/messages';
    const isAdminPage = location.pathname === '/admin-support';
    const isSearchPage = location.pathname === '/search' || location.pathname === '/search/results';
    const shouldHideNav = isProductDetail || isChat || isAdminPage || isSearchPage;

    if (isLoading) {
        return (
            <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-[9999]">
                <style>{`@keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } } .animate-fade-in { animation: fadeIn 0.8s ease-out forwards; }`}</style>
                <img src="/assets/splash.png" alt="Madili" className="w-32 h-auto animate-fade-in animate-pulse" onError={(e) => { e.target.src = 'https://via.placeholder.com/150?text=Madili'; }} />
            </div>
        );
    }

   return (
        <div className={`min-h-screen bg-gray-50 ${!shouldHideNav ? 'pb-20' : ''}`}> 
            {!shouldHideNav && <BottomNavBar user={user} db={db} appId={appId} t={t} hasSupportReply={hasSupportReply} />} 

            {user?.uid === ADMIN_UID && !isAdminPage && (
                <button onClick={() => navigate('/admin-support')} className="fixed bottom-24 right-6 bg-red-600 text-white p-4 rounded-full shadow-2xl z-50 font-bold active:scale-90 transition-transform flex items-center gap-2">
                    <span>📢</span> {t('admin.inbox', 'Admin Inbox')}
                    {adminNotifyCount > 0 && (<span className="bg-white text-red-600 px-2 py-0.5 rounded-full text-xs animate-bounce">{adminNotifyCount}</span>)}
                </button>
            )}

            {/* 🟢 GLOBAL COUNTRY SELECTOR MODAL WITH ORANGE GPS BUTTON */}
           {isLocationModalOpen && (
                <div id="global-location-modal" className="fixed inset-0 z-[2000] bg-white flex flex-col animate-in slide-in-from-bottom-4 duration-200">
           <div className="p-4 flex items-center gap-3 bg-white sticky top-0 shadow-sm z-10">
                        <button onClick={() => { setIsLocationModalOpen(false); setCountrySearchText(""); }} className="p-1 active:scale-90">
                            <ArrowLeft size={24} className="text-gray-700" />
                        </button>
                        <div className="flex-grow bg-gray-100 rounded-xl px-4 py-2.5 flex items-center border border-gray-200">
                            <Search size={18} className="text-gray-400 mr-2 shrink-0" />
                            <input 
                                type="text" 
                                autoFocus
                                placeholder={t('common.search', 'Search country...')}
                                value={countrySearchText}
                                onChange={(e) => setCountrySearchText(e.target.value)}
                                className="bg-transparent text-[15px] w-full outline-none text-gray-800 font-medium"
                            />
  {countrySearchText && <X size={16} className="text-gray-400 ml-2 cursor-pointer" onClick={() => setCountrySearchText('')} />}
                            
                            {/* 🟢 FIXED: ORANGE LOCATE ME BUTTON (Uses setIsLoading) */}
                            <button 
                                onClick={() => {
                                    setIsLocationModalOpen(false);
                                    if (navigator.geolocation) {
                                        setIsLoading(true); 
                                        navigator.geolocation.getCurrentPosition(async (position) => {
                                            const { latitude, longitude } = position.coords;
                                            localStorage.setItem('true_physical_lat', latitude.toString());
localStorage.setItem('true_physical_lon', longitude.toString());
                                            try {
                                                const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18`);
                                                const data = await res.json();
                                                const detectedCountry = data.address?.country || 'Burundi';
                                                const realName = data.address?.suburb || data.address?.city || data.address?.town || detectedCountry;
                                                
                                                if (typeof setCountryName === 'function') setCountryName(detectedCountry);
                                                localStorage.setItem('user_country', detectedCountry);
                                                
                                                const finalLoc = { lat: latitude, lon: longitude, name: realName, _forceMove: Date.now() };
                                                if (typeof setUserLocation === 'function') setUserLocation(finalLoc);

                                               if (user?.uid && db) {
    const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
   let trueRadius = 3; // 🟢 Default to 3km instead of 10
const snap = await getDoc(userRef);
if (snap.exists()) {
    const data = snap.data();
    // 🟢 Pull from the secure backup, or fallback if the backup doesn't exist yet
    trueRadius = data.savedLocalRadius || (data.preferredRadius < 11 ? data.preferredRadius : 3);
}

await setDoc(userRef, { 
    location: finalLoc, 
    country: detectedCountry, 
    preferredRadius: trueRadius, 
    lastLocationUpdate: serverTimestamp() 
}, { merge: true });
}
                                            } catch (e) { console.error(e); }
                                            finally { setIsLoading(false); } 
                                        }, () => setIsLoading(false), { enableHighAccuracy: true });
                                    }
                                }}
                                className="ml-2 bg-orange-100 p-1.5 rounded-full text-orange-600 active:scale-90 transition-transform shadow-sm border border-orange-200 flex-shrink-0"
                            >
                                <Navigation size={16} />
                            </button>
                        </div>
                    </div>

                    <div className="flex-grow overflow-y-auto bg-gray-50 pb-20">
                       {!countrySearchText && (
    <div 
        className="p-4 bg-white mb-2 border-b cursor-pointer active:bg-orange-50 transition-colors"
        onClick={async () => {
            setIsLocationModalOpen(false);
            localStorage.setItem('is_visitor_mode', 'false');
            
            if (user?.uid && db) {
                const userRef = doc(db, `artifacts/${appId}/users`, user.uid);
            let trueRadius = 3; 
const snap = await getDoc(userRef);
if (snap.exists()) {
    const data = snap.data();
    trueRadius = data.savedLocalRadius || (data.preferredRadius < 11 ? data.preferredRadius : 3);
}

await setDoc(userRef, { preferredRadius: trueRadius }, { merge: true });
            }
        }}
    >
        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Current Location</p>
        <div className="flex items-center gap-3 text-orange-600 font-bold">
            <Navigation size={18} />
            <span>{userLocation?.name || 'Locating...'}</span>
        </div>
    </div>
)}

                        <div className="bg-white">
                            {!countrySearchText && <p className="px-4 pt-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">All Countries</p>}
                            {globalCountries
                                .filter(c => c.toLowerCase().includes(countrySearchText.toLowerCase()))
                                .map((country, idx) => (
                                    <div 
                                        key={country} 
                                        onClick={async () => {
                                            setIsLoading(true); // 🟢 FIXED: Uses setIsLoading so it doesn't crash!
                                        
                                            if (typeof setCountryName === 'function') setCountryName(country);
                                            
                                            if (typeof setUserLocation === 'function') setUserLocation({ lat: 0, lon: 0, name: country, _forceMove: Date.now() }); 
                                            localStorage.setItem('user_country', country);
                                            setIsLocationModalOpen(false);
                                            setCountrySearchText("");

                                            try {
                                                const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&country=${country}`);
                                                const data = await res.json();
                                                if (data && data[0]) {
                                                    const newLoc = {
                                                        lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon), name: country, _forceMove: Date.now()
                                                    };
                                                    if (typeof setUserLocation === 'function') setUserLocation(newLoc);
                                                    
                                                    if (user?.uid && db) {
                                                        const userDocRef = doc(db, `artifacts/${appId}/users`, user.uid);
                                                        await setDoc(userDocRef, { location: newLoc, country: country, preferredRadius: 11, lastLocationUpdate: serverTimestamp() }, { merge: true });
                                                    }
                                                }
                                            } catch (e) {
                                                console.error(e);
                                            } finally {
                                                setIsLoading(false); // 🟢 STOPS THE SPINNER safely
                                            }
                                        }}
                                        className={`p-4 border-b border-gray-50 text-[15px] font-semibold text-gray-700 active:bg-orange-50 transition-colors flex justify-between items-center cursor-pointer ${idx === 0 ? 'border-t mt-2' : ''}`}
                                    >
                                        <span>{country}</span>
                                        {countryName === country && <Check size={18} className="text-orange-500" />}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            )}

            <Routes>
                <Route path="/" element={<ListingsPage user={user} db={db} appId={appId} t={t} i18n={i18n} isLoading={isLoading} setIsLoading={setIsLoading} changeLanguageHandler={changeLanguageHandler} formatTimeAgo={formatTimeAgo} ImageSwiper={ImageSwiper} userLocation={userLocation} setUserLocation={setUserLocation} countryName={countryName} setCountryName={setCountryName} formatPrice={formatPrice} setIsLocationModalOpen={setIsLocationModalOpen} />} />
                <Route path="/search" element={<SearchScreen t={t} user={user} />} />
                <Route path="/search/results" element={<SearchResultsPage db={db} appId={appId} t={t} user={user} ImageSwiper={ImageSwiper} formatTimeAgo={formatTimeAgo} countryName={countryName} formatPrice={formatPrice} />} />
                <Route path="/product/:id" element={<ProtectedRoute user={user}><ProductDetailPage db={db} appId={appId} t={t} user={user} ImageSwiper={ImageSwiper} formatTimeAgo={formatTimeAgo} countryName={countryName} formatPrice={formatPrice} /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute user={user}><NotificationPage user={user} db={db} appId={appId} t={t} /></ProtectedRoute>} />
                <Route path="/messages" element={<ProtectedRoute user={user}><MessagesPage user={user} db={db} appId={appId} t={t} i18n={i18n} countryName={countryName} formatPrice={formatPrice}/></ProtectedRoute>} />
                <Route path="/messages/:chatId" element={<ProtectedRoute user={user}><ChatWindowPage user={user} db={db} appId={appId} t={t} storage={storage} /></ProtectedRoute>} />
                <Route path="/my-shop" element={<ProtectedRoute user={user}><MyShopPage user={user} db={db} appId={appId} t={t} i18n={i18n} countryName={countryName} formatPrice={formatPrice}/></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute user={user}><ProfilePage user={user} db={db} appId={appId} t={t} auth={auth} storage={storage} registerPushNotification={() => NotificationService.setup(user, db, app)} /></ProtectedRoute>} />
                <Route path="/admin-ads" element={<ProtectedRoute user={user}>{user?.uid === ADMIN_UID ? (<AdminAdsPage t={t} db={db} storage={storage} user={user} ADMIN_UID={ADMIN_UID} appId={appId} />) : (<Navigate to="/" />)}</ProtectedRoute>} />
                <Route path="/add-listing" element={<ProtectedRoute user={user}><AddProductPage user={user} db={db} appId={appId} storage={storage} t={t} i18n={i18n} onProductAdded={notifyInterestedUsers} userLocation={userLocation} countryName={countryName} /></ProtectedRoute>} />
                <Route path="/admin-support" element={user?.uid === "K0zYcBiTkfZJ0gNhyytR6w5gvmI3" ? <AdminSupport db={db} auth={auth} /> : <Navigate to="/" />} />
                <Route path="*" element={<div className="p-10 text-center text-xl text-red-500 font-bold">404: Page Not Found</div>} />
            </Routes>
        </div>
    );
};

export default App;
